/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: ' + 769 + 'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme (' + theme.settings.themeVersion + ') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 2;

(function () {
  'use strict';

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces) // save the namespaces on the DOM element itself
        this.namespaces = {};

      // Store callbacks as an array per namespace key. The previous single-callback
      // storage (this.namespaces[event] = callback) silently leaked listeners whenever
      // the same namespace was bound twice: the namespaces map was overwritten with
      // the new callback but the old native listener stayed attached and unreachable
      // forever. With an array, off() can iterate and remove every registered handler
      // for that namespace. For window/document this also means all namespaces share
      // a single map (this === window) so collisions across components must use
      // distinct namespace suffixes — already the existing convention.
      if (!this.namespaces[event]) this.namespaces[event] = [];
      this.namespaces[event].push(callback);
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces || !this.namespaces[event]) return this;
      var nativeType = event.split('.')[0];
      var callbacks = this.namespaces[event];
      for (var i = 0; i < callbacks.length; i++) {
        this.removeEventListener(nativeType, callbacks[i]);
      }
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },

    // Category mutual exclusion, shared by theme.Collection (desktop) and theme.CollectionSidebar
    // (mobile): choosing a value under one main category unchecks every value under the other main
    // categories, on BOTH sides (C-8: after any input event the desktop and mobile checked sets are
    // equal). Each value goes through theme.setFacetChecked, which unchecks every copy of the facet
    // (the desktop input or inputs and every mobile twin, found by comparison: C-7, never by a
    // selector built from the value, which is catalogue data) and clears the "All" box of each copy's
    // group on both sides. Before, only the side the event came from was cleared, plus the first
    // desktop input when it came from the mobile drawer, so a desktop choice left the other
    // category's mobile twins and "All" boxes checked.
    clearOtherMainCategory: function (currentCategory, container) {
      var parent = currentCategory.parentElement;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling !== currentCategory && sibling.hasAttribute('data-category-main')) {
          // The "All" boxes are left out on purpose: they are no facet, and setFacetChecked
          // clears them through the rows of their groups.
          sibling.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(function (item) {
            // A desktop row carries name/value and a mobile twin data-name/data-value (no name at
            // all), so the facet is read from whichever pair the input has.
            var named = item.hasAttribute('name')
            theme.setFacetChecked(container, item.getAttribute(named ? 'name' : 'data-name'), item.getAttribute(named ? 'value' : 'data-value'), false)
          })
        }
      });
    },

    prepareTransition: function (el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    decodeString: function (encodedString) {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = encodedString;
      return textarea.value;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
        /**
         * On the last focusable element and tab forward,
         * wrap back to the first element. Without this branch the focus
         * trap is one-directional and forward-Tab can escape drawers/modals.
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - The exact-or-whole display formatter (Phase B, B2): formats an amount in minor units
   *   (cents) with the active money format, with no thousands grouping, no rounding, and decimals only when
   *   the amount has cents. It is the same algorithm as snippets/price-module.liquid, so both print identical
   *   text. Callers print the result as is. A bad input (not integer cents) returns ''.
   * - savingsPercent - The one savings-% rule (Phase B, B8): rounded, then floored to a 5 % step, shown from
   *   10 %; null when no saving should be shown. The twin of snippets/savings-percent.liquid.
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';

    // The single JS money formatter (Phase B price contract, spec §2 B2). It is the same algorithm as
    // snippets/price-module.liquid, run on the same money-format string, so both print identical text.
    // Input boundary (final gate): that holds for a format with exactly one well-formed placeholder, a word in
    // double braces, as Shopify's money formats are. A malformed or repeated token is outside the contract: this
    // matches the first well-formed token and price-module splits the format at the braces, so the two may then
    // print different text.
    // Exact-or-whole: no thousands grouping (owner rule S1); no decimals when the amount is whole, two
    // decimals when it has cents (display = charge, S9). It never rounds and never converts: amounts are
    // already in the presentment currency (G15). Callers print the result as is: never edit its punctuation.
    // The placeholders whose Shopify definition uses a '.' decimal mark; every other one (amount_no_decimals
    // included, owner decision O-B1) uses ','. Keep this list identical to price-module's `when` list.
    var DOT_DECIMAL_PLACEHOLDERS = ['amount', 'amount_with_period_and_space_separator', 'amount_with_apostrophe_separator'];

    function formatMoney(cents, format) {
      var formatString = format || theme.settings.moneyFormat || moneyFormat;
      var amount;
      if (typeof cents === 'string') {
        // A string must be integer cents. Anything else returns '' so a bad input is never shown as a price.
        if (!/^\s*-?\d+\s*$/.test(cents)) return '';
        amount = parseInt(cents, 10);
      } else if (typeof cents === 'number' && Number.isInteger(cents)) {
        // Exact minor units only: a non-integer is a caller bug, so it is not rounded into a plausible price (plan gate).
        amount = cents;
      } else {
        return '';
      }

      // The sign is kept apart and the arithmetic runs on the absolute value: JS % keeps the sign
      // (-150 % 100 = -50), so a signed remainder would print the cents wrong (design gate, 2026-10-18).
      var sign = amount < 0 ? '-' : '';
      var abs = Math.abs(amount);
      var units = Math.floor(abs / 100);
      var rest = abs % 100;

      // Affix and placeholder from the format, e.g. "€" + amount_with_comma_separator + "". The affixes are
      // not trimmed ("CHF " keeps its space). A format without a placeholder prints the number alone, as
      // price-module does.
      var match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      var prefix = match ? formatString.slice(0, match.index) : '';
      var suffix = match ? formatString.slice(match.index + match[0].length) : '';
      var name = match ? match[1] : '';
      var decimalMark = DOT_DECIMAL_PLACEHOLDERS.indexOf(name) > -1 ? '.' : ',';

      var number = String(units);
      if (rest > 0) {
        number += decimalMark + (rest < 10 ? '0' : '') + rest;
      }
      return sign + prefix + number + suffix;
    }

    // One savings-% rule, the same as snippets/savings-percent.liquid (Phase B8, owner decision O-B3): the
    // saving rounded to a whole percent first, then floored to a 5 % step (9.6 % shows 10 %, 14.6 % shows
    // 15 %), shown only from 10 %. Returns null when no saving should be shown. It divides only for a real
    // sale (compareAt > price and compareAt > 0), so a missing compare-at (null) never reaches the division (B9).
    function savingsPercent(compareAt, price) {
      if (!(compareAt > price) || !(compareAt > 0)) return null;
      var pct = Math.round(((compareAt - price) * 100) / compareAt);
      pct = pct - (pct % 5);
      return pct >= 10 ? pct : null;
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      savingsPercent: savingsPercent,
      getBaseUnit: getBaseUnit
    }
  })();

  theme.Images = (function () {

    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    // Inserts a {width} placeholder into a Shopify CDN image URL
    // so lazysizes can substitute the actual width at runtime.
    // Uses the modern query-param format (?width={width}) instead of
    // the deprecated filename format (_{width}x).
    function lazyloadImagePath(string) {
      if (string == null) return string;

      // If URL already has query params, append &width={width}
      // Otherwise, add ?width={width}
      var separator = string.indexOf('?') !== -1 ? '&' : '?';
      return string + separator + 'width={width}';
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();

  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }

    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
            // After the only target fires, drop the observer entirely so it can
            // be garbage-collected. Without disconnect() it lives on as long as
            // any closure references it — small per-call leak but adds up on
            // long browsing sessions (Recommendations / RecentlyViewed / Video).
            observer.disconnect();
          }
        }
      });
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' });

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function () {

    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {

      _getCurrentOptions: function () {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function (key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function (variant) {
        return this._getCurrentOptions().reduce((count, { value, index }) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        }, 0)
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({ value, index }) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function (lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({ value, index }) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({ value, index }) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function (lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }

      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
          } else {
            input.value = variant[index];
          }
        }
      },

      _onSelectChange: function ({ srcElement }) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
        // variant is null when the selected option combo has no matching
        // variant — the change events below must STILL dispatch (the
        // unavailable-state UI relies on them), so only the price toggling
        // is skipped instead of letting variant.price throw here.
        // Both label loops below search this product's section (this.container, the [data-section-type="product"]
        // element of snippets/product-template.liquid), never the document. It holds both pickers, the size list and
        // the #OptionDrawer size drawer, and no theme code moves them out of it. With a second product section on the
        // page (a quick-shop load), a document-wide search let a size change in one product rewrite the other's
        // labels (final gate).
        const option1Selector = this.container.querySelectorAll('.variant-input-wrap[data-index="option1"] .option--item')
        if (variant && option1Selector.length > 0) {
          // B: no theme rounding; labels and taps compare exact presentment amounts. data-price is the size's exact
          // variant.price (snippets/variant-dropdown.liquid and variant-drawer.liquid, Phase B Task 7).
          const price = variant.price
          option1Selector.forEach(el => {
            const priceEl = el.querySelector('.price--identifier')
            if (priceEl) {
              const priceFromEl = parseInt(priceEl.dataset.price)

              if (price == priceFromEl) {
                if (!priceEl.classList.contains('v-hidden')) priceEl.classList.add('v-hidden')
              }
              else {
                if (priceEl.classList.contains('v-hidden')) priceEl.classList.remove('v-hidden')
              }
            }
          })
        }

        const option1SelectorDesktop = this.container.querySelectorAll('.btn--option')
        if (variant && option1SelectorDesktop.length > 0) {
          // B: no theme rounding; labels and taps compare exact presentment amounts (as above).
          const price = variant.price

          option1SelectorDesktop.forEach(el => {
            const priceEl = el.querySelector('.price--identifier')
            if (priceEl) {
              const priceFromEl = parseInt(priceEl.dataset.price)

              if (price == priceFromEl) {
                if (!priceEl.classList.contains('v-hidden')) priceEl.classList.add('v-hidden')
              }
              else {
                if (priceEl.classList.contains('v-hidden')) priceEl.classList.remove('v-hidden')
              }
            }
          })
        }

        this.container.dispatchEvent(new CustomEvent('variantChange', { detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant && this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updatePrice: function (variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateUnitPrice: function (variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateSKU: function (variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      _updateMasterSelect: function (variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false);
        }

        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1);
        } else {
          this.videoPlayer.setVolume(0);
        }

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        this.parent.classList.add(classes.interactable); // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }

      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return YouTube;
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })

    document.body.addEventListener('touchmove', function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();

  // Prevent vertical scroll while using Swiper sliders
  (function () {
    var isSwiping = false;
    var startPos;
    var dragThreshold = 10; // pixels to move before preventing scroll

    document.body.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.swiper-wrapper')) {
        isSwiping = false;
        return;
      }
      isSwiping = true;
      startPos = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });

    document.body.addEventListener('touchmove', function (e) {
      if (isSwiping && e.cancelable) {
        var delta = {
          x: e.touches[0].pageX - startPos.x,
          y: e.touches[0].pageY - startPos.y
        };
        // If horizontal movement exceeds threshold, prevent vertical scroll
        if (Math.abs(delta.x) > dragThreshold && Math.abs(delta.x) > Math.abs(delta.y)) {
          e.preventDefault();
        }
      }
    }, { passive: false });
  })();

  /**
   * enforceSearchScope — the ONE authority for the search gender scope.
   * -----------------------------------------------------------------------------
   * Shared by every query builder that can produce a search-page fetch or
   * history URL (theme.buildFilterQuery's last step, which the count fetch in
   * getFilterUpdates and the grid fetch in theme.Collection._runGridFetch go
   * through, and the popped params inside AjaxRenderer.renderPage that a
   * Back/Forward render uses). The search gender is a MODE, not a user-facing facet, so
   * it must survive EVERY rebuilt URL — this function is the single place
   * that guarantees it.
   *
   * Two hazards it closes, neither of which any single call site handled alone:
   *   1. Shopify omits zero-result facets, so the gender checkbox can be absent
   *      from the DOM the params are built from — the scope would silently
   *      vanish, unscoping the search (cross-gender leak).
   *   2. A URL-copied `filter.p.tag=women` can be STALE after a toggle flip to
   *      men — appending men without removing women makes Shopify OR the two
   *      (BOTH genders show). We must strip the conflicting gender value.
   *
   * The hidden [data-gender-search-filter] input (owned by gender-context.js;
   * disabled = unscoped) is the single source of truth and always wins. Gender
   * values are recognised in any case and written in the store's case ('Men' /
   * 'Women', from theme.genderScopeTags; lead ruling #63). Every
   * NON-gender filter.p.tag value is kept as it is: spec 4.1 step 2 keeps it an
   * ordinary, removable facet. It does NOT combine safely with the scope:
   * Shopify ORs the values of one filter (gotcha G25), so a scoped search that
   * also carries a non-gender tag returns that tag's products of BOTH genders.
   * No UI produces one today: the store's tag group holds only Men/Women and is
   * hidden by design. A visible tag facet needs the gender scope moved off
   * filter.p.tag first (an owner item from the final gate, 2026-10-25).
   *
   * Off the search page it is a strict no-op; "the search page" is
   * theme.isSearchPage's exact route match (C-2), because the old
   * pathname.includes('search') also fired on any handle containing "search"
   * (e.g. /collections/research-lab) and stamped the header's gender scope
   * onto that collection's filters.
   *
   * Mutates and returns the passed URLSearchParams. Idempotent — safe to call
   * more than once on the same params.
   */
  theme.enforceSearchScope = function (queryParams) {
    if (!theme.isSearchPage()) return queryParams;

    var scopeInput = document.querySelector('[data-gender-search-filter]');
    if (!scopeInput) return queryParams;

    // A disabled input means "unscoped" (gender-context.js disables it when
    // there is no gender, or no map entry for it): the scope to stamp is none.
    // Every gender value is still stripped below, because the params of a
    // Back/Forward entry (renderPage) reach this function without the builder,
    // and a scope that entry once carried must not outlive the source of truth
    // (final gate round 14).
    // An enabled input holds the store's tag ('Men' / 'Women', lead ruling
    // #63); lowercased, it is the internal gender. The value appended below is
    // taken from theme.genderScopeTags, which layout/theme.liquid builds from
    // the one map (snippets/gender-scope-tag.liquid), so the URL carries the
    // store's exact tag whatever casing the input holds. An enabled input
    // holding a gender the map does not know leaves the params as they are,
    // rather than write a scope that cannot match (filter.p.tag is
    // case-sensitive, gotcha G14).
    var scope = null;
    if (!scopeInput.disabled) {
      var gender = String(scopeInput.value).toLowerCase();
      if (gender !== 'men' && gender !== 'women') return queryParams;
      scope = theme.genderScopeTags && theme.genderScopeTags[gender];
      if (!scope) return queryParams;
    }

    // Preserve any non-gender tag values (deduped); drop every gender value so
    // the scope is unambiguous, then append the source-of-truth scope exactly
    // once. Removing ALL gender values (not just the mismatched one) also
    // collapses accidental duplicates into a single authoritative entry.
    var values = queryParams.getAll('filter.p.tag');
    var nonGender = [];
    var hasGender = false;
    values.forEach(function (value) {
      var down = String(value).toLowerCase();
      if (down === 'men' || down === 'women') {
        hasGender = true;
      } else if (nonGender.indexOf(value) === -1) {
        nonGender.push(value);
      }
    });
    // Unscoped with no gender value to strip: leave the params, and the order
    // of their tag values, exactly as they came.
    if (!scope && !hasGender) return queryParams;
    queryParams.delete('filter.p.tag');
    nonGender.forEach(function (value) { queryParams.append('filter.p.tag', value); });
    if (scope) queryParams.append('filter.p.tag', scope);

    return queryParams;
  };

  /**
   * isSearchPage — exact search-page detection (C-2, spec 4.1).
   * -----------------------------------------------------------------------------
   * True only on the search results route itself: the pathname equals
   * theme.routes.search (layout/theme.liquid's locale-aware routes.search_url,
   * e.g. /search or /sv/search), a trailing slash tolerated. It replaces
   * pathname.includes('search'), which also matched any handle containing
   * "search" (e.g. /collections/research-lab) and ran the search-only rules
   * there (the URL copy and the gender scope stamp).
   *
   * @param {string} [pathname] - the path to judge; defaults to
   *   window.location.pathname.
   * @returns {boolean}
   */
  theme.isSearchPage = function (pathname) {
    if (pathname === undefined) pathname = window.location.pathname;
    // layout/password.liquid loads theme.js without theme.routes: no route means
    // no search page, and keeps this (and enforceSearchScope) from throwing.
    const search = theme.routes && theme.routes.search;
    if (!search) return false;
    return pathname === search || pathname === search + '/';
  };

  /**
   * buildFilterQuery — the ONE query builder (C-2, spec 4.1).
   * -----------------------------------------------------------------------------
   * The one builder for filter requests and history URLs (spec 4.1 names the
   * callers: the count fetch, the grid fetch, clear-all and every pushState
   * URL), so they can never disagree. Root cause it removes
   * (F11): the old builders copied the WHOLE search URL and then merged the
   * checked inputs into it (AjaxRenderer.getUpdatedParams), so a facet the
   * user had just unchecked, and the page number, survived from the lagging
   * URL; the merge also deleted while iterating, which skips the entry after
   * each deleted one. This builder never merges. It rebuilds the query from
   * scratch, in canonical order:
   *   1. Base: the request-defining params copied from opts.search with all
   *      their values, in this key order: q, type, options[prefix], sort_by on
   *      search; only sort_by on a collection. Nothing else survives from the
   *      URL (old facets, page, legacy price bounds, tracking params).
   *   2. Facets: opts.facets in order, deduplicated. Empty names or values,
   *      page and filter.v.availability are skipped; on search so are the
   *      gender values of filter.p.tag (men/women, any case), which the scope
   *      authority owns. Other tag values stay ordinary, removable facets
   *      (beside a scope they widen it, G25: see enforceSearchScope).
   *   3. Mode: filter.v.availability=1, exactly once.
   *   4. Scope: theme.enforceSearchScope, the one gender authority (a no-op
   *      off search). When it stamps a scope it re-appends the non-gender tag
   *      values, so those then sit after step 3, and Shopify ORs them with the
   *      scope (G25, an owner item: see enforceSearchScope).
   *
   * It takes the URL state from opts.search (never window.location.search) and
   * never mutates opts.facets, so any URL state can be rebuilt (clear-all
   * passes only the modes that stay checked, never a user facet). Its only
   * outside reads are step 4's: the page path (theme.isSearchPage) and the
   * scope input.
   *
   * @param {Object} opts
   * @param {string} opts.search - a location.search string ('?a=1&b=2' or '').
   * @param {boolean} opts.isSearchPage - selects the base keys (theme.isSearchPage()).
   * @param {Array<Array<string>>} opts.facets - [name, value] pairs, in DOM order.
   * @returns {URLSearchParams} a new object, in the canonical order above.
   */
  theme.buildFilterQuery = function (opts) {
    const url = new URLSearchParams(opts.search);
    const params = new URLSearchParams();

    // 1. Base: only the request-defining params, every value, in key order.
    const baseKeys = opts.isSearchPage ? ['q', 'type', 'options[prefix]', 'sort_by'] : ['sort_by'];
    for (const key of baseKeys) {
      for (const value of url.getAll(key)) params.append(key, value);
    }

    // 2. Facets, keyed on the exact pair: NUL never occurs in an attribute, so
    // the join is unambiguous (a '=' join would merge a=b|c with a|b=c).
    const seen = new Set();
    for (const [name, value] of opts.facets) {
      if (!name || !value || name === 'page' || name === 'filter.v.availability') continue;
      // On search a gender tag is the scope (a mode), never a facet: step 4
      // stamps it. Same any-case test as enforceSearchScope, so they agree.
      const isGenderTag = name === 'filter.p.tag' && ['men', 'women'].includes(String(value).toLowerCase());
      if (opts.isSearchPage && isGenderTag) continue;
      const pair = name + '\u0000' + value;
      if (seen.has(pair)) continue;
      seen.add(pair);
      params.append(name, value);
    }

    // 3. Mode: availability on, once (URL and facet copies were dropped above).
    params.append('filter.v.availability', '1');

    // 4. Scope last, so the one authority has the final say.
    return theme.enforceSearchScope(params);
  };

  /**
   * facetInputs — the filter inputs of one facet, found by COMPARISON (C-7, spec 5).
   * -----------------------------------------------------------------------------
   * Every lookup of a filter input by its facet name and value goes through here, never
   * through a selector built from them. Facet values are catalogue data (supplier feed ->
   * product options, metafields and tags): spliced into input[name="..."][value="..."], a
   * quote, a bracket or `"]` threw a SyntaxError that aborted the whole filter pass, or matched
   * the wrong input. An === comparison of attributes cannot be parsed as selector syntax, so
   * no call site can forget an escape (spec design gate, from the blind pass).
   *
   * It compares ATTRIBUTES, exactly as those selectors did: getAttribute('value'), not the
   * .value property (a checkbox without a value attribute reports "on"), and case-sensitive,
   * as an attribute selector on name/value is and as filter.p.tag needs (G14).
   *
   * Two modes, because the drawers carry each facet twice:
   *  - default: the desktop form's named inputs, input[name] (compares name and value);
   *  - opts.data: the mobile drawer's twins, input[data-name] (compares data-name and
   *    data-value). They have no name, so they never reach a query; they mirror into the
   *    named ones.
   * Interface extension (Ruling 4): value === undefined matches by name alone. The "All X"
   * pill finds its group's "All" checkbox that way: the box has data-name only (its
   * data-value is empty), so there is no value to compare.
   *
   * A value read from JSON (the count section's payload) must be decoded before it is passed
   * in (theme.utils.decodeString): Shopify sends filter_value.value HTML-escaped there, while a
   * DOM attribute holds the decoded value (G24).
   *
   * @param {ParentNode} root - the subtree to search (document, a drawer, a section container).
   * @param {string} name - the facet's parameter name, e.g. filter.v.m.collection_filter.size.
   * @param {string} [value] - the facet value; undefined matches by name only.
   * @param {{data: boolean}} [opts] - { data: true } for the data-name / data-value twins.
   * @returns {Element[]} the matching inputs in document order; empty when none match.
   */
  theme.facetInputs = function (root, name, value, opts = { data: false }) {
    const nameAttr = opts.data ? 'data-name' : 'name';
    const valueAttr = opts.data ? 'data-value' : 'value';
    return Array.from(root.querySelectorAll(opts.data ? 'input[data-name]' : 'input[name]')).filter(function (input) {
      return input.getAttribute(nameAttr) === name && (value === undefined || input.getAttribute(valueAttr) === value);
    });
  };

  /**
   * setFacetChecked — one facet's checked state onto EVERY copy of it (C-8, spec C22).
   * -----------------------------------------------------------------------------
   * The drawers carry each facet more than once: the desktop form's named input, a second one when the
   * sidebar layout renders the form twice or a category value prints under two menu leaves, and the
   * mobile drawer's data-name / data-value twins. After any input event they must all agree, so the
   * handlers set them all here instead of the first match (theme.facetInputs returns every match, found
   * by comparison: C-7). It also keeps the query honest: theme.buildFilterQuery reads every checked
   * named input, so a copy left behind would keep a facet the shopper had just removed.
   *
   * Each copy's row keeps its tag--active mark in step with its checkbox, as everywhere else in the
   * filter code. After ANY change, a check as well as an uncheck, the "All X" box of each copy's group is
   * derived from its rows, on both sides (theme.syncAllBoxes): a group is "All" exactly while every row is
   * checked, which is how the server prints it. So an unchecked row clears the box, the LAST unchecked row
   * ticks it, and a check that leaves another row unchecked leaves it off. (A handler that reads an "All"
   * box's own state while it sets the rows must read it once, before the first row: this derivation
   * rewrites that box as the rows change.)
   *
   * An empty name or value is no facet (as in Collection._checkedFacets), so nothing is touched. That
   * also keeps a missing attribute (undefined) from reaching theme.facetInputs' name-only mode, which
   * would match every value of the facet.
   *
   * @param {ParentNode} root - the subtree holding the copies (the section or the sidebar container).
   * @param {string} name - the facet's parameter name.
   * @param {string} value - the facet value.
   * @param {boolean} checked - the state every copy takes.
   * @returns {Element[]} the copies it set: the desktop inputs first, then the mobile twins.
   */
  theme.setFacetChecked = function (root, name, value, checked) {
    // No identity, no facet: stop before theme.facetInputs, which would read an undefined value as "any value".
    if (!name || !value) return [];
    // Both modes: the named desktop inputs (every form) and the data-name mobile twins.
    const copies = theme.facetInputs(root, name, value).concat(theme.facetInputs(root, name, value, { data: true }));
    copies.forEach(function (input) {
      input.checked = checked;
      // The row's active mark follows its checkbox (a row-less input, e.g. a hidden one, has none).
      const row = input.closest('li.tag');
      if (row) row.classList.toggle('tag--active', checked);
    });
    // After a check as well as after an uncheck, the "All" box of every group a copy sits in follows its rows, on every
    // side: an unchecked row clears it, the LAST unchecked row ticks it (as the server prints it), a check that leaves
    // another row unchecked leaves it off.
    theme.syncAllBoxes(copies);
    return copies;
  };

  /**
   * syncAllBoxes — the "All X" box of each group the given inputs sit in takes the state its rows say (C-8).
   * -----------------------------------------------------------------------------
   * A group's "All" box is checked exactly when EVERY row of its list is checked, hidden rows included.
   * That is the server's rule: facets-category and facets-category-mobile print the box checked when every
   * PRINTED row is active, and a row printed with the hide class is an active value at count 0, kept so its
   * input exists (Ruling 24). So a page the server rendered and a page the shopper has clicked through
   * agree, and so do the desktop copy and the mobile copy of a group, which are derived from the same
   * rows. Counting only the rows without the hide class (the old syncAllCheckboxes) unchecked the box of
   * a group whose rows were all active and hidden, right after the server had printed it checked.
   *
   * Only a list's OWN box counts: the mobile category dropdown is a .filter__list that wraps its
   * sub-groups' lists, and a plain querySelector would hand it a sub-group's box. A list without a box
   * (every filter but the category tree has none) is left alone.
   *
   * @param {Iterable<Element>} inputs - any inputs; the lists they sit in are synced (each once).
   */
  theme.syncAllBoxes = function (inputs) {
    // Each group once, however many of its inputs were given (a Set), and none for an input outside every group list.
    const lists = new Set();
    Array.from(inputs).forEach(function (input) {
      const list = input.closest('.filter__list');
      if (list) lists.add(list);
    });
    lists.forEach(function (list) {
      // The list's OWN box, not a nested sub-group's (see above).
      const all = Array.from(list.querySelectorAll('.tag__input--all')).find(function (box) {
        return box.closest('.filter__list') === list;
      });
      if (!all) return;
      // Every row, hidden ones included: the server's rule (see above). An empty list is never "All".
      const rows = Array.from(list.querySelectorAll('.tag__input:not(.tag__input--all)'));
      const on = rows.length > 0 && rows.every(function (row) { return row.checked; });
      all.checked = on;
      // The box's own row carries the mark too, as it does when the shopper clicks the box.
      const item = all.closest('li.tag');
      if (item) item.classList.toggle('tag--active', on);
    });
  };

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page (Section Rendering API).
   * theme.Collection is its one user: renderPage is its full render of one URL
   * state (Back/Forward), renderSectionFromFetch the status-checked fetch its
   * grid updates share, and updateURLHash the history push both commit with.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {string} [sections[].marker] - A selector the section's response
   *   must contain to be valid (C-5); theme.Collection's grid update swaps
   *   that node alone.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      // renderPage — the full render of ONE complete URL state (C-2, C-4, C-5;
      // spec 4.4 R5, R7). theme.Collection calls it for Back/Forward.
      //  - params IS the state. It is never merged with the address bar: the
      //    old merge (getUpdatedParams) kept facets the shopper had removed and
      //    the page number (F11). The scope authority (theme.enforceSearchScope)
      //    still has the last word on search (July rule); it works on a copy, so
      //    the caller's params are never changed.
      //  - Prepare, then swap. Every section's response is read first (from the
      //    cache, or fetched and status-checked) and validated: its node, and
      //    its marker when it has one, in the response, and its live node on
      //    the page. Only when all pass, and opts.isCurrent() says the caller
      //    still owns the page (a cache hit too, R7), are they all swapped and
      //    then the URL pushed (never before the swap, R5). A render swaps
      //    every section or none.
      //  - Resolves with the enforced params on commit, or null when superseded
      //    (nothing changed). Rejects when a fetch fails or is aborted, or a
      //    response or live node is invalid (nothing changed either).
      // opts: { signal } aborts its fetches; { isCurrent } is the ownership test;
      // { validate(prepared) } is the caller's extra prepare-stage check (it throws to reject).
      renderPage: async function (basePath, params, updateURLHash = true, opts = {}) {
        const query = theme.enforceSearchScope(new URLSearchParams(params));

        const prepared = await Promise.all(this.sections.map(async section => {
          const url = `${basePath}?section_id=${section.sectionId}&${query.toString()}`;
          const cached = this.cachedSections.find(entry => entry.url === url);
          if (cached) this.log(`[AjaxRenderer] rendering from cache: url=${url}`);
          const html = cached ? cached.html : await this.renderSectionFromFetch(url, opts.signal);
          return { section, url, html, cached: Boolean(cached), dom: new DOMParser().parseFromString(html, 'text/html') };
        }));

        // A node missing on either side, or a missing marker, is an error, never
        // a silent partial swap (507ab81, N4).
        prepared.forEach(({ section, url, dom }) => {
          const nodesFound = [].concat(section.nodeId).every(id => dom.getElementById(id) && document.getElementById(id));
          if (!nodesFound || (section.marker && !dom.querySelector(section.marker))) {
            throw new Error(`[AjaxRenderer] invalid render, nothing swapped: ${url}`);
          }
        });
        // The caller's own checks of the prepared responses, still before any swap: it throws
        // to reject the render (theme.Collection checks the /search heading, Ruling 46).
        if (opts.validate) opts.validate(prepared);

        if (opts.isCurrent && !opts.isCurrent()) return null;

        prepared.forEach(({ section, dom }) => this.renderSection(dom, section));

        // R7: only the fetched renders are cached, at most 10, first in first
        // out (the old cache grew without bound, one full section per state).
        prepared.forEach(({ url, html, cached }) => {
          if (cached) return;
          this.cachedSections.push({ url, html });
          if (this.cachedSections.length > 10) this.cachedSections.shift();
        });

        if (updateURLHash) this.updateURLHash(query);

        return query;
      },

      // One section render over the network, checked by HTTP status (C-5): a
      // 500 or 429 page is a failed render, never markup to swap in. It only
      // fetches; its callers swap after every section validated (prepare, then
      // swap). Shared by renderPage and theme.Collection's grid fetch.
      // Resolves with the HTML; rejects on a network failure, an abort (signal)
      // or a non-ok status.
      renderSectionFromFetch: async function (url, signal) {
        this.log(`[AjaxRenderer] rendering from fetch: url=${url}`);

        const response = await fetch(url, { signal });
        if (!response.ok) throw new Error(`[AjaxRenderer] HTTP ${response.status}: ${url}`);
        return response.text();
      },

      // Swaps one section in. renderPage calls it only after every section was
      // validated, so the guards below no longer fire; they stay for safety.
      renderSection: function (newDom, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );

        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            // Guard against the live target being missing (renamed/removed by
            // an earlier render). Without this, a single missing id throws
            // mid-pipeline so e.g. the header renders but the grid doesn't.
            var liveEl = document.getElementById(section.nodeId);
            if (liveEl) liveEl.innerHTML = newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              var liveEl = document.getElementById(id);
              var newEl = newDom.getElementById(id);
              if (liveEl && newEl) liveEl.innerHTML = newEl.innerHTML;
            });
          }
        }

        return section;
      },

      // The history push of a committed render (R5); its callers push only after
      // the swap. No bare "?" for an empty query (e47b869/l: the old
      // `searchParams && …` test is true even for an empty URLSearchParams), and
      // no new entry when the address bar already shows this query: committing
      // the state the address bar already names must not add a Back step that
      // changes nothing.
      updateURLHash: function (searchParams) {
        const query = new URLSearchParams(searchParams).toString();
        if (query === new URLSearchParams(window.location.search).toString()) return;
        history.pushState({}, '', window.location.pathname + (query ? '?' + query : ''));
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  /*============================================================================
    theme.cart: the page's one cart client (Phase D, spec D4)
    - enqueue: the one FIFO queue. Every cart request runs as a job, one job at
      a time, so completions cannot reorder and a read cannot overtake a change.
    - request: the one call to a cart endpoint. A 15 s deadline, it never
      rejects, and an answer that comes after the deadline is never applied.
    - classifyAdd, classifyChange, reconcileVerdict, resolveLineTarget and
      matchesCart: pure verdicts on a reply or a cart (D3.3, D3.4, D4, D2.1).
    - updateCount: the one writer of the header counts (D1.2; the bubble and the
      mobile menu's count, 0 included: final gate F3).
    - getCart, getCartProductMarkup, changeItem, updateNote, updateAttribute:
      the old wrappers, now queued and status-checked, for callers OUTSIDE any
      job. Inside a job, only request() (the job rule, see enqueue).
    qa/harness/cart_queue_unit.mjs (U1-U8) runs this object's text in a vm: keep
    the start line "  theme.cart = {" as it is, close the object with a line of
    two spaces and a brace, and let no line inside it be just that.
  ==============================================================================*/
  theme.cart = {
    // D3.3 / D4: the deadline of every cart request, in ms. Long enough for a slow phone network, short enough that
    // a hung request never strands the shopper (spec D3.3, d's call). Probes and the unit test lower it at runtime.
    DEADLINE_MS: 15000,

    // D4: the newest cart JSON a request() reply carried (a 2xx, cart-shaped body that arrived within the deadline),
    // or null before the first. A queued change resolves its line against it just before it sends (resolveLineTarget).
    latestCart: null,

    // D4: the promise of the last job enqueued; the next job starts when it settles. Only enqueue touches it.
    _tail: Promise.resolve(),

    // D4: the page's one cart queue, FIFO, one job at a time. A job starts only once the job before it has settled,
    // so completions cannot reorder, a read cannot overtake a change, and the DOM is written only by the job that has
    // just finished. run is () => Promise<T> (a plain value or a synchronous throw works too); the promise returned
    // is that job's own. The next job is chained on BOTH outcomes of this one, so a job that throws or rejects
    // releases the queue and rejects only its own promise.
    // THE JOB RULE (Tasks 3 and 5): inside a job, call request() only, never a queued wrapper (getCart, changeItem,
    // updateNote, ...), and never await another enqueue() there. That job would wait behind the running one, which
    // is waiting for it: a deadlock. Every await in a job must end (request() always does, by DEADLINE_MS), or the
    // queue stops for the rest of the page.
    enqueue: function (run) {
      // run gets no arguments: .then would hand it the previous job's value or error, which is not its business. A
      // run that is not a function fails its own job (TypeError) instead of passing the previous value through.
      const start = () => run();
      this._tail = this._tail.then(start, start);
      return this._tail;
    },

    // D3.3 / D4: the one call to a cart endpoint; use it inside a job. It never rejects: it fulfils with a Reply,
    // { status, body, timedOut, networkError }, which the classifiers below turn into one outcome.
    //  - status is set only when the whole answer (status line and body) arrived within DEADLINE_MS. Otherwise status
    //    and body are null and one flag says why: timedOut (the deadline), or networkError (fetch threw or rejected,
    //    or the body failed to read).
    //  - The deadline: DEADLINE_MS after the call, the timer answers timedOut by itself, and this request's own
    //    AbortController then aborts the fetch. The timer answers, not the abort, so a fetch that ignores its signal
    //    still cannot hold the job past the deadline.
    //  - A late answer is never applied (spec D4, "Aborted requests never land"): once the deadline has answered,
    //    nothing reads what the fetch brings back, so it cannot reach the caller, latestCart or the DOM.
    //  - The body is read once, as text. With as = 'json' (the default) a JSON object or array becomes the body and
    //    anything else keeps its raw text (an HTML error page, the 429 limiter's "local_rate_limited"); with
    //    as = 'text' the text is the body. response.json() is not used: it throws on such a body, and a body can be
    //    read only once.
    //  - A 2xx cart-shaped body becomes latestCart, only when it arrived in time.
    //  init reaches fetch unchanged except for signal, which is always this request's own.
    request: async function (url, init, as = 'json') {
      const controller = new AbortController();
      let timer;
      const deadline = new Promise((resolve) => {
        timer = setTimeout(() => resolve({ status: null, body: null, timedOut: true, networkError: false }), this.DEADLINE_MS);
      });
      // The whole answer, read in full. Any failure on the way becomes networkError, this request's own abort
      // included; that abort happens only after the deadline has answered, so such a reply is never used.
      const answer = (async () => {
        const response = await fetch(url, Object.assign({}, init, { signal: controller.signal }));
        const text = await response.text();
        let body = text;
        if (as !== 'text') {
          try {
            const parsed = JSON.parse(text);
            // Only an object or an array counts as a JSON body: a bare JSON value ("null", 42) keeps its text, so a
            // reply's body is always an object or a string whenever its status is set.
            if (parsed !== null && typeof parsed === 'object') body = parsed;
          } catch (e) {
            // Not JSON: the body stays the raw text.
          }
        }
        return { status: response.status, body: body, timedOut: false, networkError: false };
      })().catch(() => ({ status: null, body: null, timedOut: false, networkError: true }));

      const reply = await Promise.race([answer, deadline]);
      clearTimeout(timer);
      if (reply.timedOut) {
        // Stop the browser's wait. Shopify may still finish the work (spec D4, "Ordering in the browser is not
        // ordering at Shopify"); the answer, if one comes, is read by nobody.
        controller.abort();
        return reply;
      }
      if (reply.status >= 200 && reply.status < 300 && this._isCart(reply.body)) this.latestCart = reply.body;
      return reply;
    },

    // D3.3: the one classification of an add's reply (POST /cart/add.js), exactly one class per reply:
    //  - 'added': a 2xx whose JSON describes the added line: the line item itself (a numeric variant_id), or a
    //    non-empty items[] in which every entry has a numeric variant_id. Only then does the cart have it;
    //  - 'rejected': any 4xx (422 with Shopify's description, 400, 404, 429 and the rest): Shopify refused the add;
    //  - 'unconfirmed': everything else (the deadline, a network failure, any 5xx, a 2xx that describes no line,
    //    such as an empty items[] or an entry without a variant_id): the add may or may not have reached the cart.
    //    A 5xx is not a rejection, because a gateway error can follow a commit.
    classifyAdd: function (reply) {
      const status = reply.status;
      if (status >= 400 && status < 500) return 'rejected';
      const body = reply.body;
      const isLine = (x) => !!x && typeof x === 'object' && typeof x.variant_id === 'number';
      // The length test is needed because [].every() is true: an empty items[] describes no line (cp2 round 1).
      const described = isLine(body) || (!!body && Array.isArray(body.items) && body.items.length > 0 && body.items.every(isLine));
      return status >= 200 && status < 300 && described ? 'added' : 'unconfirmed';
    },

    // D4: the classification of a reply that should carry the cart (POST /cart/change.js, POST /cart/update.js, a
    // GET /cart.js read): 'confirmed' for a 2xx cart-shaped body, 'rejected' for any 4xx (Shopify refused the
    // change), and 'unconfirmed' for everything else (the deadline, a network failure, any 5xx, a 2xx without a
    // cart), where the change may or may not have happened, so the caller refreshes before it shows anything.
    classifyChange: function (reply) {
      const status = reply.status;
      if (status >= 400 && status < 500) return 'rejected';
      return status >= 200 && status < 300 && this._isCart(reply.body) ? 'confirmed' : 'unconfirmed';
    },

    // D3.4: the reconcile verdict of an unconfirmed add, from one /cart.js read in the same job: 'in_bag' when the
    // attempted variant is in the cart, 'unconfirmed' when it is not or the read failed (cart null). It checks
    // presence, not a quantity change (spec D3.4, d's call), and never reports absence as a rejection: the add may
    // still commit after the read.
    reconcileVerdict: function (variantId, cart) {
      const inBag = !!cart && Array.isArray(cart.items) && cart.items.some((item) => item.variant_id === variantId);
      return inBag ? 'in_bag' : 'unconfirmed';
    },

    // D4: send-time line resolution. A queued change finds its line when it runs, not when it was tapped, because a
    // line's key "changes as characteristics of the line item change" (Shopify), so an earlier removal can re-key a
    // later line. target is { key, variantId } as tapped; cart is the newest cart JSON the queue holds (latestCart).
    // It returns { key } to send, { done: true } when the line is already gone (send nothing), or { refuse: true }
    // when it cannot tell which line was meant (the caller refreshes and shows cart.general.update_error).
    resolveLineTarget: function (target, cart) {
      // No cart JSON yet on this page: the tapped key, rendered with the page, is the newest information there is.
      if (!cart || !Array.isArray(cart.items)) return { key: target.key };
      // The recorded key is still present: use it, even when other lines share its variant.
      if (cart.items.some((item) => item.key === target.key)) return { key: target.key };
      // Without a usable variant id, "already gone" cannot be told from "re-keyed": never guess.
      if (!Number.isInteger(target.variantId) || target.variantId < 1) return { refuse: true };
      const lines = cart.items.filter((item) => item.variant_id === target.variantId);
      if (lines.length === 1) return { key: lines[0].key };
      // No line has the variant: the line is already gone. Several do (different properties): never guess.
      return lines.length === 0 ? { done: true } : { refuse: true };
    },

    // D2.1 (plan gate): the section/cart cross-check. True only when el, a rendered [data-cart-contents], shows
    // exactly this cart: its data-cart-item-count and data-cart-total equal item_count and total_price, AND its
    // .cart__item rows, in order, carry the cart's lines as [data-key, data-quantity]. The line check is what stops
    // a render of other lines with equal totals (a different line, swapped quantities) from passing. A missing
    // attribute never matches.
    // The render's note must be the cart's too (final gate F5, Codex B4): a refresh reads the section and /cart.js at
    // once, so a note saved between the two reads (another tab) would otherwise let a render of another note through.
    // main-cart prints the note exactly in data-cart-note on [data-cart-contents] (final gate round 3, H3 = R3C4),
    // whether or not the merchant shows the note field. It replaced the note field's text, which the HTML parser alters
    // (it drops one line feed right after a textarea's start tag), and round 2's model of that parsing (G4), under
    // which a render of the note "A" matched the cart note "\nA". An attribute keeps a leading line feed, so those two
    // differ now. Both sides read CR LF and a lone CR as LF, and a null note as '': the parser's input stream turns every
    // CR of the markup into LF before the attribute is read, so a note holding CR LF (the checkout form posts its text
    // that way) could never match otherwise, and that difference never shows on the page. A render without the
    // attribute never matches (final gate round 4, H5: fail-closed). main-cart prints it on every render since H3, so a
    // render without it was cached before that deploy, and refusing it only falls back to the refresh, then the reload,
    // which shows the server's cart; skipping the note there would let a stale note's render through.
    matchesCart: function (el, cart) {
      if (!el || !this._isCart(cart)) return false;
      const data = el.dataset;
      if (data.cartItemCount !== String(cart.item_count) || data.cartTotal !== String(cart.total_price)) return false;
      const lf = (text) => (typeof text === 'string' ? text : '').replace(/\r\n?/g, '\n');
      if (typeof data.cartNote !== 'string' || lf(data.cartNote) !== lf(cart.note)) return false;
      const rows = Array.from(el.querySelectorAll('.cart__item'));
      return rows.length === cart.items.length && rows.every((row, i) =>
        row.dataset.key === cart.items[i].key && row.dataset.quantity === String(cart.items[i].quantity));
    },

    // D1.2, D2.1: the one writer of the header counts, moved from theme.CartForm.updateCount (Phase D Task 2) so every
    // cart job sets them the same way. Every count, 0 included, is written as a reload prints it (final gate F3 = Codex
    // B1, Claude I1): the old body wrote .cart-link__bubble only when count > 0 and put the 0 in .cart-link__bubble-num,
    // which no markup has, so removing the last line in place left the old count in the header.
    //  - .cart-link__bubble (snippets/header-icons.liquid): its text. Its --visible class stays as the server rendered
    //    it (always on, 0 included).
    //  - [data-cart-count] (snippets/drawer-menu.liquid, the mobile menu's "Cart (N)"): its text and its attribute,
    //    which theme.css.liquid's :has([data-cart-count="0"]) rule reads. Its class has a typo that matches neither
    //    bubble selector, and that file is not this phase's, so it is found by its attribute.
    //  - .cart-link__bubble-num: still written when present (none today; harmless).
    updateCount: function (count) {
      document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
        el.innerText = count;
      });
      document.querySelectorAll('.cart-link__bubble').forEach((el) => {
        el.textContent = count;
      });
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.setAttribute('data-cart-count', count);
      });
    },

    // D4 / U7: the one test of "cart-shaped": an items array and a numeric item_count, which every cart JSON has and
    // a line item, an error body or an HTML page does not. request (latestCart), classifyChange and matchesCart all
    // use it, so they cannot disagree on what a cart is.
    _isCart: function (body) {
      return !!body && typeof body === 'object' && Array.isArray(body.items) && typeof body.item_count === 'number';
    },

    // D4 kept wrapper: the cart JSON (GET /cart.js, cache-busted), as one queued job. Resolves with the cart only
    // when the reply is confirmed; rejects otherwise.
    getCart: function () {
      const url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return this._cartJob(url, { credentials: 'same-origin', method: 'GET' });
    },

    // D4 kept wrapper: the cart page's ajax view (templates/cart.ajax.liquid) as HTML text, as one queued job, for a
    // caller outside any job. Resolves with the text only on a 2xx, so an error page is never rendered as the cart. No
    // theme caller since Phase D Task 5: CartForm.buildCart reads the view inside its own job (the job rule).
    getCartProductMarkup: function () {
      let url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return this._cartJob(url, { credentials: 'same-origin', method: 'GET' }, 'text');
    },

    // D4 kept wrapper: sets a line's quantity by its key (POST /cart/change.js; 0 removes the line). Resolves with
    // the cart.
    changeItem: function (key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    // D4: the JSON POST behind changeItem, updateAttribute and updateNote, as one queued job (_cartJob). It checks
    // the reply's status before it uses the body, and resolves with the cart only when the reply is confirmed.
    _updateCart: function (params) {
      return this._cartJob(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    },

    // D4 ("_updateCart and getCart check the status before they parse, and return a classified result"): one queued
    // job of one request() for the wrappers above. It resolves with the reply's body only when the reply is
    // confirmed (as 'json': classifyChange says 'confirmed', a 2xx cart; as 'text': a 2xx, whose body is then its
    // text) and rejects otherwise, with the Reply on error.reply, so no caller parses an error page or an error JSON
    // as the cart.
    _cartJob: function (url, init, as) {
      return this.enqueue(async () => {
        const reply = await this.request(url, init, as);
        const confirmed = as === 'text' ? reply.status >= 200 && reply.status < 300 : this.classifyChange(reply) === 'confirmed';
        if (!confirmed) {
          const error = new Error('theme.cart: ' + url + ' was not confirmed');
          error.reply = reply;
          throw error;
        }
        return reply.body;
      });
    },

    // D4 kept wrapper: sets one cart attribute (POST /cart/update.js). Resolves with the cart. No caller in the theme
    // today; plan Task 2 keeps it as part of theme.cart's public surface.
    updateAttribute: function (key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },

    // D4 kept wrapper: sets the cart note (POST /cart/update.js), from the drawer's note field (drawer mode). Resolves
    // with the cart. The cart page makes no AJAX note save (lead ruling seq 53): its checkout form posts the note field.
    updateNote: function (note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },

    // Turns a note or attribute value into a trimmed string (undefined becomes ''), as Shopify stores them.
    attributeToString: function (attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  /*============================================================================
    CartForm: the one cart-mutation owner of a cart form (Phase D, spec D2.1, D2.2, D4)
    - The cart page (sections/main-cart.liquid, data-location="page") is built on the section's [data-cart-root], an
      element no swap replaces, so it exists on an empty cart too. Every change (a Remove, the hidden quantity path) is
      one job of theme.cart's queue: POST /cart/change.js with bundled section rendering, so ONE request changes the
      cart and returns main-cart's own fresh render. That render is checked line by line against the same answer's
      cart JSON (theme.cart.matchesCart) before its [data-cart-contents] replaces the page's, so the page shows exactly
      what a reload would. Every other outcome refreshes from the server (the section and /cart.js), and the message
      comes from what the refreshed cart shows, never from the status code alone. Checkout posts no quantities.
    - The drawer (#CartDrawerForm; drawer mode only, U7 decides its deletion) keeps the templates/cart.ajax.liquid
      fragment, rebuilt as one job (spec D2.2), with the this.products repair.
    - Both stop a checkout while the terms box (when the merchant enables it) is unticked.
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',

      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };

    // The cart page's hooks (sections/main-cart.liquid, snippets/cart-item.liquid).
    var page = {
      contents: '[data-cart-contents]',
      row: '.cart__item',
      remove: '[data-cart-remove]',
      message: '[data-cart-message]',
      status: '[data-cart-status]',
      empty: '.cart-message--empty',
      updates: '[name="updates[]"]',
      // The controls focus can sit on, in document order: focusPlan and focusAfterSwap find a control by its index.
      focusable: 'a[href], button, input, select, textarea, [tabindex]'
    };

    var classes = {
      btnLoading: 'btn--loading',
      loading: 'is-loading'
    };

    var config = {
      requiresTerms: false
    };

    // theme.CartForm(form): form is the cart page's [data-cart-root] (data-location="page", initPage) or the drawer's
    // #CartDrawerForm (init). The two share only the QtySelector wiring.
    function CartForm(form) {
      if (!form) {
        return;
      }

      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;

      if (this.location === 'page') {
        this.initPage(form);
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      /*==========================================================================
        The drawer (drawer mode only; spec D2.2, U7)
      ==========================================================================*/

      // The drawer's wiring, as before Phase D: its QtySelectors, the quantity event, the terms check on submit, the
      // note, and cart:build.
      init: function () {
        this.initQtySelectors(this.form);

        document.addEventListener('cart:quantity' + this.namespace, this.drawerQuantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.drawerSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function () {
            var newNote = this.value;
            // theme.cart.updateNote rejects on a failure (Phase D); the drawer has no message area, so it is logged.
            theme.cart.updateNote(newNote).catch(function (err) {
              console.error('[CartForm] the drawer note was not saved', err);
            });
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function () {
          this.buildCart();
        }.bind(this));
      },

      reInit: function () {
        this.initQtySelectors(this.form);
      },

      // The drawer's checkout submit: an unticked terms box (when enabled) cancels it, as before Phase D.
      drawerSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },

      // The drawer's rebuild as ONE job of theme.cart's queue (spec D2.2, D4): the read of the cart page's ajax view
      // (templates/cart.ajax.liquid) and its DOM write sit in the same job, so no other job can run between them and
      // overtake the write. Inside the job only theme.cart.request() is called (the job rule): the queued
      // getCartProductMarkup would wait behind this very job. The URL is that wrapper's. Only a 2xx is rendered, so an
      // error page never becomes the drawer's rows. Resolves when the job has ended.
      buildCart: function () {
        return theme.cart.enqueue(async () => {
          let url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

          url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

          const reply = await theme.cart.request(url, { credentials: 'same-origin', method: 'GET' }, 'text');
          if (reply.status >= 200 && reply.status < 300) this.cartMarkup(reply.body);
        });
      },

      cartMarkup: function (html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          if (this.wrapper) this.wrapper.classList.remove('is-empty');

        } else {
          if (this.wrapper) this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup. this.products is the drawer's rows container ([data-products]); the old test named a
        // property that never existed (this.product), so the rows were never committed (spec D2.2).
        if (this.products) {
          this.products.innerHTML = '';
          this.products.append(items);
        }

        // Update subtotal. C13 (Phase B): data-cart-subtotal is cart.items_subtotal_price (templates/cart.ajax.liquid),
        // the amount the cart page's Subtotal row prints, and the one formatter writes it, so the row reads the same
        // before and after a rebuild (it used to receive cart.total_price). Drawer mode only since Phase D: the cart
        // page swaps in main-cart's own section render instead (initPage), so this renderer no longer has to produce
        // the cart page's Total, mobile rows or O-B6 block. The drawer's own single Subtotal (R22) is left to U7.
        if (this.subtotal) {
          this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        }

        this.reInit();

        if (window.AOS) { AOS.refreshHard() }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      // A theme.QtySelector for each quantity control in scope (the drawer's form; on the cart page the root at load and
      // the swap region after each swap, whose nodes are new, so no control is ever bound twice). Their cart:quantity
      // events come back to drawerQuantityChanged or quantityChanged.
      initQtySelectors: function (scope) {
        if (!scope) {
          return;
        }
        scope.querySelectorAll(selectors.qtySelector).forEach(el => {
          new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      // The drawer's quantity event (drawer mode), as before Phase D.
      drawerQuantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        const parent = el.closest('.cart__item')

        const qtyElements = parent.querySelectorAll('.js-qty__info .__qty')

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }


        theme.cart.changeItem(key, qty)
          .then(function (cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }

            this.buildCart();

            if (el) {
              el.classList.remove('is-loading');
            }
            qtyElements.forEach(item => {
              item.innerHTML = qty
            })

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          }.bind(this))
          .catch(function (XMLHttpRequest) { });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      // D1.2: the header counts have one writer, theme.cart.updateCount (this body moved there in Phase D Task 2), so
      // every cart job and this form write them the same way. Kept as a method: cartMarkup calls it.
      updateCount: function (count) {
        theme.cart.updateCount(count);
      },

      /*==========================================================================
        The cart page (data-location="page"; spec D2.1, D4)
      ==========================================================================*/

      // The cart page's wiring. Everything is delegated from this.root ([data-cart-root], never replaced), so it
      // survives every swap and works on an empty cart: a Remove's click and the form's submit (the form is the submit's
      // target: a swap replaces it, and an empty cart has none). The quantity event and cart:build come on the document,
      // a back-forward-cache restore on the window. The note field has no listener: since lead ruling seq 53 the cart
      // page makes no AJAX note save (a recorded D4 deviation). The field (name="note", in #CartPageForm) rides the
      // checkout POST, and Shopify's form handler saves its text as the cart's note.
      initPage: function (form) {
        this.root = form.closest('[data-cart-root]') || form;
        this.sectionId = this.root.dataset.sectionId;
        // The lines with a queued or running job, by tapped key. It is a Map, not a plain Set of keys, because each key
        // keeps its tapped variant id: the line a queued change will be sent to after Shopify re-keyed it is still found
        // and marked busy after a swap (syncBusy).
        this.pendingKeys = new Map();
        // This form's jobs queued or running (changes and refreshes; track): while above 0 every checkout button is
        // disabled (syncBusy) and a submit is cancelled (onSubmit), and a wanted reload waits for it to reach 0.
        this.pendingJobs = 0;
        // The running change job's record (changeJob), which swap reads for focus and syncBusy for its line; null between
        // change jobs.
        this.current = null;
        // Set when a refresh answered but its render could not be shown: the cart page is then loaded once this form's
        // last job has ended (track), unless a later job's verified swap has shown the server's cart meanwhile (swap
        // clears it, final gate F1).
        this.reloadWanted = false;
        // True from the moment a checkout submit really goes ahead (onSubmit's last branch, the one place that sets it)
        // until the page comes back from the back-forward cache (onPageShow): once a native submission proceeds, the
        // page either unloads or is restored that way (final gate round 3, H1 = R3B3: a change never ends it; only a
        // later listener that cancels that very submit takes it back, onSubmit). While it is true no wanted reload
        // navigates (track), no refresh runs (refreshJob) and Remove and quantity taps are ignored (runChange), so nothing
        // competes with the checkout navigation.
        this.leaving = false;

        this.initQtySelectors(this.root);
        this.root.addEventListener('click', this.onRemoveClick.bind(this));
        this.root.addEventListener('submit', this.onSubmit.bind(this));
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
        document.addEventListener('cart:build', () => {
          this.refresh();
        });
        window.addEventListener('pageshow', this.onPageShow.bind(this));
      },

      // A Remove (either layout's [data-cart-remove] link) as one cart job at quantity 0 (D2.1). A click on a line that
      // already has a job is swallowed, so a line has one job at a time (its links are aria-disabled meanwhile). A link
      // outside a keyed line is left to its href, the no-JS path.
      onRemoveClick: function (evt) {
        const link = evt.target.closest(page.remove);
        const row = link && this.root.contains(link) ? link.closest(page.row) : null;
        if (!row || !row.dataset.key) {
          return;
        }
        evt.preventDefault();
        if (this.isBusy(row)) {
          return;
        }
        this.runChange(this.targetOf(row), 0, this.controlIndex(row, link));
      },

      // The hidden quantity controls' event (theme.QtySelector: cart:quantity.cart-page, detail [key, qty, el]) as one
      // cart job; 0 removes the line (before Phase D, !qty rejected it). Ignored: a quantity that is not a whole number
      // of 0 or more (QtySelector can hand over the min attribute's text), and a line that already has a job.
      quantityChanged: function (evt) {
        const detail = evt.detail || [];
        const key = detail[0];
        const qty = Number(detail[1]);
        if (!key || !Number.isInteger(qty) || qty < 0 || this.pendingKeys.has(key)) {
          return;
        }
        const row = this.rowByKey(key);
        if (row && this.isBusy(row)) {
          return;
        }
        // Without a row the variant is unknown (NaN), so resolveLineTarget can only use the key or refuse.
        const target = row ? this.targetOf(row) : { key: key, variantId: NaN };
        this.runChange(target, qty, row ? this.controlIndex(row, document.activeElement) : -1);
      },

      // One change of one line as a job of theme.cart's queue (D2.1, D4). target is { key, variantId } as tapped,
      // quantity the line's new absolute quantity (0 removes it), control the index of the line's control that started
      // it (focusAfterSwap). From this call until the job ends the line is busy and every checkout button is disabled.
      // The messages are cleared here, at the tap (final gate F8, Claude M3), not when the job starts: a job queued
      // behind a failing one would otherwise wipe that failure's message within milliseconds and then announce
      // "updated" while the failed line is still on the page. While a checkout submit is leaving the page (leaving,
      // final gate round 3, H1 = R3B3) the tap is ignored and no job is queued: its request, its refresh or a reload
      // could compete with the checkout navigation (the Remove link's own navigation is already prevented,
      // onRemoveClick). Resolves when the job has ended, whatever its outcome (at once for an ignored tap); never rejects.
      runChange: function (target, quantity, control) {
        if (this.leaving) {
          return Promise.resolve();
        }
        this.clearMessages();
        this.pendingKeys.set(target.key, target.variantId);
        return this.track(
          () => this.changeJob(target, quantity, control),
          () => this.pendingKeys.delete(target.key)
        );
      },

      // A refresh of the section from the server (refreshJob) as a job of theme.cart's queue, for a back-forward-cache
      // restore and cart:build. Resolves when it has ended; never rejects.
      refresh: function () {
        return this.track(() => this.refreshJob(null));
      },

      // Runs job (an async function that calls theme.cart.request() only, the job rule) as one job of theme.cart's
      // queue, counted in pendingJobs from now until it ends. Every cart job of this form goes through here: a change
      // (runChange) and a refresh (refresh). The end is the job's own finally, so the next job starts from released
      // state: release() (the job's bookkeeping), the count, then the busy marks and checkout buttons (syncBusy). A throw
      // in the theme's code is logged and released like any outcome. When a refresh asked for it (reloadWanted) and no
      // later swap has shown a verified render since (swap clears it, F1), the cart page is loaded once the last of this
      // form's jobs has ended, so a removal already queued is still sent first; never while a checkout is leaving the
      // page (leaving): a refresh queued then (cart:build) ends while an earlier reload may still be wanted, and loading
      // it would cut off the checkout navigation.
      track: function (job, release) {
        this.pendingJobs += 1;
        this.syncBusy();
        return theme.cart.enqueue(async () => {
          try {
            await job();
          } catch (err) {
            console.error('[CartForm] a cart job stopped on an error in the theme code', err);
          } finally {
            if (release) release();
            this.current = null;
            this.pendingJobs -= 1;
            this.syncBusy();
            if (this.pendingJobs === 0 && this.reloadWanted && !this.leaving) location.assign(theme.routes.cartPage);
          }
        });
      },

      // The body of one change job (inside the job, so theme.cart.request() only). In order:
      //  1. Send-time resolution (D4): the tapped line against the newest cart JSON the queue holds (latestCart; with
      //     none yet on this page, the tapped key). The line already gone: nothing is sent, a refresh. Several lines
      //     share its variant and its key is gone: never guess, a refresh and update_error.
      //  2. POST /cart/change.js with bundled section rendering (sections, and sections_url = theme.routes.cartPage, the
      //     locale-aware cart path, spec section 10): one request does the change and returns main-cart's new render.
      //  3. A confirmed reply (a 2xx cart) whose section rendered (not null) and shows exactly that cart (swap checks it
      //     with matchesCart): swapped in, then the bubble, cart:updated and the announcement (committed).
      //  4. Anything else, a confirmed reply whose render cannot be shown included: a refresh, which shows the server's
      //     state and takes the message from it (refreshJob, outcomeMessage).
      changeJob: async function (target, quantity, control) {
        // Only the polite live region is emptied when the job starts, so this job's "updated" is a change that assistive
        // technology announces even after an earlier job's identical one. The message area keeps an earlier job's error
        // until the next tap (runChange, F8).
        this.announce('');
        const resolved = theme.cart.resolveLineTarget(target, theme.cart.latestCart);
        // key: the key sent, or the tapped one when nothing is sent. reply stays null when nothing is sent. before: the keys
        // of the lines of the target's variant as the page knows them now, which lineOf compares a later cart with (cp5
        // round 4).
        const key = resolved.key || target.key;
        const change = { target: target, quantity: quantity, control: control, key: key, refused: !!resolved.refuse, reply: null, before: this.variantKeys(target.variantId, key) };
        this.current = change;
        if (!resolved.key) {
          return this.refreshJob(change);
        }
        change.reply = await theme.cart.request(theme.routes.cartChange, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: resolved.key, quantity: quantity, sections: [this.sectionId], sections_url: theme.routes.cartPage })
        });
        const cart = theme.cart.classifyChange(change.reply) === 'confirmed' ? change.reply.body : null;
        const html = cart && cart.sections ? cart.sections[this.sectionId] : null;
        if (typeof html === 'string' && this.swap(html, cart)) {
          return this.committed(cart);
        }
        return this.refreshJob(change);
      },

      // A refresh inside a job (theme.cart.request() only): main-cart's section (GET <cart path>?section_id=<id>, as
      // text) and the cart (GET /cart.js), together and cache-busted. change is the change job's record, or null for a
      // plain refresh (pageshow, cart:build), which shows no message. The outcomes (spec D2.1, "Failure"):
      //  - both answered, the cart read is a cart and the section shows exactly it: swapped in, the bubble from that
      //    cart, and for a change the message from what that cart shows (outcomeMessage);
      //  - either read failed on the network or at its deadline: the DOM stays as it was, the job's end releases every
      //    busy state and checkout button (safe: checkout no longer posts the page's quantities, onSubmit), and a change
      //    shows update_error. No navigation: on a dead network it would replace the page with the browser's error page;
      //  - answered but unusable (not a 2xx, a cart read that is not a cart, no section, or a section of another cart
      //    state): the server is reachable and a full render is the truth, so the cart page is loaded once this form's
      //    jobs have ended (track), unless a later job's verified swap shows the server's cart first (swap, F1).
      // While a checkout is leaving the page (leaving, G1 = R2B1) no refresh runs: it would swap or ask for a reload
      // under the checkout navigation. (A change job cannot reach here then: a submit goes ahead only with no job
      // pending, and no change starts while the page is leaving, runChange; only a refresh queued meanwhile can.)
      refreshJob: async function (change) {
        if (this.leaving) {
          return;
        }
        const bust = Date.now();
        const replies = await Promise.all([
          theme.cart.request(theme.routes.cartPage + '?section_id=' + encodeURIComponent(this.sectionId) + '&t=' + bust,
            { credentials: 'same-origin', method: 'GET' }, 'text'),
          theme.cart.request(theme.routes.cart + '?t=' + bust, { credentials: 'same-origin', method: 'GET' })
        ]);
        const section = replies[0];
        const read = replies[1];
        if (section.status === null || read.status === null) {
          if (change) this.showMessage(this.copy('msgUpdateError'));
          return;
        }
        const cart = theme.cart.classifyChange(read) === 'confirmed' ? read.body : null;
        const shown = section.status >= 200 && section.status < 300 && !!cart && this.swap(section.body, cart);
        if (!shown) {
          this.reloadWanted = true;
          return;
        }
        theme.cart.updateCount(cart.item_count);
        if (change) this.outcomeMessage(change, cart);
      },

      // A change the page now shows: the header bubble from the same cart (D2.1), cart:updated with that cart JSON (D4),
      // and the polite announcement of cart.general.updated.
      committed: function (cart) {
        theme.cart.updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        this.announce(this.copy('msgUpdated'));
      },

      // The message of a change that did not confirm in place, from the refreshed cart (spec D2.1): the change visible
      // there counts as done (committed: updated announced, no error). Otherwise Shopify's description when the reply
      // carried one and the key sent still names a line of that cart, else update_error; an ambiguous target (refused)
      // is always update_error. The status code alone never decides: Shopify can answer 400 to a bundled-section request
      // whose change succeeded, and an error for a key that is no longer in the cart. That error answers a key the page
      // no longer shows (Shopify re-keyed the line, or it is gone), and its description ("no valid id or line
      // parameter") is nothing a shopper can act on, so update_error is shown instead (cp5 round 4).
      outcomeMessage: function (change, cart) {
        if (!change.refused && this.changeShown(change, cart)) {
          return this.committed(cart);
        }
        const body = change.reply ? change.reply.body : null;
        const keyed = cart.items.some((item) => item.key === change.key);
        const described = !change.refused && keyed && !!body && typeof body === 'object' && typeof body.description === 'string' && body.description;
        this.showMessage(described || this.copy('msgUpdateError'));
      },

      // Whether cart shows the change, judged by the line's identity (lineOf), never by its key's absence alone (cp5
      // round 4): Shopify re-keys a line as its characteristics change, and answers a key it no longer has with 400,
      // changing nothing, so a line can survive a removal under a new key. A quantity change shows when its line is at
      // the new quantity. A removal shows when no line is the target and the target's variant has fewer lines than when
      // the change was sent (before). Without a usable variant id nothing proves a removal, since the key's absence alone
      // does not.
      changeShown: function (change, cart) {
        const line = this.lineOf(change, cart);
        if (change.quantity !== 0) {
          return !!line && line.quantity === change.quantity;
        }
        const left = cart.items.filter((item) => item.variant_id === change.target.variantId).length;
        return !line && Number.isInteger(change.target.variantId) && left < change.before.length;
      },

      // The line of cart that is change's target, or null (spec D2.1 "if the line remains", D4; cp5 round 4). It is found
      // by the key the change was sent with. Failing that, since Shopify re-keys a line as its characteristics change
      // (discount applications included), it is the one line of the target's variant whose key is new, provided that
      // variant has as many lines as when the change was sent (change.before), so none of them has gone. null when the
      // line is gone, or when it cannot be told from its variant's other lines (two of them re-keyed, a line added or
      // removed meanwhile): never a guess, so a same-variant sibling is never taken for the target.
      lineOf: function (change, cart) {
        const byKey = cart.items.find((item) => item.key === change.key);
        if (byKey) {
          return byKey;
        }
        const lines = cart.items.filter((item) => item.variant_id === change.target.variantId);
        const fresh = lines.filter((item) => !change.before.includes(item.key));
        return lines.length === change.before.length && fresh.length === 1 ? fresh[0] : null;
      },

      // The keys of variantId's lines as this page knows them now (a change's before; lineOf). They come from the newest
      // cart JSON the queue holds (latestCart), else from this page's rows, which are then the page's own render: every
      // swap comes with a cart JSON, so latestCart is set from the first swap on. key, the key a change is sent with, is
      // always among them.
      variantKeys: function (variantId, key) {
        const cart = theme.cart.latestCart;
        const keys = cart
          ? cart.items.filter((item) => item.variant_id === variantId).map((item) => item.key)
          : Array.from(this.root.querySelectorAll(page.row)).filter((row) => Number(row.dataset.variantId) === variantId).map((row) => row.dataset.key);
        return keys.includes(key) ? keys : keys.concat(key);
      },

      // Puts a fresh render of main-cart in place (D2.1) and returns true; or returns false and changes nothing when
      // html holds no [data-cart-contents], or its render does not show exactly cart (theme.cart.matchesCart: the raw
      // count and total, and every line's key and quantity in order). On a swap:
      //  - the region's children and its own attributes become the fresh render's (rows, both summaries, the O-B6 block,
      //    the terms, the empty state), so the page shows what a reload would;
      //  - input in progress survives: the note's text and the terms box keep their live values (restoreInputs);
      //  - the QtySelectors are made again on the new nodes (initQtySelectors);
      //  - the lines with a queued job are marked busy again and, while a job is pending, the new checkout buttons are
      //    disabled, since the fresh render arrives enabled (syncBusy);
      //  - focus goes where spec section 5 says (focusPlan, then focusAfterSwap).
      swap: function (html, cart) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(page.contents);
        const region = this.root.querySelector(page.contents);
        if (!fresh || !region || !theme.cart.matchesCart(fresh, cart)) {
          return false;
        }
        const plan = this.focusPlan(region);
        const live = this.liveInputs(region);
        Array.from(region.attributes).forEach((attr) => {
          if (!fresh.hasAttribute(attr.name)) region.removeAttribute(attr.name);
        });
        Array.from(fresh.attributes).forEach((attr) => region.setAttribute(attr.name, attr.value));
        // The note's text in progress is the swap's to keep (cp5 round 2): restoreInputs moves it into the fresh render's
        // note field, and the checkout POST carries it from there.
        region.replaceChildren(...fresh.childNodes);
        // The page now shows a render verified against its own cart answer, so a reload an earlier refresh wanted (it
        // answered but could not be shown, refreshJob) is no longer needed (final gate F1, Codex C1). Without this the
        // queue's drain still loaded the cart page over this verified render and lost the focus set below. A later
        // unusable refresh sets it again.
        this.reloadWanted = false;
        this.restoreInputs(region, live);
        this.initQtySelectors(region);
        this.syncBusy();
        this.focusAfterSwap(region, plan, cart);
        return true;
      },

      // Writes the busy state from the bookkeeping, so no mark outlives its job (it runs at every tap, swap and job
      // end). A line is busy while it has a job: its tapped key, and for a change still queued the line that key
      // resolves to in the newest cart (resolveLineTarget: the line the change will be sent to, after Shopify re-keyed
      // it). The running change (this.current) was resolved when it was sent: its line is the key it sent, and after a
      // swap the line lineOf identifies with certainty under a new key (cp5 round 4: a line that survived a refused
      // removal, re-keyed, stays busy until its job ends). Never the variant fallback (cp5 round 2): once a removal is
      // answered its key is gone, and the fallback would name another line of the same variant (other properties),
      // marking that sibling busy. A busy line has aria-busy="true", the
      // existing is-loading class on its quantity controls (pointer-events: none) and aria-disabled Remove links; a
      // line without a job has none of them, so a released page carries exactly the server's markup. While a job of
      // this form is pending (a change or a refresh), every checkout button is disabled; the ones disabled here are
      // marked data-cart-held and are the only ones enabled again, so a button the server rendered disabled (the O-B6
      // block) stays disabled.
      syncBusy: function () {
        const busy = new Set();
        const running = this.current;
        this.pendingKeys.forEach((variantId, key) => {
          busy.add(key);
          if (running && running.target.key === key) {
            busy.add(running.key);
            const line = theme.cart.latestCart ? this.lineOf(running, theme.cart.latestCart) : null;
            if (line) busy.add(line.key);
            return;
          }
          const found = theme.cart.resolveLineTarget({ key: key, variantId: variantId }, theme.cart.latestCart);
          if (found.key) busy.add(found.key);
        });
        this.root.querySelectorAll(page.row).forEach((row) => {
          const on = busy.has(row.dataset.key);
          if (on) row.setAttribute('aria-busy', 'true');
          else row.removeAttribute('aria-busy');
          row.querySelectorAll(selectors.qtySelector).forEach((el) => {
            // Only a real change is written, so an untouched class attribute keeps the server's exact text.
            if (el.classList.contains(classes.loading) !== on) el.classList.toggle(classes.loading, on);
          });
          row.querySelectorAll(page.remove).forEach((link) => {
            if (on) link.setAttribute('aria-disabled', 'true');
            else link.removeAttribute('aria-disabled');
          });
        });
        const hold = this.pendingJobs > 0;
        this.root.querySelectorAll(selectors.checkoutBtn).forEach((btn) => {
          if (hold && !btn.disabled) {
            btn.disabled = true;
            btn.setAttribute('data-cart-held', '');
          } else if (!hold && btn.hasAttribute('data-cart-held')) {
            btn.disabled = false;
            btn.removeAttribute('data-cart-held');
          }
        });
      },

      // Where focus is before a swap, as data that finds the same place among the new nodes (focusAfterSwap). null when
      // focus is outside the swap region: a swap never pulls a shopper's focus from elsewhere. own when focus is on the
      // running change's line, or nowhere (the body: Safari focuses no link on a click), so the changed line's rule
      // applies: then control is the index of the line's control that has (or, with no focus, took) the action, remove
      // the index of that Remove among the line's Remove links (its layout), and next and prev the lines around it.
      // Otherwise the plan names the focused control by its line and index, by its id (the note with its caret, the
      // terms box), or by its index among the region's controls.
      focusPlan: function (region) {
        const active = document.activeElement;
        const lost = !active || active === document.body;
        if (!lost && !region.contains(active)) {
          return null;
        }
        const change = this.current;
        const row = lost ? null : active.closest(page.row);
        const rows = Array.from(region.querySelectorAll(page.row));
        const i = change ? rows.findIndex((r) => r.dataset.key === change.key) : -1;
        if (change && (lost || (row && row === rows[i]))) {
          const control = lost ? change.control : this.controlIndex(row, active);
          const el = i >= 0 ? rows[i].querySelectorAll(page.focusable)[control] : null;
          return {
            own: true,
            control: control,
            remove: i >= 0 ? Array.from(rows[i].querySelectorAll(page.remove)).indexOf(el) : -1,
            next: rows[i + 1] && i >= 0 ? this.targetOf(rows[i + 1]) : null,
            prev: i > 0 ? this.targetOf(rows[i - 1]) : null
          };
        }
        if (lost) {
          return null;
        }
        if (row) {
          return { line: this.targetOf(row), control: this.controlIndex(row, active) };
        }
        if (active.id) {
          return { id: active.id, start: active.selectionStart, end: active.selectionEnd, scroll: active.scrollTop };
        }
        return { index: Array.from(region.querySelectorAll(page.focusable)).indexOf(active) };
      },

      // Moves focus after a swap by the plan (focusPlan, then focusByPlan; spec section 5). Focus was in the region, so
      // when the fresh render has no place for it, it goes to the empty-state message (tabindex="-1" in the markup),
      // never to the body: the cart emptied, and the line, the note or the checkout button it was on is gone (cp5 round 4).
      focusAfterSwap: function (region, plan, cart) {
        if (!plan) {
          return;
        }
        this.focusByPlan(region, plan, cart);
        const empty = region.querySelector(page.empty);
        if (empty && !region.contains(document.activeElement)) empty.focus();
      },

      // Puts focus where the plan says, when that place is in the fresh render. The changed line: its own control if the
      // line remains, else the next line's Remove, else the previous line's; a Remove is taken from the layout that was
      // used, when that one is visible. The changed line is found by its identity (lineOf: the key sent, or a certain
      // re-key), never by a key's absence or a variant guess (cp5 rounds 2 and 4). So a removal Shopify refused keeps
      // focus on that line's Remove, under its new key too (a one-line cart included); and a same-variant sibling is never
      // taken for a removed line, whose control index can name another control there (its property link). Any other
      // focused control gets its new copy back, the note with its caret. Other lines are found by key, or by variant
      // after a re-key (lineIn).
      focusByPlan: function (region, plan, cart) {
        if (plan.own) {
          const change = this.current;
          const line = this.lineOf(change, cart);
          const same = line ? this.rowByKey(line.key) : null;
          const near = same ? null : this.lineIn(region, plan.next, cart) || this.lineIn(region, plan.prev, cart);
          // The line remains: a removal keeps focus on its Remove; a quantity change on its own control, else its Remove.
          if (same && (change.quantity === 0 || !this.focusControl(same, plan.control))) this.focusRemove(same, plan.remove);
          if (near) this.focusRemove(near, plan.remove);
          return;
        }
        if (plan.line) {
          const line = this.lineIn(region, plan.line, cart);
          if (line) this.focusControl(line, plan.control);
          return;
        }
        if (plan.id) {
          const el = Array.from(region.querySelectorAll('[id]')).find((e) => e.getAttribute('id') === plan.id);
          if (!el) return;
          el.focus();
          // The note's caret and scroll, where the shopper was typing (a checkbox has no selection: null).
          if (typeof plan.start === 'number' && typeof el.setSelectionRange === 'function') el.setSelectionRange(plan.start, plan.end);
          if (plan.scroll) el.scrollTop = plan.scroll;
          return;
        }
        const el = region.querySelectorAll(page.focusable)[plan.index];
        if (el) el.focus();
      },

      // Focuses a line's control by its index among the line's controls; false when there is none or it cannot take
      // focus (a hidden quantity control, a disabled button).
      focusControl: function (row, index) {
        const el = index >= 0 ? row.querySelectorAll(page.focusable)[index] : null;
        if (!el) {
          return false;
        }
        el.focus();
        return document.activeElement === el;
      },

      // Focuses a line's Remove: the one at index (the layout that was used) when it is visible, else the first visible.
      focusRemove: function (row, index) {
        const links = Array.from(row.querySelectorAll(page.remove));
        const shown = (el) => !!el && el.getClientRects().length > 0;
        const link = shown(links[index]) ? links[index] : links.find(shown);
        if (link) link.focus();
      },

      // The line of target ({ key, variantId }) among region's rows: by its key, or by the key resolveLineTarget finds in
      // cart after a re-key; null when it is gone.
      lineIn: function (region, target, cart) {
        if (!target) {
          return null;
        }
        const rows = Array.from(region.querySelectorAll(page.row));
        const found = theme.cart.resolveLineTarget(target, cart);
        return rows.find((r) => r.dataset.key === target.key) || (found.key ? rows.find((r) => r.dataset.key === found.key) : null) || null;
      },

      // The live state a swap keeps (spec D2.1, "a swap never discards input in progress"): the note's text when it is
      // not the note of the render the field came from (its defaultValue; an untouched note takes the fresh render, which
      // prints the server's note), and the terms box's checked state (the fresh render prints it unticked). cp5 round 2
      // judged the text against the note the server held as the page last learned it (noteServer), because the page's
      // own saves made the render's note stale; with no AJAX save (lead ruling seq 53) the page learns a note only from a
      // render, so that is the field's defaultValue again.
      liveInputs: function (region) {
        const note = region.querySelector(selectors.cartNote);
        const terms = region.querySelector(selectors.termsCheckbox);
        return {
          note: note && note.value !== note.defaultValue ? note.value : null,
          terms: terms ? terms.checked : null
        };
      },

      // Writes liveInputs' state into the fresh nodes: the live text into the fresh note field's value (its defaultValue
      // stays the fresh render's note), the box's state into the fresh box. With no fresh field (the empty cart prints
      // none) a typed note goes with the lines: the page saves no note itself (lead ruling seq 53; cp5 round 3's save at
      // this point is gone), and an empty cart has no checkout to carry it.
      restoreInputs: function (region, live) {
        const note = region.querySelector(selectors.cartNote);
        const terms = region.querySelector(selectors.termsCheckbox);
        if (note && live.note !== null) note.value = live.note;
        if (terms && live.terms !== null) terms.checked = live.terms;
      },

      // The cart page form's submit (checkout), delegated from the root because a swap replaces the form. While a job of
      // this form is pending (a change or a refresh) the submit is cancelled (the checkout buttons are disabled then;
      // this also stops a submit from elsewhere, an implicit Enter). The terms check stays: an unticked box cancels it.
      // Then every updates[] input is disabled, so the POST carries no quantities: every change has been committed by its
      // own job, and Shopify applies updates[] by position, so a page showing a cart it has not confirmed could re-apply
      // stale quantities. Checkout starts from the server's cart, whatever the page shows (spec D2.1). The note field
      // stays enabled: the POST carries its text, and Shopify saves it as the cart's note (the page makes no AJAX note
      // save, lead ruling seq 53). If a later listener cancels the submit, the inputs come back. Without JS nothing
      // changes: then no change is ever made in place. Only a submit that goes ahead marks the page as leaving, here, once
      // every check has passed (final gate round 3, H1), so no wanted reload, refresh or change competes with its
      // navigation (R3B3). A later listener that cancels this very submit means it never left: the inputs, the button's
      // look and the mark then come back.
      onSubmit: function (evt) {
        const form = evt.target;
        if (!form || typeof form.getAttribute !== 'function' || form.getAttribute('id') !== 'CartPageForm') {
          return;
        }
        if (this.pendingJobs > 0) {
          evt.preventDefault();
          return;
        }
        const terms = form.querySelector(selectors.termsCheckbox);
        if (terms && !terms.checked) {
          alert(theme.strings.cartTermsConfirmation);
          evt.preventDefault();
          return;
        }
        const button = evt.submitter && evt.submitter.matches(selectors.checkoutBtn) ? evt.submitter : form.querySelector(selectors.checkoutBtn);
        if (button) button.classList.add(classes.btnLoading);
        const inputs = Array.from(form.querySelectorAll(page.updates)).filter((el) => !el.disabled);
        inputs.forEach((el) => {
          el.disabled = true;
        });
        this.leaving = true;
        setTimeout(() => {
          if (!evt.defaultPrevented) return;
          inputs.forEach((el) => {
            el.disabled = false;
          });
          if (button) button.classList.remove(classes.btnLoading);
          this.leaving = false;
        }, 0);
      },

      // A back-forward-cache restore (pageshow, persisted): the cart may have changed meanwhile (another tab, the
      // checkout), so one refresh job is queued. A submit's loading dim is cleared first, and the leaving mark ended (H1:
      // the one place that ends it): the restored page is not checking out, so it refreshes, reloads and takes taps as
      // usual again.
      onPageShow: function (evt) {
        if (!evt.persisted) {
          return;
        }
        this.leaving = false;
        this.root.querySelectorAll(selectors.checkoutBtn).forEach((btn) => {
          if (btn.classList.contains(classes.btnLoading)) btn.classList.remove(classes.btnLoading);
        });
        this.refresh();
      },

      // Shows one message in the section's message area ([data-cart-message], role alert, outside the swap region) as
      // plain text in the theme's .errors style; an empty text clears it. It moves neither the page nor focus (lead ruling
      // seq 58, H9): role="alert" announces the message, and the line it is about stays visibly unchanged. The spec never
      // asked for a scroll; round 1 added one (F8, Claude M3), but telling a keyboard user's focus, which must stay in view
      // (WCAG 2.4.7), from a tap's is a heuristic with a long tail: rounds 3-8 and the re-reviews each found one more input
      // sequence its guard misread (:focus-visible M3, html.tab-outline R6B1/R6B2, the last input R7C1/R7B1, then A1), so
      // seq 58 removed it. A visible per-line message is the later improvement (the R2C3 and R4B3 family); the gate's
      // triage.md and the spec hold the history.
      showMessage: function (text) {
        const el = this.root.querySelector(page.message);
        if (!el) {
          return;
        }
        el.textContent = text || '';
        el.classList.toggle('errors', !!text);
      },

      // Empties the message area and the live region at a tap (runChange), so a new attempt starts clean and each
      // outcome's text is a change that assistive technology announces.
      clearMessages: function () {
        this.showMessage('');
        this.announce('');
      },

      // Writes the polite live region ([data-cart-status], outside the swap region).
      announce: function (text) {
        const el = this.root.querySelector(page.status);
        if (el) el.textContent = text;
      },

      // One cart page string from the root's data- attributes (msgUpdated, msgUpdateError; sections/main-cart.liquid).
      // dataset returns the decoded text: Liquid prints t output HTML-escaped and the attribute parser decodes it once
      // (G19). '' when the attribute is missing.
      copy: function (name) {
        return this.root.dataset[name] || '';
      },

      // True while a line has a job: its key among the tapped keys, or (for a line Shopify re-keyed) its aria-busy mark
      // while a job of this form is pending. Once the queue has drained no line is ever refused, whatever a mark says.
      isBusy: function (row) {
        return this.pendingKeys.has(row.dataset.key) || (this.pendingJobs > 0 && row.getAttribute('aria-busy') === 'true');
      },

      // The line row whose data-key is key, or null (keys are compared as strings, never put in a selector).
      rowByKey: function (key) {
        return Array.from(this.root.querySelectorAll(page.row)).find((row) => row.dataset.key === key) || null;
      },

      // A line's target as a queued change records it: its key and its variant id (Number, so resolveLineTarget refuses
      // a missing one rather than guess).
      targetOf: function (row) {
        return { key: row.dataset.key, variantId: Number(row.dataset.variantId) };
      },

      // The index of el among a line's controls (page.focusable, document order); -1 when it is not one of them.
      controlIndex: function (row, el) {
        return Array.from(row.querySelectorAll(page.focusable)).indexOf(el);
      }
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      wrapper: '.collapsible-wrapper',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    async function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
      var closeElHeight = 0;

      var wrapper = evt.target.closest(selectors.wrapper)
      async function closeSiblings(wrapper) {
        if (wrapper) {
          let siblings = getSiblings(wrapper);
          let promises = siblings.map(async openItem => {
            let target = openItem.querySelector(selectors.trigger);
            let opened = target.classList.contains(classes.open);
            let hasChildOpen = openItem.querySelector(selectors.moduleInner).querySelector('.' + classes.open)
            if (hasChildOpen) {
              await closeAccordion(hasChildOpen)
            }
            if (opened) {
              const isClose = await closeAccordion(target);
              closeElHeight = isClose
            }
          });

          await Promise.all(promises);
        }
      }

      await closeSiblings(wrapper)

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var searchWrapper = container.querySelector('.filter-search--wrapper')

      if (searchWrapper) {
        height = height + searchWrapper.offsetHeight
      }

      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height + 1, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : (height + parentCollapsibleEl.offsetHeight) - closeElHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight + 1, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function closeAccordion(el) {
      return new Promise((resolve, reject) => {
        var moduleId = el.getAttribute('aria-controls');
        var container = document.getElementById(moduleId);

        if (!moduleId) {
          moduleId = el.dataset.controls;
        }

        // No ID, bail
        if (!moduleId) {
          return;
        }

        // If container=null, there isn't a matching ID.
        // Check if data-id is set instead. Could be multiple.
        // Select based on being in the same parent div.
        if (!container) {
          var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
          if (multipleMatches.length > 0) {
            container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
          }
        }

        if (!container) {
          return;
        }

        var height = container.querySelector(selectors.moduleInner).offsetHeight;
        var searchWrapper = container.querySelector('.filter-search--wrapper')

        if (searchWrapper) {
          height = height + searchWrapper.offsetHeight
        }

        var isAutoHeight = container.classList.contains(classes.autoHeight);
        var parentCollapsibleEl = container.parentNode.closest(selectors.module);
        var childHeight = height;

        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, true, isAutoHeight);
        }, 0);

        if (!isAutoHeight) {
          height = 0;
        }

        el.setAttribute('aria-expanded', false);
        el.classList.remove(classes.open);

        setTransitionHeight(container, height, true, isAutoHeight);

        // If we are in a nested collapsible element like the mobile nav,
        // also set the parent element's height
        if (parentCollapsibleEl) {
          var parentHeight = parentCollapsibleEl.style.height;

          if (parentHeight === 'auto') {
            childHeight = 0; // Set childHeight to 0 if parent is initially opened
          }

          var totalHeight = parentCollapsibleEl.offsetHeight - childHeight;

          setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
        }
        resolve(childHeight)
      })
    }

    function getSiblings(node) {
      return [...node.parentNode.children].filter(c => c !== node)
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {

        container.style.height = height + 'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        // After the open transition settles, hand the container back to
        // natural height so late content reflows (e.g. images loading) don't
        // clip. Was a jQuery leftover (`o.css('height','auto')`) that would
        // TypeError on a plain DOM node. NOTE: this branch is currently
        // unreachable — the `collapsible--auto-height` class sits on the
        // trigger BUTTONS in liquid while isAutoHeight is read off the
        // content container — but the landmine is defused in case that
        // markup mismatch is ever fixed to enable auto-height behavior.
        window.setTimeout(function () {
          container.style.height = 'auto';
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });

    return Disclosure;
  })();
  // Drawers — generic drawer/modal system used across the theme.
  // Opens/closes off-canvas panels (cart drawer, filter drawer, variant drawer, menu).
  // Listens for clicks on elements with .js-drawer-open-[name] and manages
  // body scroll lock, focus trap, and close-on-overlay-click.
  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Store bound handlers once for proper cleanup
        this._boundOpen = this._boundOpen || this.open.bind(this);
        this._boundClose = this._boundClose || this.close.bind(this);
        this._boundModalClose = this._boundModalClose || this.close.bind(this);

        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this._boundOpen);
        });

        document.addEventListener('drawer-open', this._boundOpen)

        this.drawer.querySelector(this.config.close).addEventListener('click', this._boundClose);

        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', this._boundModalClose);
      },

      destroyListeners: function () {
        document.removeEventListener('drawer-open', this._boundOpen);
        document.removeEventListener('modalOpen', this._boundModalClose);
      },

      getScrollbarWidth: function () {
        const scrollDiv = document.createElement("div");
        scrollDiv.style.visibility = "hidden";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.msOverflowStyle = "scrollbar"; // For older IE
        scrollDiv.style.position = "absolute";
        scrollDiv.style.top = "-9999px";
        scrollDiv.style.width = "100px";
        document.body.appendChild(scrollDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
      },

      open: function (evt, returnFocusEl) {
        var hasTarget = evt.detail.target

        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close

          if (hasTarget) {
            hasTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = hasTarget;
          } else {
            evt.currentTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = evt.currentTarget;
          }

        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        this.drawer.removeAttribute('inert');

        if (this.config.id === 'NavDrawer') {
          var sf = this.drawer.querySelector('.slide-nav__search-field');
          var title = this.drawer.querySelector('.title__placeholder');
          if (sf) sf.classList.remove('disappear');
          if (title) title.textContent = '';
        }

        // Redundant reflow removed — prepareTransition below already forces
        // a reflow via offsetWidth, which commits the inert removal above.

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);
        const scrollbarWidth = this.getScrollbarWidth()
        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
        this.bindEvents();
      },
      close: function (evt) {

        if (window.startTracking) {
          document.documentElement.classList.remove('trigger-from-search-close')
          document.documentElement.classList.remove('track-collection-filter')

          var navDrawer = document.querySelector('#NavDrawer')
          var filterDrawer = document.querySelector('#FilterDrawer')
          var filterDrawerMobile = document.querySelector('#FilterDrawerMobile')

          if (navDrawer) {
            navDrawer.removeAttribute('inert');
            navDrawer.classList.add('drawer--is-open');
          }
          if (filterDrawer) {
            filterDrawer.classList.remove('drawer--is-open');
            filterDrawer.setAttribute('inert', '');
          }
          if (filterDrawerMobile) {
            filterDrawerMobile.classList.remove('drawer--is-open');
            filterDrawerMobile.setAttribute('inert', '');
          }

          if (this.drawer.getAttribute('id') == 'FilterDrawer') this.isOpen = false
          if (this.drawer.getAttribute('id') == 'FilterDrawerMobile') this.isOpen = false
          return
        }

        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        const langNCurDrawer = this.drawer.querySelector('.lang--drawer.is-active')
        const drawerFixedHeader = this.drawer.querySelector('.drawer__fixed-header.is-removed-height')
        if (langNCurDrawer) langNCurDrawer.classList.remove('is-active')
        if (drawerFixedHeader) drawerFixedHeader.classList.remove('is-removed-height')

        this.drawer.setAttribute('inert', '');

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.style.removeProperty('--scrollbar-width')

        if (!document.documentElement.classList.contains('trigger-from--drawer')) {
          document.documentElement.classList.add(this.config.closingClass);
        }

        window.setTimeout(function () {
          document.documentElement.classList.remove(this.config.closingClass);

          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            // Don't steal focus when transitioning from drawer to search
            if (!document.documentElement.classList.contains('trigger-from--drawer')) {
              this.activeSource.focus();
            }
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();

        const accords = this.drawer.querySelectorAll('.accordion-collapse.show')
        const accordsTrigger = this.drawer.querySelectorAll('.accordion-button[aria-expanded="true"]')
        accords.forEach(_ => {
          _.classList.remove('show')
        })
        accordsTrigger.forEach(_ => {
          _.classList.add('collapsed')
          _.setAttribute('aria-expanded', false)
        })
      },
      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function (evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function () {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 350); // modal close css transition (--motion-panel-out + buffer)

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  /*============================================================================
    ParallaxImage
  ==============================================================================*/

  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [1, 0],
        90: [0, -1],
        180: [-1, 0],
        270: [0, 1]
      }

      this._boundScrollHandler = () => this.scrollHandler();

      this.init();
      window.addEventListener('scroll', this._boundScrollHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._boundScrollHandler);
      if (this.timeout) clearTimeout(this.timeout);
    }

    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;

      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));

      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);

      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px

      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360

      const toLeft = angle > 90 && angle < 270;
      const toTop = angle < 180;

      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop ? 'top' : 'bottom'] = 0;

      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [Math.cos(radians), Math.sin(radians) * -1] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }

      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;

      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }

    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();

      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;

      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }

      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }

    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }

      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }

  customElements.define('parallax-image', ParallaxImage);


  /*============================================================================
    AjaxProduct: the one add-to-cart owner of a product form (Phase D, spec D3.1-D3.6 and O2)
    - Every add of the form is one attempt(). The main and sticky Adds and the size drawer's Add submit the form
      natively (the drawer's is type="submit" form="<form id>", snippets/product-template.liquid), so the submit
      listener gets them all and reads the submitter. Each size list's secondary Add (type="button",
      snippets/variant-dropdown.liquid, rendered once per product option) calls attempt('secondary') from its click.
      assets/buy-button.js, which owned the drawer's Add, is gone (E1), so one form can no longer run two adds at
      once (#64 (2)).
    - An attempt is frozen at the tap (the serialized form and its variant id) and runs as one job of theme.cart's
      queue (D4). Its reply falls in exactly one class (theme.cart.classifyAdd): added, rejected or unconfirmed. An
      unconfirmed add is reconciled against /cart.js in the same job and never retried (D3.4).
    - Every state (the loading dim, the inert size pickers, the in-flight guard) is released in a finally (D3.5), as
      soon as the add's outcome is known: the bubble read after it is a queued job of its own (final gate F6).
    - Everything is looked up in the form's product section (this.container) or the form, never in the document,
      so a quick shop beside the product page keeps its own gate, buttons, messages and pickers.
    - The messages' copy comes from the form's live region ([data-add-status], snippets/product-form.liquid): data-
      attributes printing t raw (strings ruling seq 8, G19). theme.strings.addToCartError stays the text of a
      rejected add without Shopify's own description.
  ==============================================================================*/
  theme.AjaxProduct = (function () {
    // One instance per product form (theme.Product initAjaxProductForm, in drawer and hybrid cart modes). submit is
    // the main Add's selector (default .add-to-cart); args.scopedEventId adds scoped twins of the add events.
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      if (this.form) {
        this.container = form.closest('[data-section-type="product"]') || document;
        // The drawer's and the list's Adds sit outside the form and name it with their form attribute (a quick shop
        // rewrites that attribute to its own form's id, theme.Product openModalProduct), so they are found by it.
        // getAttribute, never form.id: the form has a control named id (the no-JS select), and a form's named
        // controls shadow its properties, so form.id is that select element, not the id.
        // secondary is a list: snippets/product-template.liquid renders variant-dropdown once per product option, and
        // each copy carries its own secondary Add, so every one of them belongs to this form (cp3 round 1: binding the
        // first alone left the others dead, the size list's among them when a hidden colour list came first).
        const named = '[form="' + CSS.escape(form.getAttribute('id')) + '"]';
        this.buttons = {
          main: form.querySelector(submit ? submit : '.add-to-cart'),
          sticky: form.querySelector('.add-to-cart--sticky'),
          secondary: Array.from(this.container.querySelectorAll('[data-add-to-cart-secondary]' + named)),
          drawer: this.container.querySelector('[data-add-to-cart-drawer]' + named)
        };
        this.statusEl = form.querySelector('[data-add-status]');
        this.pending = false;
        this.attemptId = 0;
        this.lastVariantId = null;
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
        this.init();
      }
    };

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      // Wires the size list's secondary Add and the clearing of a message when the size really changes.
      init: function () {
        // A secondary Add never submits natively (type="button"), so each one's click is an attempt of its own, with
        // its source known. It used to dispatch a plain Event('submit'), which carries no submitter (spec D3.1).
        this.buttons.secondary.forEach((b) => b.addEventListener('click', () => this.attempt('secondary')));
        // A message belongs to the variant it was shown for (D3.6, #64 (3)). theme.Variants dispatches variantChange on
        // this section for every size tap, a re-tap of the selected size included, so a message clears only when the
        // variant id actually changes. variant is null for an option set that matches no variant.
        this.container.addEventListener('variantChange', (evt) => {
          const variant = evt.detail && evt.detail.variant;
          const id = variant ? variant.id : null;
          if (id !== this.lastVariantId) this.clearMessages();
          this.lastVariantId = id;
        });
      },

      // The form's submit listener: the main, sticky and drawer Adds submit natively. The source is the submitter's
      // key in this.buttons (secondary holds a list, hence the concat). A submit without a submitter (a browser
      // without SubmitEvent.submitter, or a script's requestSubmit()) counts as the drawer's while this section's size
      // drawer is open (not inert), else as the main form's.
      addItemFromForm: function (evt) {
        evt.preventDefault();
        const submitter = evt.submitter;
        const drawer = this.container.querySelector('#OptionDrawer');
        const byButton = Object.keys(this.buttons).find((k) => !!submitter && [].concat(this.buttons[k]).includes(submitter));
        this.attempt(byButton || (!submitter && drawer && !drawer.hasAttribute('inert') ? 'drawer' : 'main'));
      },

      // One add of this form (D3.5), source 'main' | 'sticky' | 'secondary' | 'drawer':
      //  1. no explicit size: the prompt, and no request (O2, D3.2);
      //  2. this form's add still pending: ignored (the double-tap guard, A1: atc_probe stays at 1 POST);
      //  3. the attempt is frozen now, at the tap: the serialized form and its variant id, so a job that waits in the
      //     queue still posts what the shopper chose;
      //  4. from here until the job ends every Add of the form is loading and both size pickers are inert. The job ends
      //     when the add's outcome is known and shown (spec D3.5): the bubble read that may follow is a queued job of
      //     its own (queueCountRead, final gate F6), so the form is never held behind Adds that already look ready;
      //  5. the job runs in theme.cart's queue, and the finally releases everything on every outcome, a throw in the UI
      //     code included (the guard first, so a throw in setBusy can never leave the form locked).
      attempt: async function (source) {
        if (!this.sizeChosen()) return this.promptForSize(source);
        if (this.pending) return;
        const payload = theme.utils.serialize(this.form);
        const variantId = Number(this.form.elements.id.value);
        this.pending = true;
        try {
          this.attemptId += 1;
          const id = this.attemptId;
          this.lastVariantId = variantId;
          this.clearMessages();
          this.setBusy(true);
          await theme.cart.enqueue(() => this.runAdd({ payload: payload, variantId: variantId, source: source, id: id }));
        } catch (err) {
          // Only a throw in the theme's own code lands here (request() never rejects). The state is still released.
          console.error('[AjaxProduct] the add stopped on an error in the theme code', err);
        } finally {
          this.pending = false;
          this.setBusy(false);
        }
      },

      // The size gate (O2, B6b): true when every size list of this section reads data-selected="true". A size tap in
      // either picker sets it (theme.Product initOptionDrawer / initVariantSelector), and so does a sellable ?variant=
      // deep link (snippets/variant-dropdown.liquid). No list at all (a one-size OS product renders no picker) means
      // there is nothing to choose: the gate is open.
      sizeChosen: function () {
        return Array.from(this.container.querySelectorAll('.option-selector--wrapper .option--list'))
          .every((list) => list.dataset.selected === 'true');
      },

      // A gate miss. From the size drawer's Add (O2, D3.2): no request; the drawer stays open, its action area shows
      // the drawer's own size label as the prompt, and focus moves to the first enabled size, so the shopper is told
      // and taken to the choice. The button stays enabled: a disabled one says nothing and leaves the tab order. From
      // the main, sticky or secondary Add: the opener as before, the size drawer above 768 px (where the size list is
      // hidden) and the size list, with selector:open for the sticky bar.
      promptForSize: function (source) {
        if (source === 'drawer') {
          const label = this.container.querySelector('#OptionDrawer .option-label');
          const first = Array.from(this.container.querySelectorAll('#OptionDrawer .btn--option'))
            .find((b) => !b.disabled && b.getClientRects().length > 0);
          this.clearMessages();
          // No size is chosen yet, so the first size tap (any variant id) clears this prompt.
          this.lastVariantId = null;
          this.showMessage('error', label ? label.textContent.trim() : '', 'drawer');
          if (first) first.focus();
          return;
        }
        if (window.innerWidth > 768) {
          const trigger = this.container.querySelector('.js-drawer-open-option');
          if (trigger) trigger.click();
        }
        const list = this.container.querySelector('.option-selector--wrapper');
        if (!list) return;
        list.classList.add('open');
        document.dispatchEvent(new Event('selector:open'));
      },

      // The queued job of one attempt. It posts the frozen payload with theme.cart.request() only (the job rule: a
      // queued wrapper here would wait behind this very job), then acts on the one class of the reply (D3.3):
      //  - added: success();
      //  - rejected (any 4xx): error();
      //  - unconfirmed (the deadline, a network failure, any 5xx, a 2xx without a line): one /cart.js read in this same
      //    job and theme.cart.reconcileVerdict (D3.4). The variant in the bag: the in-bag status. Not in it, or the
      //    read failed: the unconfirmed message. The bubble follows the read whenever it succeeded. Nothing is retried,
      //    and absence is not reported as a rejection: the add may still commit after the read, and "try again" would
      //    invite a duplicate.
      runAdd: async function ({ payload, variantId, source, id }) {
        const reply = await theme.cart.request(theme.routes.cartAdd, {
          method: 'POST',
          body: payload,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const verdict = theme.cart.classifyAdd(reply);
        if (verdict === 'added') return this.success(reply.body, source, id);
        if (verdict === 'rejected') return this.error(reply, source);
        const cart = await this.readCart();
        if (cart) theme.cart.updateCount(cart.item_count);
        if (theme.cart.reconcileVerdict(variantId, cart) === 'in_bag') {
          return this.showMessage('in_bag', this.copy('msgInBag'), source);
        }
        const text = this.copy('msgUnconfirmed');
        this.showMessage('unconfirmed', text, source);
        this.dispatchError(text, source);
      },

      // One /cart.js read inside a job of this form: the add's own (an unconfirmed add's reconcile, D3.4) or the bubble
      // read's (queueCountRead, F6). Always request(), never the queued getCart: the job rule. Cache-busted as getCart
      // is. The cart, or null when the reply is not a confirmed cart (theme.cart.classifyChange).
      readCart: async function () {
        const url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
        const reply = await theme.cart.request(url, { credentials: 'same-origin', method: 'GET' });
        return theme.cart.classifyChange(reply) === 'confirmed' ? reply.body : null;
      },

      // The added outcome (D3.6), with the choreography it had before Phase D: the live region announces it,
      // ajaxProduct:added (and its scoped twin) is dispatched, every Add shows the tick for 500 ms, then the size
      // selectors close (main, sticky, secondary) or the size drawer closes (ajaxProduct:added:close-drawer, which
      // theme.Product initOptionDrawer handles). On the cart page the page reloads, as before. Then one /cart.js read
      // writes the header counts (D1.2) as a queued job of its own (queueCountRead), so this job, and the form's busy
      // state with it, ends at the outcome (final gate F6). If that read fails the counts keep their number: the add
      // itself succeeded.
      success: async function (product, source, id) {
        this.announce(this.copy('msgAdded'));
        // addToCartBtn is the button these events named before Phase D: the drawer's Add for a drawer add (it came from
        // buy-button.js), the main Add for every other add (theme.AjaxProduct), so listeners keep getting one element.
        const detail = { product: product, addToCartBtn: (source === 'drawer' && this.buttons.drawer) || this.buttons.main };
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail }));
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, { detail: detail }));
        }
        // The tick replaces the loading dim, as it did before Phase D (the loading class was cleared first), so it
        // shows at full strength. The in-flight guard and the inert pickers are released when this job ends (attempt),
        // which is right after this: the bubble read below is a job of its own.
        this.eachButton((b) => {
          b.classList.remove('btn--loading');
          b.classList.add('btn--success');
        });
        setTimeout(() => {
          // The tidy-up belongs to its attempt (D3.6, design gate blind pass). Once a newer attempt has started on this
          // form, that attempt owns the buttons, the selectors and the drawer, and has already removed this tick
          // (setBusy), so this timer does nothing: it never closes a drawer or selectors under the newer add.
          if (id !== this.attemptId) return;
          this.eachButton((b) => b.classList.remove('btn--success'));
          if (source === 'drawer') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added:close-drawer', { detail: {} }));
            return;
          }
          this.container.querySelectorAll('.option-selector--wrapper').forEach((w) => w.classList.remove('open'));
          document.dispatchEvent(new Event('selector:close'));
        }, 500);

        // Reload page if adding product from a section on the cart page
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }

        this.queueCountRead();
      },

      // The rejected outcome (D3.3, any 4xx): Shopify's description when the body carries one (a 422's "only N left"),
      // else theme.strings.addToCartError; shown in the message place and carried by ajaxProduct:error. The product form
      // posts quantity 1, so a 422 adds nothing here, but one /cart.js read follows it for the bubble, so the count stays
      // right if a quantity input ever appears (spec D3.3); like success's, that read is a job of its own (F6).
      error: async function (reply, source) {
        const body = reply.body;
        const described = !!body && typeof body === 'object' && typeof body.description === 'string' && body.description;
        const text = described || (theme.strings && theme.strings.addToCartError) || '';
        this.showMessage('error', text, source);
        this.dispatchError(text, source);
        if (reply.status === 422) this.queueCountRead();
      },

      // The bubble read after an add whose outcome is known (success, a 422): one /cart.js read and the header counts
      // from it (D1.2), as a queued job of its own, enqueued and not awaited (final gate F6, Codex B5 = Claude M1).
      // Inside the add's job it held the form busy (pending, inert pickers) behind Adds that already looked ready, so
      // taps were dropped silently for as long as the read took (up to the 15 s deadline on a slow network). FIFO order
      // still puts it after the add and before any later job. Called from inside the add's job, which never awaits
      // it: the job rule allows enqueueing there, never awaiting a queued job. theme.cart.getCart() is this read as a
      // queued wrapper, but the job rule bars wrappers inside a job (one awaited there by mistake deadlocks the queue),
      // so this is a bare enqueue of readCart. An unconfirmed add's read is not this: it decides the outcome (D3.4), so
      // it stays inside the add's job.
      queueCountRead: function () {
        theme.cart.enqueue(async () => {
          const cart = await this.readCart();
          if (cart) theme.cart.updateCount(cart.item_count);
        }).catch((err) => {
          console.error('[AjaxProduct] the bubble read stopped on an error in the theme code', err);
        });
      },

      // ajaxProduct:error (and its scoped twin) for a failed add: the message shown and the attempt's source (#64 (4)).
      dispatchError: function (text, source) {
        const detail = { errorMessage: text, source: source };
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: detail }));
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, { detail: detail }));
        }
      },

      // Every Add of the form at once (D3.5). On: each shows the loading dim (and loses an earlier attempt's tick), and
      // both size pickers of this section turn inert (the drawer's .product-options, the list's .option--list), so the
      // size cannot change under a pending add (#64 (1)); the Adds and the pickers' triggers stay outside them. Off:
      // all of it is released. inert needs Safari 15.5, Chrome 102 or Firefox 112; an older browser ignores it, which
      // leaves the behaviour before Phase D (the size could change), never worse (spec section 10).
      setBusy: function (on) {
        this.eachButton((b) => {
          b.classList.toggle('btn--loading', on);
          if (on) b.classList.remove('btn--success');
        });
        this.container.querySelectorAll('#OptionDrawer .product-options, .variant-input-wrap .option--list')
          .forEach((el) => el.toggleAttribute('inert', on));
      },

      // Shows one attempt's message (D3.6) as plain text (textContent) plus, for in_bag and unconfirmed, a link to the
      // bag built as an element (D3.4). Each carries data-add-message="<kind>" (clearMessages removes them by it). The
      // error and unconfirmed messages are alerts in the theme's .errors style. The in-bag one is neutral news (final
      // gate F7, Claude M2): the theme's neutral .note box with no live role, and its text goes to the form's
      // persistent polite region ([data-add-status], announce). A live region inserted already populated is announced
      // unreliably (NVDA and JAWS with Chrome often say nothing), and a shopper who hears no outcome may tap again: the
      // duplicate D3.4 is there to avoid. Its place: the size drawer's action area when the attempt came from the
      // drawer and the drawer is still open (the form sits behind the drawer and its overlay, Phase A O9), otherwise the
      // form. An empty text shows nothing.
      showMessage: function (kind, text, source) {
        if (!text) return;
        const el = document.createElement('div');
        el.setAttribute('data-add-message', kind);
        if (kind === 'in_bag') {
          el.classList.add('note', 'text-center');
          this.announce(text);
        } else {
          el.classList.add('errors', 'text-center');
          el.setAttribute('role', 'alert');
        }
        el.textContent = text;
        const bagUrl = this.copy('bagUrl');
        const bagLabel = this.copy('bagLabel');
        if (kind !== 'error' && bagUrl && bagLabel) {
          const link = document.createElement('a');
          link.href = bagUrl;
          link.textContent = bagLabel;
          el.append(' ', link);
        }
        const drawer = this.container.querySelector('#OptionDrawer');
        const action = source === 'drawer' && drawer && !drawer.hasAttribute('inert') ? drawer.querySelector('.drawer--action') : null;
        if (action) {
          action.prepend(el);
        } else {
          this.form.append(el);
        }
      },

      // Removes this form's messages from both places one can sit (the form and the size drawer's action area): the
      // .errors ones and, since the in-bag message has no .errors (F7), every [data-add-message]. Then it empties the
      // live region, so each attempt starts clean and its announcement is a change.
      clearMessages: function () {
        const action = this.container.querySelector('#OptionDrawer .drawer--action');
        [this.form, action].forEach((place) => {
          if (place) place.querySelectorAll('.errors, [data-add-message]').forEach((old) => old.remove());
        });
        if (this.statusEl) this.statusEl.textContent = '';
      },

      // Writes the form's polite live region ([data-add-status]). It sits outside the size drawer, which closes and
      // turns inert after an add, so a confirmed add is announced either way (D3.6), and so is the in-bag outcome (F7).
      announce: function (text) {
        if (this.statusEl) this.statusEl.textContent = text;
      },

      // One string the messages need, from the live region's data- attributes (msgAdded, msgInBag, msgUnconfirmed,
      // bagLabel, bagUrl; snippets/product-form.liquid). dataset returns the decoded text: Liquid prints t output
      // HTML-escaped and the attribute parser decodes it once (G19). '' when the element is missing.
      copy: function (name) {
        return (this.statusEl && this.statusEl.dataset[name]) || '';
      },

      // Runs fn on each Add of the form that exists, every secondary Add included (flat: secondary is a list). A
      // one-size OS product renders no size list, so no secondary Add; a section without a size drawer has no drawer
      // Add.
      eachButton: function (fn) {
        Object.values(this.buttons).flat().forEach((b) => {
          if (b) fn(b);
        });
      }
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };

      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        if (!this.plus.hasListenerAttached) {
          this.plus.addEventListener('click', function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this));
          this.plus.hasListenerAttached = true
        }


        if (!this.minus.hasListenerAttached) {
          this.minus.addEventListener('click', function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this));
          this.minus.hasListenerAttached = true
        }

        this.input.addEventListener('change', function (evt) {
          this._change(this._getQty());
        }.bind(this));
      },

      _getQty: function () {
        var qty = this.input.value;
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');

      if (!holder) {
        return;
      }

      holder.innerHTML = '';
      holder.append(div);

      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);

      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function () {
        this.resize();
      }.bind(this)));

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) { // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function () {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }

        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener('click', function (evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function (evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function (evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: 'disabled'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = { value: variant[index], soldOut: true }
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })

          return options;
        }, { option1: [], option2: [], option3: [] })
      },

      setInitialAvailability: function () {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map((value, index) => { return { value, index: `option${index + 1}` } })
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function (evt) {

        const { value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant } = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + option + '"]');

        // Loop through each option value
        values.forEach(obj => {
          this.addSoldOutText(group, obj)
          this.enableVariantOption(group, obj);
        });
      },
      addSoldOutText: function (group, option) {
        if (option.soldOut) {
          const el = group.querySelector('option[value="' + option.value + '"]')
          // Build via DOM nodes instead of innerHTML so merchant-supplied
          // option.value can't break out of the <span> as HTML. Also pull
          // "Out of stock" from theme.strings.soldOut (already translated)
          // instead of hardcoding English.
          if (el) {
            const valueSpan = document.createElement('span')
            valueSpan.textContent = option.value
            const stockSpan = document.createElement('span')
            stockSpan.className = 'stock--availability'
            stockSpan.textContent = ' ' + (theme.strings.soldOut || 'Out of stock')
            el.replaceChildren(valueSpan, stockSpan)
          }
        }
      },
      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="' + value + '"]').disabled = true;
          } else {
            group.querySelector('option[value="' + value + '"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }

      },

      disableVariantGroup: function (group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }

    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;
    var vimeoPlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };


  /*============================================================================
    ToolTip
  ==============================================================================*/

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');

      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');

      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }

    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;

      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }

      this._lockScrolling();

      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }

      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });

      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });

      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }

    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';

      this._unlockScrolling();

      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }

    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }

  customElements.define('tool-tip', ToolTip);

  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }

    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });

      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }

  customElements.define('tool-tip-trigger', ToolTipTrigger);

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;
    // The matchSmall / unmatchSmall listeners below live on document, so they outlive every init(). init() runs again
    // whenever the theme editor reloads the announcement bar section, and each run used to stack another pair (before
    // D1.1 the two header controllers stacked them on every page view too); every breakpoint change then rebuilt the
    // slider once per pair. The one pair is bound on the first init that needs it and always reads the module's current
    // `bar`, so it serves whichever section instance loaded last.
    var breakpointListenersBound = false;

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      // A single announcement block needs no slider. dataset values are
      // always strings, so compare against '1' — the old `=== 1` never
      // matched and a 1-block bar initialized Flickity for nothing.
      if (bar.dataset.blockCount === '1') {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      if (breakpointListenersBound) {
        return;
      }
      breakpointListenersBound = true;

      document.addEventListener('matchSmall', function () {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function () {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();

  // Section controller for sections/announcement-bar.liquid (data-section-type="announcement-bar"). It exists so the bar
  // no longer shares the header section's type: both sections used to declare the header type, which made
  // theme.HeaderSection run twice on every page (D1.1). It only forwards to the theme.announcementBar module above:
  // init starts the slider, the editor's block events move it to the selected announcement, and the editor's unload
  // tears it down before the section re-renders. Registered right before 'header' (see the registrations at the bottom
  // of this file), so the slider exists before theme.headerNav.init() measures the bar.
  theme.AnnouncementBarSection = (function () {
    function AnnouncementBarSection(container) {
      this.container = container;

      this.init();
    }

    AnnouncementBarSection.prototype = Object.assign({}, AnnouncementBarSection.prototype, {
      // Starts the slider (or nothing, for a page without a bar or a bar with one announcement).
      init: function () {
        theme.announcementBar.init();
      },

      // The editor selected one of this section's blocks: show that announcement and pause the slider.
      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      // The editor left the block: resume the slider.
      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },

      // The editor is about to re-render or remove the section: destroy the slider so a re-init does not stack sliders.
      onUnload: function () {
        theme.announcementBar.unload();
      }
    });

    return AnnouncementBarSection;
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function () {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
            }
          }
        })
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function (evt) {
          this.cartForm.buildCart();
          if (theme.settings.cartType === 'drawer') {
            this.open();
          }
        }.bind(this));

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function () {
        this.drawer.open();
      },

      close: function () {
        this.drawer.close();
      }
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      searchBtnTrigger: '.slide-nav__search-trigger',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      announcementBarHeight: 0,
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      const headerEl = document.querySelector('.header-group--main-header')

      const elementRect = headerEl.getBoundingClientRect();
      const scrollPosition = window.scrollY;

      if (scrollPosition >= 10) {
        siteHeader.classList.add('sticky--active')
      }
      else {
        siteHeader.classList.remove('sticky--active')
      }

      // Header state must CONVERGE after browser scroll restoration, which
      // can land before this script runs (fast loads) or seconds after
      // first paint (slow loads) — and whose scroll event is missed when
      // the guarded/throttled listener isn't ready or enabled. The check
      // above runs once, at whatever scroll position happens to be current;
      // on a slow reload that's 0 (pre-restore), leaving the header in the
      // wrong mode until the first touch — the "header flashes on reload"
      // bug. scrollHandler is idempotent, so re-run it at every settle
      // point, with the header's transitions suppressed (--settling) so a
      // late correction PAINTS the right state instead of animating to it.
      function settleHeaderState() {
        if (!siteHeader) return;
        siteHeader.classList.add('site-header--settling');
        scrollHandler();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            siteHeader.classList.remove('site-header--settling');
          });
        });
      }
      window.on('load' + config.namespace, settleHeaderState);
      window.on('pageshow' + config.namespace, settleHeaderState);
      // Restoration itself fires a scroll event — catch the very first one
      // unguarded (the throttled listener may be disabled or not yet bound).
      window.addEventListener('scroll', settleHeaderState, { once: true, passive: true });
      // Convergence poll: under slow network the ordering of restoration vs
      // this script is racy (restoration can precede the scroll binding,
      // and the load event trails image downloads by seconds). A few
      // idempotent, paint-only re-checks guarantee the header settles
      // within ~1.5s of the script running, whatever the ordering.
      settleHeaderState();
      setTimeout(settleHeaderState, 100);
      setTimeout(settleHeaderState, 500);
      setTimeout(settleHeaderState, 1500);

      const announcementBar = document.querySelector('.announcement-bar')
      if (announcementBar) config.announcementBarHeight = announcementBar.clientHeight

      if (window.innerWidth > 768) {
        if (announcementBar) {
          config.announcementBarHeight = 250
        }
        else {
          config.announcementBarHeight = 200
        }
      }

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      accessibleDropdowns();
      searchDrawer();

      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderHeight();

      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var h = siteHeader.offsetHeight;

      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }

      // stickyHeaderWrapper is created lazily by stickyHeader() only if the
      // mega menu fits. The 250ms editor-mode setTimeout can fire before that
      // — bail out if the wrapper isn't there yet rather than throwing.
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      if (stickyHeader) stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;

      // Trailing call: ensures final scroll position is captured
      // even when the leading-only throttle drops the last event
      clearTimeout(config.scrollTrailingTimeout);
      config.scrollTrailingTimeout = setTimeout(function() {
        requestAnimationFrame(scrollHandler);
      }, 40);
    }

    function scrollHandler() {
      const headerEl = document.querySelector('.header-group--main-header');
      const stickyInner = document.querySelector(selectors.siteHeader);

      const elementOffsetTop = headerEl.offsetTop; // Distance from the top of the document
      const scrollPosition = window.scrollY; // Current scroll position

      if (scrollPosition >= 10) {
        stickyInner.classList.add('sticky--active');
      } else {
        stickyInner.classList.remove('sticky--active');
      }
    }

    // Mega menu dropdown system for desktop navigation.
    // mouseleave is bound to the parent <li> (not the <a>) with a 150ms debounced close,
    // giving the cursor time to cross any gap between the link and the dropdown.
    // When switching between mega menus, transitions are suppressed for an instant swap
    // (no fade-out + fade-in, just content change — perceived as one persistent panel).
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }

      // Open/hide top level dropdowns
      var dropdownCloseTimeout = null;

      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
      });

      // Close dropdowns on mouseleave from parent <li>, not the <a> link.
      // Uses a short delay so the cursor can cross any gap to reach the dropdown.
      document.querySelectorAll(selectors.navItems).forEach(el => {
        el.on('mouseenter' + config.namespace, function() {
          if (dropdownCloseTimeout) {
            clearTimeout(dropdownCloseTimeout);
            dropdownCloseTimeout = null;
          }
        });
        el.on('mouseleave' + config.namespace, function() {
          dropdownCloseTimeout = setTimeout(function() {
            closeDropdowns();
            dropdownCloseTimeout = null;
          }, 150);
        });
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });

      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on('touchend' + config.namespace, function () {
          closeDropdowns();
        });

        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach(el => {
          el.on('touchend' + config.namespace, function (evt) {
            evt.stopImmediatePropagation();
          });
        });
      }

      function accessibleMouseEvent(evt) {
        var newParent = evt.currentTarget.parentNode;
        var currentMega = document.querySelector('.site-nav--is-megamenu.is-focused');
        var switchingMegas = currentMega
          && newParent !== currentMega
          && newParent.classList.contains('site-nav--is-megamenu');

        if (switchingMegas) {
          var outgoing = currentMega.querySelector('.megamenu');
          var incoming = newParent.querySelector('.megamenu');
          if (outgoing) outgoing.classList.add('megamenu-switching');
          if (incoming) incoming.classList.add('megamenu-switching');

          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              if (outgoing) outgoing.classList.remove('megamenu-switching');
              if (incoming) incoming.classList.remove('megamenu-switching');
            });
          });
        }

        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function () {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        if (dropdownCloseTimeout) {
          clearTimeout(dropdownCloseTimeout);
          dropdownCloseTimeout = null;
        }
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });

      document.querySelectorAll(selectors.searchBtnTrigger).forEach(btn => {
        btn.addEventListener('click', triggerSearchDrawer);
      });

      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }

    function triggerSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var drawerClose = document.querySelector('.js-drawer-close');

      document.documentElement.classList.add('trigger-from--drawer');
      window.startTracking = false;
      if (drawerClose) drawerClose.click();

      // Open search immediately (no setTimeout) to keep .focus()
      // in the user gesture chain — required for mobile keyboard
      openSearchDrawerDirect();
    }

    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      openSearchDrawerDirect();
    }

    function openSearchDrawerDirect() {
      var container = document.querySelector(selectors.searchContainer);
      container.classList.add('is-active');

      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');

      // Prevent mobile zoom on input focus
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0');
      }

      // Focus input immediately for mobile keyboard support
      var input = container.querySelector('.site-header__search-input');
      if (input) {
        // RAF gives browser one frame to paint the container before focusing,
        // avoiding a forced synchronous reflow while still ensuring focus works.
        requestAnimationFrame(() => input.focus());
      }

      // Set up focus trap after drawer animation completes
      setTimeout(function () {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: input
        });
      }, 600);

      theme.a11y.lockMobileScrolling(config.namespace);

      bindSearchEvents();
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      if (document.documentElement.classList.contains('trigger-from--drawer')) {
        document.documentElement.classList.remove('js-drawer-open--search', 'trigger-from--drawer');
        var jsDrawerOpen = document.querySelector('.js-drawer-open-nav')
        if (jsDrawerOpen) {
          document.documentElement.classList.add('trigger-from-search-close', 'track-collection-filter');
          document.dispatchEvent(new CustomEvent('drawer-open', { detail: { target: jsDrawerOpen } }));
          window.startTracking = true
          window.setTimeout(function () {
            window.startTracking = false
          }, 1000)
        }
      }
      else {
        document.documentElement.classList.add('js-drawer-closing');
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
      }

      window.setTimeout(function () {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function () {
        container.classList.remove('is-active');
      }.bind(this));

      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });

      // Restore normal viewport zoom
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width,initial-scale=1.0');
      }

      theme.a11y.unlockMobileScrolling(config.namespace);

      unbindSearchEvents();
    }

    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));

      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function (evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }

    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };

  theme.predictiveSearch = (function () {
    // The dedupe key (pairKey(): the product request's own query, text + scope) of the live
    // request pair, in flight or painted; '' when none is live. search() clears it as soon as
    // the box's text or scope moves off it
    // (Ruling 37), so from that keystroke on the old pair can no longer paint.
    var currentString = '';
    // Holds the ONE AbortController of the in-flight request pair (the product
    // section and suggest.json share its signal), so a newer query or scope
    // cancels both halves of a stale pair at once, before either can render.
    var predictController = null;
    var searchTimeout;
    var namespace = '.predictive';

    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',
      searchButton: '[data-predictive-search-button]'
    };

    var cache = {};

    var classes = {
      isActive: 'predicitive-active'
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };

    /**
     * Escape catalogue strings before they are interpolated into innerHTML:
     * the collection titles and URLs suggest.json echoes (buildCollections).
     * Without it, a crafted collection title (e.g. one containing
     * `"><img onerror=…>`) could inject markup into the dropdown. Applied at
     * THIS mapping layer only, never inside theme.buildCollectionItem
     * (escaping in both places would double-escape). Product tiles no longer
     * pass through here: since C-10 the server renders them and Liquid
     * escapes their text (snippets/predictive-product-tile.liquid). ES5 so it
     * lives comfortably in this legacy IIFE.
     */
    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /**
     * The gender the current search is scoped to. The hidden filter.p.tag
     * input in #HeaderSearchForm is the single source of truth (owned and
     * kept in sync by gender-context.js: cookie default + overlay toggle
     * override). Disabled input = unscoped search.
     *
     * The input holds the store's tag ('Men' / 'Women', lead ruling #63), and
     * the collections gate below matches lowercase handle suffixes (-men /
     * -women), so this returns the internal, lowercase gender. The products
     * request sends the input's own value (headerSearchParams), the store's tag.
     */
    function currentSearchGender() {
      var input = document.querySelector('[data-gender-search-filter]');
      if (!input || input.disabled) return null;
      var gender = String(input.value).toLowerCase();
      return gender === 'men' || gender === 'women' ? gender : null;
    }

    /**
     * Gender gate for suggest.json collection results. Collections are
     * gendered by handle convention (…-men / …-women). Fail-closed: a
     * scoped dropdown shows ONLY collections carrying the matching
     * suffix, so a collection that skips the naming convention can never
     * leak into the wrong gender's suggestions (it just won't appear in
     * scoped dropdowns — the safe failure mode).
     */
    function collectionMatchesGender(collection, gender) {
      if (!gender) return true;
      var handle = collection.handle || '';
      var suffix = '-' + gender;
      return handle.slice(-suffix.length) === suffix;
    }

    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      cache.wrapper = document.querySelector(selectors.wrapper);

      if (!cache.wrapper) {
        return;
      }

      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);

      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);
      // Also on input (Ruling 37): a paste from the context menu, a drag-and-drop and the
      // search field's own clear button change the text without any keyup, so the dropdown
      // used to keep the old text's results. A typed key now runs search() twice (input,
      // then keyup), which is harmless: the second run changes nothing but the debounce
      // (see search()). The module never unbinds its listeners, so neither is unbound.
      cache.input.on('input' + namespace, search);

      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);

      cache.results = document.querySelector(selectors.resultDiv);

      // Re-run the live query when the search scope or site gender flips —
      // the dropdown may be open with now-wrongly-scoped results. The
      // request key includes the scope, so this is never suppressed as a
      // duplicate.
      ['search-gender:changed', 'gender:changed'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          if (cache.input && cache.input.value !== '') {
            // A scope flip invalidates any in-flight AND any rendered results.
            // Abort the live request pair (both halves share one controller),
            // wipe the dropdown, and clear the dedupe
            // key BEFORE re-querying: otherwise the 500ms debounce could let an
            // old-scope response paint after the user picked a new scope, and a
            // failed replacement request would strand wrong-scope markup on
            // screen indefinitely (a cross-gender leak).
            if (predictController) predictController.abort();
            cache.results.innerHTML = '';
            currentString = '';
            search();
          }
        });
      });
    }

    function reset() {
      // Abort any in-flight request pair: a response landing after the
      // dropdown was cleared must not repaint it (same supersession rule as
      // scope flips).
      if (predictController) predictController.abort();
      predictController = null;
      cache.results.innerHTML = '';
      // Clear the in-flight marker too (Ruling 31). The aborted pair settles as
      // an AbortError, which leaves the loading state to whoever aborted it, and
      // with the box empty no newer pair is coming to clear it: the dropdown
      // would stay dimmed (the :has(.loading) overlay) until the next query.
      cache.results.classList.remove('loading');
      clearTimeout(searchTimeout);
      // Clear the dedupe key so re-typing the same first query after the input
      // was emptied still fires a fresh request (the key is pairKey(): text + scope).
      currentString = '';
    }

    /**
     * headerSearchParams — the ONE param builder for the header search form (C-10 / C-11, spec 6.1).
     * -----------------------------------------------------------------------------
     * Every way out of #HeaderSearchForm builds its query here: Enter and the search icon (submitSearch) and the
     * dropdown's "view all" button (triggerSearch). The C-10 predictive products request (fetchProducts) calls it
     * too, so none of them can disagree about what a header search sends (type, options[prefix], the enabled
     * gender scope, availability, q with its wildcard). "View all" used to call the native form.submit(), which
     * fires no submit event: it skipped the submit handler and went out without the q wildcard.
     *
     * Rules, each there for a reason:
     *  - Fields come from new FormData(form), the platform's own "what would this form submit": it leaves out
     *    disabled controls, which is how the unscoped gender input (disabled by gender-context.js) stays off the
     *    URL, and it yields the rest in DOM order. theme.utils.serialize was considered and not used: it returns
     *    a string, keeps duplicate names and has no q rule, so it would need re-parsing and the same fix-ups.
     *  - One value per name, the first in DOM order. That is what the old formData.get(key) loop gave, and it
     *    keeps the contract "one gender tag, one availability" even if a stray copy of an input ever appears.
     *  - q is trimmed and gets the '*' wildcard the theme has always appended, but only when text is left after
     *    trimming. A blank box stays a plain empty q: appending '*' to nothing would send a bare '*' query.
     *
     * @param {HTMLFormElement} form - #HeaderSearchForm (cache.form).
     * @returns {URLSearchParams} the query; String(params) is the query string without a leading "?".
     */
    function headerSearchParams(form) {
      var params = new URLSearchParams();
      var seen = new Set();

      new FormData(form).forEach(function (value, name) {
        // First occurrence wins; later copies of the same name are dropped.
        if (seen.has(name)) return;
        seen.add(name);

        if (name === 'q') {
          var term = String(value).trim();
          value = term ? term + '*' : term;
        }
        params.append(name, value);
      });

      return params;
    }

    // The one navigation from the header form to the full results page. It is the "view all" button's handler,
    // and submitSearch (Enter / the icon) ends here too, so both land on the same URL by construction. It no
    // longer calls the native cache.form.submit(): that fires no submit event, so it skipped submitSearch and
    // sent q without the wildcard.
    function triggerSearch() {
      window.location.href = `${theme.routes.search}?${headerSearchParams(cache.form)}`;
    }

    // Enter / the search icon. preventDefault stops the browser's own GET, which would serialise the form itself
    // and skip headerSearchParams (no wildcard, untrimmed q).
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      triggerSearch();
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
    }

    // search — runs on every edit of the header box (the input event), on every keyup but Up,
    // Down and Tab (handleKeyup), and after a scope flip. An empty box resets the dropdown.
    // Otherwise the query waits on the 500 ms debounce (predictQuery), but the pair still out
    // for an OLDER text or scope loses now, at this keystroke (Ruling 37).
    function search() {
      var keyword = cache.input.value;

      if (keyword === '') {
        reset();
        return;
      }
      var q = _normalizeQuery(keyword);

      // Supersession at the keystroke: the scope flip's and reset()'s (abort the live pair,
      // clear its key), so its settle fails the isCurrent() check even when its answer has
      // already arrived. Before, the abort waited for the new text's own pair, 500 ms later,
      // and an older pair that settled inside that window passed its key check and painted
      // results for text the box no longer held. Unlike those two, it leaves the painted
      // results in place (no clearing, no flicker) until the new pair replaces them. The key
      // is pairKey(), predictQuery's own. An unchanged key keeps its live pair: a key that
      // edits nothing (Shift, Left, Right) or an edit the product request does not see (a
      // leading or trailing space: headerSearchParams trims). A change of case or of the
      // spaces inside the text IS a new request (Ruling 45). For an edit that changes the key,
      // the keyup after its input event finds the key already cleared, and aborting an
      // aborted controller does nothing.
      if (pairKey() !== currentString) {
        if (predictController) predictController.abort();
        currentString = '';
      }

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    /**
     * predictQuery — the dropdown's request pair for one debounced query (C-10, spec 6.1).
     * -----------------------------------------------------------------------------
     * Products come from the scoped search itself (fetchProducts: sections/predictive-search-products.liquid at the
     * /search URL headerSearchParams builds), so Shopify applies the gender scope, availability and Unlisted status
     * before the ranking is cut to 4, and the tiles are the first 4 products of "view all". Collections still come
     * from suggest.json (fetchCollections), which takes no filters (F5), behind the handle-suffix gate.
     *
     * The completion rule (design gate), each part there for a reason:
     *  - ONE AbortController for BOTH fetches. The keystroke that moves the box's text or scope off this pair's key
     *    (search(), Ruling 37), a scope flip or an emptied box (reset()) aborts the whole pair at once and clears
     *    the key, so neither half of a stale pair can outlive it. That happens at the keystroke, not 500 ms later
     *    when the newer text's own pair starts here (which aborts the controller too, for any pair still out).
     *    There is no in-flight guard on purpose: an early return while a request was live made supersession
     *    unreachable (a slow stale-scope response could render over fresher results). Abort plus the request key
     *    are the supersession mechanism.
     *  - ONE Promise.all. The dropdown paints only when both halves have succeeded: painting each half as it lands
     *    could show one query's collections beside another's products, or paint a half whose sibling then fails.
     *  - Every settle re-checks the request key (isCurrent). A pair that is no longer the live one neither paints
     *    nor clears: whoever superseded it owns the dropdown and the key (the newer text's pair, out or still on
     *    its debounce; reset() for an emptied box). A stale failure that cleared the key would even strand the
     *    newer pair, whose own check would then fail.
     *  - Either failure (a non-2xx status, a product response without its marker, a network error) clears the
     *    dropdown once and clears the dedupe key, so typing the same query again retries instead of being swallowed
     *    as a duplicate. An abort is not a failure: whoever aborted owns what happens next.
     *
     * @param {string} q - The normalized query (_normalizeQuery), for the suggest.json half only. The dedupe key is
     *   pairKey(), the product request's own query.
     */
    async function predictQuery(q) {
      const searchGender = currentSearchGender();

      // The dedupe guard keys on what the pair actually requests (pairKey, Ruling 45): the text AND the scope, so the
      // same text under a different gender is a different search (the old q-only guard suppressed the refresh after
      // a toggle flip).
      const requestKey = pairKey();
      if (currentString === requestKey) return;
      currentString = requestKey;
      const isCurrent = () => currentString === requestKey;

      cache.results.classList.add('loading');

      if (predictController) predictController.abort();
      predictController = new AbortController();
      const signal = predictController.signal;

      try {
        const [tiles, collections] = await Promise.all([fetchProducts(signal), fetchCollections(q, searchGender, signal)]);
        // Superseded while the pair was out: whoever superseded it owns the dropdown and the loading state (the
        // newer text's pair, out or still on its debounce; reset() for an emptied box).
        if (!isCurrent()) return;
        cache.results.classList.remove('loading');
        paint(tiles, collections);
      } catch (err) {
        if ((err && err.name === 'AbortError') || !isCurrent()) return;
        cache.results.classList.remove('loading');
        cache.results.innerHTML = '';
        currentString = '';
      }
    }

    // The product half of a pair: the scoped search's first page of 4, rendered by
    // sections/predictive-search-products.liquid at the very URL "view all" opens (headerSearchParams), so the two
    // cannot disagree. A non-2xx status, or a 200 that is not that section (no [data-predictive-products] marker: a
    // password page, a redirect to another template), is a failure, never "no products". Resolves with the tile
    // elements, in search order. theme.AjaxRenderer's renderSectionFromFetch does the same status-checked fetch, but
    // it is a method of the filter renderer (it needs that object's this.log): borrowing it would tie the header
    // dropdown to the filter renderer for three lines.
    //
    // pairKey — the identity of the request pair the box holds now, used as the dedupe and supersession key
    // (search() and predictQuery()). It is the product request's own query, what fetchProducts sends: the trimmed text
    // with its wildcard, the enabled gender scope (the header form's hidden input) and the form's constant fields.
    // Final gate round 2 (Ruling 45): the key used to be _normalizeQuery's text, which lowercases and turns spaces into
    // dashes. Two texts that send DIFFERENT product requests then shared one key: "red OR blue" and "red or blue"
    // (Shopify's search operators are case-sensitive), "red-blue" and "red blue". So the old pair painted for the new
    // text and the new request was deduplicated away. Equal keys mean equal raw text, so the suggest.json half
    // (normalized text) is equal too.
    function pairKey() {
      return headerSearchParams(cache.form).toString();
    }

    async function fetchProducts(signal) {
      const url = theme.routes.search + '?' + headerSearchParams(cache.form) + '&section_id=predictive-search-products';
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error(`[predictive] product section HTTP ${response.status}`);
      const html = await response.text();
      const marker = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-products]');
      if (!marker) throw new Error('[predictive] the product response has no [data-predictive-products]');
      return Array.from(marker.children);
    }

    // The collection half of a pair: suggest.json, collections only (products come from fetchProducts). It takes no
    // filters (F5), so the scope is the fail-closed handle-suffix gate (collectionMatchesGender), applied BEFORE the
    // cap of 4. The limit is the API's maximum, 10, so the gate still finds 4 when other-gender collections rank
    // first. A non-2xx status is a failure (an error page never counts as "no collections"); a 200 whose payload
    // holds no collections list is no collections.
    async function fetchCollections(q, searchGender, signal) {
      // Locale-aware root (the store runs 8 locales). Shopify.routes.root is injected by content_for_header.
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const params = paramUrl({
        'q': q,
        'resources[type]': 'collection',
        'resources[limit]': 10,
        'resources[limit_scope]': 'each'
      });
      const response = await fetch(root + 'search/suggest.json?' + params, { signal });
      if (!response.ok) throw new Error(`[predictive] suggest HTTP ${response.status}`);
      const suggestions = await response.json();
      const results = suggestions && suggestions.resources && suggestions.resources.results;
      const collections = results && Array.isArray(results.collections) ? results.collections : [];
      return collections.filter(c => collectionMatchesGender(c, searchGender)).slice(0, 4);
    }

    // Paints one settled, current pair: the products block first, then the collections, in the structure the
    // dropdown CSS lays out (#PredictiveResults is a flex row; .predictive-result__layout [data-type-products] and
    // [data-type-collections] size its direct children). The products block is built with DOM APIs around the
    // tiles the server rendered (spec C-7: no HTML string spliced from data); the collections keep buildCollections'
    // escaped markup. No tiles and no collections leave the dropdown empty.
    function paint(tiles, collections) {
      cache.wrapper.classList.remove('hide');
      cache.results.innerHTML = buildCollections(collections);
      if (!tiles.length) return;

      const grid = document.createElement('div');
      grid.className = 'grid grid--uniform';
      grid.append(...tiles);
      const block = document.createElement('div');
      block.setAttribute('data-type-products', '');
      block.append(grid);
      cache.results.prepend(block);
    }

    function buildCollections(collections) {
      var output = '';

      if (collections.length) {
        // Escape merchant-controlled text/URL here, at the mapping layer (657bbb7). theme.buildCollectionItem
        // interpolates title and url into innerHTML raw, and it has no other caller, so escaping once here can't
        // double-escape (Phase A4).
        var safeCollections = collections.map(function (c) {
          return Object.assign({}, c, { title: escapeHtml(c.title), url: escapeHtml(c.url) });
        });
        var markup = theme.buildCollectionItem(safeCollections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label hidden">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }

      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj).map(function (key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }

    return {
      init: init
    };
  })();

  theme.buildProductImage = function (product, imageSize, useOverlay) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';

    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = 'lazyload';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.image_aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
      if (product.images) {
        if (product.images.length > 1) {

          output = `
            ${output}
            <div class="grid-product__secondary-image small--hide">
              <img class="lazyload"
                  data-src="${product.media[1].preview_image.src}"
                  data-widths="[360, 540, 720, 900, 1080]"
                  data-aspectratio="${product.image_aspect_ratio}"
                  data-sizes="auto"
                  alt="${product.title}">
            </div>
          `
        }
      }
    }

    return output;
  }

  theme.buildCollectionItem = function (items) {
    var output = '';

    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  }

  /*============================================================================
    Shipping Reminder Popup
  ==============================================================================*/

  class ShippingReminderPopup extends HTMLElement {
    constructor() {
      super();

      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);

      this.classes = {
        activeContent: 'shipping-reminder-popup__content--active',
        inactiveContent: 'shipping-reminder-popup__content--inactive',
        inactiveDeclineContent: 'shipping-reminder-popup__decline-content--inactive',
        activeDeclineContent: 'shipping-reminder-popup__decline-content--active',
        modalInnerActive: 'active'
      }

      // this.declineButton = this.querySelector('[data-shipping-reminder-popup-decline-button]');
      this.declineContent = this.querySelector('[data-shipping-reminder-popup-decline-content]');
      this.content = this.querySelector('[data-shipping-reminder-popup-content]');
      this.returnButton = this.querySelector('[data-shipping-reminder-popup-return-button]');
      this.exitButton = this.querySelector('[data-shipping-reminder-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');

      this.allowedCountries = this.dataset.allowedCountries.split(',').map(_ => _.toLowerCase().trim()) || [];

      if (Shopify.designMode) {
        // Bound handlers stored on `this` so disconnectedCallback can remove them.
        // Without this, each section reload in the editor leaks two document
        // listeners that reference a detached element.
        this._onSectionSelect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        };
        this._onSectionLoad = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }

            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);

            if (!secondViewVisited) return;

            this.showDeclineContent();
          }
        };
        document.addEventListener('shopify:section:select', this._onSectionSelect);
        document.addEventListener('shopify:section:load', this._onSectionLoad);
      }

      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR 'Show age verification popup' setting is unchecked
      if ((this.cookie || this.dataset.enabled === 'false') && this.dataset.testMode === 'false') return;

      this.init();
    }

    disconnectedCallback() {
      if (this._onSectionSelect) document.removeEventListener('shopify:section:select', this._onSectionSelect);
      if (this._onSectionLoad) document.removeEventListener('shopify:section:load', this._onSectionLoad);
    }

    triggerPopup() {
      if (this.dataset.testMode !== 'false') {
        this.modal.open();
        this.showTextContent();
        return;
      }

      fetch('https://api.ipify.org/')
        .then(res => res.text())
        .then(ip => fetch(`https://ipapi.co/${ip}/json/`))
        .then(res => res.json())
        .then(data => {
          const country = data.country_name;
          if (!this.allowedCountries.includes(country.toLowerCase())) {
            this.modal.open();
            this.showTextContent();
          } else {
            Cookies.set(this.cookieName, 'entered', { expires: 30 });
          }
        })
        .catch(() => {
          // IP lookup failed — don't block the user, silently skip
        });
    }

    init() {
      this.modal = new theme.Modals(this.id, 'shipping-reminder-popup-modal', {
        closeOffContentClick: false
      });

      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }

      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }

      this.triggerPopup();

      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));

      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();

          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);

          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }

      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();

          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30 });
          }

          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }

          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }

          this.modal.close();

          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }

    showTextContent() {
      const modalInner = this.querySelector('.modal__inner')
      if (modalInner) {
        setTimeout(() => {
          if (!modalInner.classList.contains(this.classes.modalInnerActive)) modalInner.classList.add(this.classes.modalInnerActive)
        }, 500)
      }
    }

    hideTextContent() {
      const modalInner = this.querySelector('.modal__inner')
      if (modalInner) {
        setTimeout(() => {
          if (modalInner.classList.contains(this.classes.modalInnerActive)) modalInner.classList.remove(this.classes.modalInnerActive)
        }, 500)
      }
    }

    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);

      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }

    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);

      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }

  customElements.define('shipping-reminder-popup', ShippingReminderPopup);



  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      triggerClick: function (evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }

        if (!theme.config.bpSmall) {
          this.inSlideshow = false;
        }
        this.items = this.getImageData();
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.srcElement.parentElement.childNodes[0];
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
          : this.container.querySelectorAll(selectors.images);

        var items = [];

        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');

        window.addEventListener('resize', this.syncHeight);

        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.removeEventListener('resize', this.syncHeight);
          window.scrollTo(0, initialScrollPos);
        });
      }
    });

    return Photoswipe;
  })();


  theme.Recommendations = (function () {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }

    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;

      selectors.recommendations = 'Recommendations-' + this.sectionId;

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations);

        if (!section || section.dataset.enable === 'false') {
          return;
        }

        var url = this.url;

        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass)
          if (wrapper) {
            wrapper.innerHTML = '';
          }
        }

        fetch(url).then(function (response) {
          return response.text();
        }).then(function (html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }

          placeholder.innerHTML = '';

          if (!div) {
            this.container.classList.add('hide');
            if (window.AOS) { AOS.refreshHard() }
            return;
          }

          placeholder.appendChild(div);

          // Show the recommendations wrapper (hidden until products load)
          var wrapper = section.querySelector('[data-recommendations-wrapper]');
          if (wrapper) { wrapper.classList.remove('hide'); }

          theme.reinitProductGridItem(section);

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));

          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }
        }.bind(this));
      }
    });

    return Recommendations;
  })();

  theme.SlideshowSection = (function () {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) { return }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }

    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function () {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function (variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((html) => {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            this.container.innerHTML = html;
            this.container.innerHTML = this.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (this.container.querySelector(selectors.drawerOpenBtn)) {
              this.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (this.container.querySelector(selectors.modalOpenBtn)) {
              this.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = this.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = this.productTitle;
            }
          });
      }
    });

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function () {
              // playback normal
            }).catch(function () {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();

  theme.Blog = (function () {



    function Blog(container) {

      this.tagFilters();

    }



    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function () {

        var filterBy = document.getElementById('BlogTagFilter');



        if (!filterBy) {

          return;

        }



        filterBy.addEventListener('change', function () {

          location.href = filterBy.value;

        });

      }

    });



    return Blog;

  })();


  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
      childList: '.slide-nav__dropdown',
      subNavToggleBtn: '.js-toggle-submenu'
    };

    var classes = {
      isActive: 'is-active'
    };

    // CollectionSidebar — manages the mobile filter drawer UI.
    // Owns: checkbox state sync (mobile ↔ desktop), sub-nav accordion toggling,
    // category mutual exclusion, "All X" convenience checkboxes, and clear/apply actions.
    // Does NOT own: fetch pipeline, count updates, or product grid rendering (those are in Collection).
    // Communicates with Collection via the _scheduleFilterUpdate callback set during init.
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function () {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.destroy();

        this.wrapper = this.container.querySelector('.slide-nav__wrapper')

        // Create bound handlers once for proper removal
        if (!this._boundContainerChange) {
          this._boundContainerChange = this._onContainerChange.bind(this)
          this._boundContainerClick = this._onContainerClick.bind(this)
          this._boundClearGroup = this.clearGroup.bind(this)
          this._boundApplyGroup = this.applyGroup.bind(this)
          this._boundOnClose = this.onClose.bind(this)
          this._boundBackToSlideOne = this.backToSlideOne.bind(this)
        }

        // Delegated listeners — handles all filter checkboxes and sub-nav buttons
        this.container.addEventListener('change', this._boundContainerChange)
        this.container.addEventListener('click', this._boundContainerClick)

        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters');
        theme.FilterDrawerMobile = new theme.Drawers('FilterDrawerMobile', 'collection-filters-mobile');

        this.config = {
          menuLevel: 1,
          activeMenu: 'main'
        }

        this.drawerBottom = this.container.querySelector('.filter-drawer--bottom')
        this.listControl = this.container.querySelector('.list-control')

        this.listControlClearBtn = this.listControl.querySelector('[data-list-control="clear"]')
        this.listControlClearBtn.addEventListener('click', this._boundClearGroup)

        this.listControlApplyBtn = this.listControl.querySelector('.apply__button')
        this.listControlApplyBtn.addEventListener('click', this._boundApplyGroup)

        this.closeBtn = this.container.querySelector('#FilterDrawerMobile .js-drawer-close')
        this.closeBtn.addEventListener('click', this._boundOnClose)

        this.resetBtn = this.container.querySelector('#FilterDrawerMobile .drawer__reset-button')
        this.resetBtn.addEventListener('click', this._boundBackToSlideOne)

        const desktopDrawerScroll = this.container.querySelector('#FilterDrawer .drawer__scrollable')
        this.updateShadowState(desktopDrawerScroll)

        this._resizeObserver = new ResizeObserver((entries) => {
          this.updateShadowState(desktopDrawerScroll)
        })
        this._resizeObserver.observe(desktopDrawerScroll)

        this._scrollHandler = (e) => {
          const scrollTop = desktopDrawerScroll.scrollTop;
          const scrollHeight = desktopDrawerScroll.scrollHeight;
          const clientHeight = desktopDrawerScroll.clientHeight;
          const isAtTop = scrollTop === 0;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1; // -1 for rounding errors

          // Toggle "scrolled" class (not at top)
          desktopDrawerScroll.classList.toggle('scrolled', !isAtTop);

          // Toggle "scroll-end" class (at bottom)
          desktopDrawerScroll.classList.toggle('scroll-end', isAtBottom);
        };
        desktopDrawerScroll.addEventListener('scroll', this._scrollHandler);
        this._desktopDrawerScroll = desktopDrawerScroll;
      },

      updateShadowState: function (drawer) {
        if (!drawer) {
          return;
        }
        if (drawer.scrollHeight > drawer.clientHeight) {

          drawer.classList.add('has-scroll');
        } else {
          drawer.classList.remove('has-scroll');
        }
      },

      _onContainerChange: function (evt) {
        var input = evt.target
        if (!input.classList.contains('tag__input') || !input.hasAttribute('data-name')) return
        // Only the mobile drawer's inputs are this handler's. The desktop form's "All" box carries
        // data-name too, so its change event reaches this container as well; Collection.onFormInput
        // already handled it (its input event comes first), and running selectAllUnderList on a
        // desktop box a second time started a second facet change for the one click.
        if (!input.closest('#FilterDrawerMobile')) return
        if (input.classList.contains('tag__input--all')) {
          this.selectAllUnderList(evt)
        } else {
          this.handleFilterChange(evt)
        }
      },

      _onContainerClick: function (evt) {
        var subNavBtn = evt.target.closest(selectors.subNavToggleBtn)
        if (subNavBtn) {
          this.toggleSubNav({ currentTarget: subNavBtn })
        }
      },

      backToSlideOne: function (e) {
        var titleEl = this.container.querySelector('.title__placeholder')
        titleEl.innerHTML = theme.strings.filterAllFilters
        this.goToSubnav();
        this.updateListControl(e.target)
      },

      onClose: function (e) {
        e.preventDefault()
        const form = document.querySelector('.filter-form')
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      },

      reInit: function (container) {
        this.container = container.querySelector(selectors.sidebar)
        this.init()
      },

      // Mobile filter checkbox handler (C-8: two-way mirroring). The change goes onto EVERY copy of
      // the facet through theme.setFacetChecked: this twin itself, any other mobile twin of the same
      // value, and every desktop named input (the sidebar layout renders the form twice, and a
      // category value can print under two menu leaves; the old code set only the first match). They
      // are found by comparison (theme.facetInputs, C-7), never by a selector built from the value:
      // the value is catalogue data, and a quote or bracket in it threw a SyntaxError here.
      // The "All" box of the row's own group is derived from its rows on BOTH sides (theme.setFacetChecked):
      // unchecking clears it, checking the last unchecked row ticks it. The old code cleared the first "All"
      // box it found anywhere under the dropdown, which was another group's when the dropdown holds
      // several, never touched the desktop box, and never ticked it.
      // Then triggers the filter pipeline via _scheduleFilterUpdate callback.
      handleFilterChange: function (evt) {
        const target = evt.target
        const mainCategory = target.closest('[data-category-main]')

        theme.setFacetChecked(this.container, target.dataset.name, target.dataset.value, target.checked)

        if (mainCategory) {
          this.clearOtherMainCategory(mainCategory)
        }

        this.listControl.classList.add('show')
        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      // A group's "All" checkbox in the mobile drawer (C-8: two-way mirroring): checks or unchecks
      // every row of its list, and each row goes onto every copy of its facet (the other mobile
      // twins and the desktop inputs, found by comparison: C-7) through theme.setFacetChecked.
      // Then the "All" box of every group those copies sit in is derived from its rows
      // (theme.syncAllBoxes): this box itself and its desktop counterpart, so the two sides agree.
      // Before, the desktop "All" box was never touched and only the first desktop input of each row
      // was set.
      selectAllUnderList: function (evt) {
        const target = evt.target
        const mainCategory = target.closest('[data-category-main]')
        const list = target.closest('.filter__list')
        // The state the shopper chose, read ONCE: setFacetChecked derives this very box from the rows as it
        // sets them, so target.checked is not the choice any more after the first row.
        const on = target.checked
        const copies = []
        list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(item => {
          copies.push(...theme.setFacetChecked(this.container, item.dataset.name, item.dataset.value, on))
        })
        // The closing pass: setFacetChecked has derived the boxes after each row, so this changes nothing when
        // the rows followed; it also covers THIS box, so it never stays ticked over rows that could not follow
        // (a row without a facet identity has no copy to set).
        theme.syncAllBoxes(copies.concat(target))

        if (mainCategory) {
          this.clearOtherMainCategory(mainCategory)
        }

        this.listControl.classList.add('show')
        if (!on) { this.listControl.classList.remove('show') }

        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      clearOtherMainCategory: function (currentCategory) {
        theme.utils.clearOtherMainCategory(currentCategory, this.container)
      },

      // The open submenu's Apply: goes back up one level through that submenu's own back button.
      // The submenu is found by its data-title, the filter's label (C-7: label-derived text is
      // CSS.escape'd before it enters a selector, so a quote or bracket in it cannot throw).
      applyGroup: function (evt) {
        const listControlEl = evt.target.closest('[data-control]')
        const currentGroupName = listControlEl.dataset.control

        const currentMenu = this.container.querySelector(`.slide-nav__dropdown[data-title="${CSS.escape(currentGroupName)}"]`)
        if (!currentMenu) return
        const backButton = currentMenu.querySelector('[data-back]')
        backButton.click()
      },

      // The open submenu's own "Clear all": unchecks that one group, then starts a facet change.
      // C-7: the group is found by its label-derived data-list-control, CSS.escape'd before it
      // enters the selector; each facet's copies by comparison (theme.facetInputs), never by a
      // selector built from the value.
      // C-8 (Ruling 26): every row goes through theme.setFacetChecked, so EVERY copy of its facet
      // is cleared (both desktop forms of the sidebar layout, a value under two menu leaves, the
      // other mobile twins) and the "All" boxes of the group's lists are cleared on both sides, the
      // desktop ones included. theme.buildFilterQuery reads every checked named input, so a copy
      // left checked would keep the cleared facet in the next query. Before, only the first desktop
      // input of each checked row was cleared and the desktop "All" boxes were never touched.
      clearGroup: function (evt) {
        evt.preventDefault()
        const listControlEl = evt.target.closest('[data-control]')
        const currentGroupName = listControlEl.dataset.control

        const groupEl = this.container.querySelector(`li[data-list-control="${CSS.escape(currentGroupName)}"]`)
        const groupItems = groupEl.querySelectorAll('input')
        groupItems.forEach(item => {
          // A row clears its facet everywhere, checked or not (a copy elsewhere may have drifted). An
          // "All" box is no facet (no value of its own): the rows of its list clear it, here and on the
          // desktop side, so it only needs its own state and mark reset below.
          if (!item.classList.contains('tag__input--all')) {
            theme.setFacetChecked(this.container, item.getAttribute('data-name'), item.getAttribute('data-value'), false)
          }
          item.checked = false
          const listItem = item.closest('li.tag')
          if (listItem) listItem.classList.remove('tag--active')
        })

        this.listControl.classList.remove('show')
        if (this._scheduleFilterUpdate) this._scheduleFilterUpdate()
      },

      // Opens a submenu of the mobile drawer and shows its title in the drawer header.
      toggleSubNav: function (evt) {
        var btn = evt.currentTarget;

        var title = btn.dataset.title
        var titleEl = this.container.querySelector('.title__placeholder')
        if (title) {
          // The title is the filter's label (data-title, already decoded by the browser): text,
          // never markup (C-7). As innerHTML, a label holding < or & became markup.
          titleEl.textContent = title
        } else {
          // No title: the drawer's own heading, a t string (theme.strings), which Shopify returns
          // HTML-escaped (G19), so innerHTML is what decodes it.
          titleEl.innerHTML = theme.strings.filterAllFilters
        }
        this.goToSubnav(btn.dataset.target);
        this.updateListControl(btn.parentNode)
      },

      updateListControl: function (el) {
        const controlTarget = el.dataset.listControl
        if (controlTarget) {
          this.listControl.setAttribute('data-control', controlTarget)
          this.closeBtn.classList.add('hidden')
          this.resetBtn.classList.remove('hidden')
        } else {
          this.listControl.setAttribute('data-control', "")
          this.closeBtn.classList.remove('hidden')
          this.resetBtn.classList.add('hidden')
        }

        if (this.checkAnyInputSelected(el)) {
          this.listControl.classList.add('show')
        }
      },

      checkAnyInputSelected: function (el) {
        const hasAnythingChecked = el.querySelector('input[data-name]:checked')
        return hasAnythingChecked ? true : false
      },

      // If a level is sent we are going up, so target list doesn't matter
      goToSubnav: function (target) {
        // Activate new list if a target is passed. The target is 'tier-2-' plus the filter's label
        // handle (data-target), so it is CSS.escape'd before it enters the selector (C-7); with no
        // target, CSS.escape gives 'undefined', which names no list, as before (the top level).
        var targetMenu = this.container.querySelector(selectors.childList + '[data-parent="' + CSS.escape(target) + '"]')
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;
          this.config.activeMenu = target

          // Hide all level 3 menus if going to level 2
          if (this.config.menuLevel == 2) {
            this.container.querySelectorAll(selectors.childList + '[data-level="3"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }

          if (this.config.menuLevel == 3) {
            this.container.querySelectorAll(selectors.childList + '[data-level="4"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }


          setTimeout(() => {
            targetMenu.classList.add(classes.isActive);
            targetMenu.parentElement.classList.add(classes.isActive);
          }, 150)

          this.drawerBottom.classList.add('submenu-active')

        } else {
          // Going to top level, reset
          this.config.menuLevel = 1;
          this.wrapper.removeAttribute('style');
          this.container.querySelectorAll(selectors.childList).forEach(list => {
            list.classList.remove(classes.isActive);
            list.parentElement.classList.remove(classes.isActive);
          });

          this.drawerBottom.classList.remove('submenu-active')
          this.listControl.classList.remove('show')
        }

        this.wrapper.dataset.level = this.config.menuLevel;
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
        if (theme.FilterDrawerMobile) {
          if (!drawerStyle) {
            theme.FilterDrawerMobile.close()
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawerMobile.open()
          }
        }
      },

      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if (theme.FilterDrawerMobile) {
          theme.FilterDrawerMobile.close()
        }
      },

      destroy: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
          theme.FilterDrawer.destroyListeners();
        }

        if (theme.FilterDrawerMobile) {
          theme.FilterDrawerMobile.close();
          theme.FilterDrawerMobile.destroyListeners();
        }

        // Remove delegated container listeners
        if (this.container && this._boundContainerChange) {
          this.container.removeEventListener('change', this._boundContainerChange)
        }
        if (this.container && this._boundContainerClick) {
          this.container.removeEventListener('click', this._boundContainerClick)
        }

        // Remove button listeners
        if (this.listControlClearBtn && this._boundClearGroup) {
          this.listControlClearBtn.removeEventListener('click', this._boundClearGroup)
        }
        if (this.listControlApplyBtn && this._boundApplyGroup) {
          this.listControlApplyBtn.removeEventListener('click', this._boundApplyGroup)
        }
        if (this.closeBtn && this._boundOnClose) {
          this.closeBtn.removeEventListener('click', this._boundOnClose)
        }
        if (this.resetBtn && this._boundBackToSlideOne) {
          this.resetBtn.removeEventListener('click', this._boundBackToSlideOne)
        }

        // Remove observer and scroll
        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
        }

        if (this._scrollHandler && this._desktopDrawerScroll) {
          this._desktopDrawerScroll.removeEventListener('scroll', this._scrollHandler);
        }
      },

      // Legacy alias for section manager compatibility
      onUnload: function () {
        this.destroy();
      }
    });

    return CollectionSidebar;
  })();

  theme.Collection = (function () {
    var selectors = {
      sortSelect: '#SortBy',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',

      // The one result region (C-1): main-collection.liquid and main-search.liquid both render
      // [data-ajax-grid], in every state including zero results. A grid swap replaces its
      // contents and the loading dim (.unload) goes on it. The old target,
      // .collection-grid__wrapper, is missing whenever the page shows an empty state instead
      // of a grid, which left the dim with nothing to attach to.
      collectionGrid: '[data-ajax-grid]',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      tagsForm: '.filter-form',
      filtersWrapper: '.sticky-filter--wrapper',
    };

    var classes = {
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };

    // Collection — orchestrates the entire collection page: filter pipeline, product grid AJAX,
    // URL history, and coordination between CollectionSidebar (UI) and the Section Rendering API.
    //
    // Filter pipeline (Farfetch-inspired; spec 4.4, D9: two requests per change):
    //   1. A facet change (checkbox, pill, mobile group) → _onFacetChange() starts a new
    //      GENERATION (_bump, R1) and both of its sub-operations:
    //   2. executeFilterUpdate(gen) → fetches collection-count section at once (lightweight, ~5KB)
    //      → updates count badge, filter options, size visibility, active pills
    //   3. scheduleBackgroundUpdate(gen) → debounced 300ms → _runGridFetch(gen)
    //      → fetches every registered section, validates them all, then commits them together:
    //        the result region, the header, the sticky bar and (on /search) the heading swap,
    //        then the URL is pushed. Only a grid commit (this one, or step 5's full render)
    //        writes the result region: the count path never touches it, the empty state
    //        included (Ruling 36)
    //   4. "Show Results" closes the drawer and, if that grid fetch is still out, dims the
    //      region until it ends (onFormSubmit, R4)
    //   5. Back/Forward render the address bar's state in full (_onPopState, R5)
    //   6. Clear all (clearAll, from a drawer or an empty state) is one more intent: a new
    //      generation with every user facet unchecked (the modes stay), whose count fetch and
    //      grid fetch both start at once, without the debounce
    //
    // Request ownership (C-4/C-5): this._gen names the newest intent. Every async result is
    // checked against it and dropped when a newer intent (or a teardown, destroy) started
    // since (R2), and only the current generation's outcome (commit or error) releases the
    // shared UI state: the dim, the Show Results busy state, the stale-option dim, the
    // pending flag, the toast (R3).
    // AbortController only saves bandwidth (R6); correctness never depends on it.
    // Smart disable: unchecked inputs dim briefly if user clicks faster than server responds.
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);

      this.header = document.querySelector('[data-section-type="collection-header"]')
      this.headerId = this.header?.getAttribute('data-section-id')

      // The header section is registered only when the page has one. /search has no
      // collection-header, and registering it anyway made every grid fetch also request
      // section_id=undefined.
      // marker: the result region (C-1). A grid response without it is invalid (C-5), and a
      // grid update swaps only that node; a Back/Forward render swaps #CollectionAjaxContent
      // whole (AjaxRenderer.renderPage), which must contain it too.
      // The header also needs its swap node on the page: collection-header.liquid renders
      // the section WITHOUT #CollectionHeaderAjaxContent in its hero-image branch and when
      // disabled. There is nothing to update there, and since a registered section whose
      // node is missing fails validation, registering it would turn every commit into an error.
      var ajaxSections = [
        {
          sectionId: this.sectionId,
          nodeId: 'CollectionAjaxContent',
          marker: selectors.collectionGrid,
        }
      ];
      if (this.headerId && document.getElementById('CollectionHeaderAjaxContent')) {
        ajaxSections.push({
          sectionId: this.headerId,
          nodeId: 'CollectionHeaderAjaxContent'
        });
      }

      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: ajaxSections,
        onReplace: this.onReplaceAjaxContent.bind(this),
      });

      // Request ownership (C-4/C-5, spec 4.4). They live on the instance, so a forceReload
      // (init again after a Back/Forward render) keeps them.
      //  - _gen: the current generation. Every user intent starts a new one (_bump, R1).
      //  - _readyGen: the generation whose grid is on screen ("ready", R4 a). The page load
      //    is ready: both start at 0, and init() runs destroy(), which moves to generation 1
      //    and carries the readiness over, so Show Results with nothing changed just closes
      //    the drawer.
      //  - _committed: the query of the grid on screen, as URLSearchParams#toString(): the
      //    page's own location.search at load, then each commit's (R4 0/d, R5).
      //  - _gridController: the grid fetch in flight (one at a time); _bgUpdateTimer: its
      //    pending 300 ms debounce. _bump clears both.
      //  - _countFetchPending: a count fetch is out (drives the stale-option dim).
      //  - _errorToastTimer: the one timer that removes the error toast (showFilterError). The
      //    toast itself carries the generation that raised it in data-gen (R3).
      this._gen = 0
      this._readyGen = 0
      this._committed = this._addressQuery()
      this._gridController = null
      this._bgUpdateTimer = null
      this._countFetchPending = false
      this._errorToastTimer = null

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      // _bump — R1: every user intent (a facet change, a pill, a mobile group clear or
      // select-all, clear-all, Back/Forward) starts a new generation before its
      // sub-operations, which capture the number it returns. Whatever the previous
      // generation still has in flight is aborted and its debounce cleared (bandwidth only,
      // R6: the generation check is what keeps a late answer off the page). Readiness falls
      // away by itself: _readyGen now names an older generation (R4). A teardown (destroy)
      // bumps too, so nothing it leaves in flight can commit, and carries readiness over
      // itself.
      _bump: function () {
        this._gen += 1
        this._cancelPending()
        return this._gen
      },

      // Aborts both sub-operations' fetches and clears the grid debounce: _bump's bandwidth
      // half (R6), for a new intent and for a teardown (destroy goes through _bump).
      _cancelPending: function () {
        if (this.filterAbortController) {
          this.filterAbortController.abort()
          this.filterAbortController = null
        }
        if (this._gridController) {
          this._gridController.abort()
          this._gridController = null
        }
        clearTimeout(this._bgUpdateTimer)
        this._bgUpdateTimer = null
      },

      destroy: function () {
        // Teardown (init runs it first, so a forceReload after a Back/Forward render does
        // too; so does an editor unload): nothing in flight may land on a rebuilt or removed
        // section, and no shared UI state may stay set. It moves to a new generation
        // (_bump, Ruling 39), because R6 says correctness never rests on abort: a
        // continuation that slips past the abort (its answer already in, its await queued)
        // must find a newer generation and change nothing. Aborting alone left it the
        // current one, free to commit. Readiness carries over when the grid on screen was
        // the current generation's, since a teardown changes no state: the one forceReload
        // path (theme.sections.reinit('collection-grid') in renderCollectionPage) runs just
        // after that instance's commit, so there it always does. The committed query is kept
        // as it is. A fetch of the old generation ends as superseded, so this releases what it
        // would have.
        const wasReady = this._readyGen === this._gen
        this._bump()
        if (wasReady) this._readyGen = this._gen
        this._countFetchPending = false
        this._setFilterInputsStale(false)
        this._releaseGridUi('idle')

        // Remove active tag container delegation
        if (this._activeTagContainers && this._boundActiveTagClick) {
          this._activeTagContainers.forEach(function (list) {
            list.removeEventListener('click', this._boundActiveTagClick)
          }.bind(this))
        }

        // Remove the clear-all delegation (initFilters adds it back to the same container)
        if (this._boundClearAllClick) {
          this.container.removeEventListener('click', this._boundClearAllClick)
        }

        // Remove form input/submit/keydown listeners
        if (this._filterForms) {
          this._filterForms.forEach(form => {
            if (this._boundFormInput) form.removeEventListener('input', this._boundFormInput)
            if (this._boundFormSubmit) form.removeEventListener('submit', this._boundFormSubmit)
            if (this._boundFormKeydown) form.removeEventListener('keydown', this._boundFormKeydown)
          })
        }

        // Remove the resize listener BY NAMESPACE (C-8, e47b869/a). window.off(key) removes every
        // callback registered under that key, so the old bare 'resize' removed all of them: the
        // Slideshow's included, on every re-init (a Back/Forward render, an editor reload). With
        // this section's own key it removes only what initFilters added. Nothing is registered
        // when the sticky header is off, and off() on an unknown key does nothing.
        window.off('resize' + this.namespace);

        // Remove popstate
        if (this.namespace) {
          window.off('popstate' + this.namespace);
        }
      },

      // The theme editor unloads a section before it re-renders it (theme.Sections._onSectionUnload
      // calls onUnload on the instance, when there is one). Without this the unloaded instance kept
      // every listener, and each load added another set: after two reloads one facet change started
      // three count requests (C-8, Codex C26). destroy() takes this section's own listeners and
      // fetches down. The sidebar is not a section of its own, so the editor never calls its
      // onUnload: it is taken down here, or its container and drawer listeners would answer a mobile
      // change once for each instance that was ever loaded.
      onUnload: function () {
        this.destroy()
        this.sidebar.destroy()
      },

      init: function () {
        this.destroy();
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.sidebar.init();
        // The mobile drawer's checkboxes, group clear and select-all are facet changes too (R1).
        this.sidebar._scheduleFilterUpdate = this._onFacetChange.bind(this)
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby');
      },

      // A sort change is a full navigation: the server renders the new order. The query comes
      // from the ONE builder (_buildQuery, C-2; Ruling 38), which reads the CHECKED inputs, so it
      // keeps a facet the shopper checked while its grid fetch was still out. It used to copy
      // window.location.search, which names the last COMMITTED grid (C-4), and the reload
      // dropped that facet. Only sort_by is set on top. The builder never emits page, so the
      // new order starts on page 1, and like every theme-built filter URL this one always
      // carries filter.v.availability=1 (on /search, the gender scope too) and drops tracking
      // params.
      onSortChange: function () {
        const query = this._buildQuery()
        query.set('sort_by', this.getSortValue())
        window.location.search = query.toString()
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function () {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            // After an AJAX filter swap the matching image node may be gone
            // even though the swatch still has a hover handler — guard both
            // mouseenter and mouseleave against the stale-target throw.
            var el = document.querySelector('.grid-product__color-image--' + id);
            if (!el) return;
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function () {
            var id = swatch.dataset.variantId;
            var el = document.querySelector('.grid-product__color-image--' + id);
            if (el) el.classList.remove('is-active');
          });
        });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          if (!this._boundStickyResize) {
            this._boundStickyResize = theme.utils.debounce(500, this.setFilterStickyPosition);
          }
          // Under this section's own key (C-8): destroy() removes it by that key, and a bare
          // 'resize' key is shared with other components (the Slideshow's handler), which one
          // off('resize') would remove along with this one.
          window.on('resize' + this.namespace, this._boundStickyResize);
        }

        // Create bound handlers once for proper removal
        if (!this._boundActiveTagClick) {
          this._boundActiveTagClick = this._onActiveTagClick.bind(this)
          this._boundClearAllClick = this._onClearAllClick.bind(this)
          this._boundFormInput = this.onFormInput.bind(this)
          this._boundFormSubmit = this.onFormSubmit.bind(this)
          this._boundFormKeydown = this._onFormKeydown.bind(this)
        }

        // Delegated click on pill containers — survives innerHTML replacement
        this._activeTagContainers = document.querySelectorAll(selectors.activeTagList)
        this._activeTagContainers.forEach(list => {
          list.addEventListener('click', this._boundActiveTagClick)
        })

        // One delegated listener on the section container for every clear-all control (both
        // drawers' buttons and the empty state's): see _onClearAllClick. Binding the buttons
        // one by one never reached the empty state's, which lives in the region a grid swap
        // replaces.
        this.container.addEventListener('click', this._boundClearAllClick)

        this._filterForms = document.querySelectorAll(selectors.tagsForm)
        this._filterForms.forEach(form => {
          form.addEventListener('input', this._boundFormInput);
          form.addEventListener('submit', this._boundFormSubmit);
          // The brand search box's Enter guard (_onFormKeydown), delegated like input and submit.
          form.addEventListener('keydown', this._boundFormKeydown);
        });

        this.searchEnabledFilters = []

        const searchFields = document.querySelectorAll('[data-filter-search-input]')
        searchFields.forEach(el => {
          var parent = document.getElementById(el.dataset.parentId)
          var name = el.dataset.filterSearchInput
          var valueListItem = parent.querySelectorAll('[data-filter-value]')
          var values = []

          valueListItem.forEach(item => {
            if (!values.includes(item.dataset.filterValue.toLowerCase())) values.push(item.dataset.filterValue.toLowerCase())
          })
          this.searchEnabledFilters.push({ name, parentId: el.dataset.parentId, parent, values, items: [...valueListItem] })
        })

        const hasMainCategory = document.querySelector('[data-has-main-category]')
        const hasSubCategory = document.querySelector('[data-has-sub-category]')

        if (!hasMainCategory && !hasSubCategory) {
          this.toggleSizeFilter(true)
        }
      },

      // _onClearAllClick — the one delegated click listener for every clear-all control: the
      // "Clear all" buttons of both filter drawers and the empty state's button (rendered by
      // the server in main-collection / main-search; theme.js builds no empty state since
      // Ruling 36). It sits on the section container, not on the buttons, because a grid swap
      // replaces the empty state's node and a forceReload rebuilds the drawers: a listener
      // bound button by button would be lost (or doubled) each time, a delegated one is not.
      // The hook is the [data-filter-clear-all] attribute, never a class, so restyling a
      // button cannot silently disconnect it. The buttons are type="button", so there is no
      // default action to prevent.
      _onClearAllClick: function (evt) {
        if (!evt.target.closest('[data-filter-clear-all]')) return
        this.clearAll()
      },

      // clearAll — Clear all (spec C-3), from a drawer's bottom bar or an empty state. It is
      // one user intent, so it starts a new generation like every other (_bump, R1) and runs
      // the same two sub-operations as a facet change, which is what gives it the lifecycle's
      // rules: the count fetch (executeFilterUpdate: badge, option availability, size filter,
      // pills, and its own error toast) and the grid fetch (_runGridFetch: prepare-then-swap,
      // which also replaces the empty state, the URL pushed only when it commits, and its own
      // error toast).
      // Both start now, without the 300 ms debounce, because nothing more can follow a clear;
      // the grid never waits on the count, so it refreshes even when the count fails. The URL
      // no longer changes before the fetch (the old updateUrlAfterClear), so Back after a
      // clear returns to the filtered state.
      //
      // Only USER facets are cleared. The two modes stay exactly as they are: every
      // filter.v.availability input, and a filter.p.tag input whose value is men or women,
      // any case (the gender scope: clearing it would unscope the page; the same any-case
      // test as theme.buildFilterQuery and theme.enforceSearchScope). Any other filter.p.tag
      // value is an ordinary facet and is cleared.
      clearAll: function () {
        const gen = this._bump()

        // Both forms in one pass. The desktop inputs carry name/value, the mobile twins only
        // data-name/data-value (no name at all, and a checkbox without a value attribute
        // reports "on"), so each input is read from whichever pair it has. The "All X"
        // checkboxes are .tag__input too (data-name only), so this pass unchecks them as
        // well, and every list item loses its active mark.
        this.container.querySelectorAll('input.tag__input:checked').forEach(input => {
          const named = input.name !== ''
          const name = named ? input.name : input.dataset.name
          const value = named ? input.value : input.dataset.value
          if (name === 'filter.v.availability') return
          if (name === 'filter.p.tag' && ['men', 'women'].includes(String(value).toLowerCase())) return
          input.checked = false
          input.closest('li.tag')?.classList.remove('tag--active')
        })

        // replaceChildren() leaves the lists truly empty, which the
        // .tag-list--active-tags:empty rule needs to hide the pill strip.
        this.container.querySelectorAll(selectors.activeTagList).forEach(list => list.replaceChildren())
        this._setResultsBadge('')

        // The empty state stays until the grid commit replaces the region's contents (Ruling 36:
        // the grid commit is the region's one writer). That swap removes the button the shopper
        // may just have pressed, and with it the keyboard focus (it would fall to <body>; WCAG
        // 2.2, 2.4.3). So the focus moves first: when it is inside the empty state, it goes to
        // the result region itself, a node every grid swap keeps (it swaps the contents, not the
        // node), so it still holds the focus when the cleared results land. If the grid fetch
        // fails, the empty state stays, which is right: the grid on screen still shows that
        // state. A clear from a drawer button leaves the focus where it is.
        const emptyState = document.getElementById('filter-empty-state')
        const focusInside = emptyState?.contains(document.activeElement)
        const region = focusInside ? this.container.querySelector(selectors.collectionGrid) : null
        if (region) {
          // A programmatic focus target needs a tabindex; keep one the markup already has.
          if (!region.hasAttribute('tabindex')) region.setAttribute('tabindex', '-1')
          region.focus({ preventScroll: true })
        }

        // Neither is awaited: each resolves with its own outcome and shows its own toast.
        this.executeFilterUpdate(gen)
        this._runGridFetch(gen)
      },

      // Debounced (300ms) trigger for the heavier grid fetch of generation `gen` (R4: one grid
      // fetch per generation). Separated from executeFilterUpdate so count updates are instant
      // while rapid clicks collapse into a single grid request: each click's _bump clears the
      // previous timer, and that _bump already made readiness false (a62b1b1).
      scheduleBackgroundUpdate: function (gen = this._gen) {
        clearTimeout(this._bgUpdateTimer)
        this._bgUpdateTimer = setTimeout(function () {
          this._bgUpdateTimer = null
          this._runGridFetch(gen)
        }.bind(this), 300)
      },

      // R1 for a facet change (a desktop checkbox, a pill, a mobile checkbox, a mobile group
      // clear or select-all): a new generation whose count fetch starts now and whose grid
      // fetch waits on the debounce (D9: two requests per change, one generation owns both).
      _onFacetChange: function () {
        var gen = this._bump()
        this.executeFilterUpdate(gen)
        this.scheduleBackgroundUpdate(gen)
      },

      // Dims unchecked filter checkboxes while a count fetch is in-flight.
      // Prevents clicking stale options that may no longer be valid.
      // Only triggers when user clicks faster than the server responds (~200ms) —
      // most users never see it.
      _setFilterInputsStale: function (stale) {
        // Scope to this Collection instance — two Collections on one page
        // (editor preview) would otherwise see each other's stale state.
        var root = this.container || document;
        root.querySelectorAll('.filter__list').forEach(function (list) {
          if (stale) {
            list.classList.add('filter-inputs--stale')
          } else {
            list.classList.remove('filter-inputs--stale')
          }
        })
      },

      // Core filter pipeline — the COUNT sub-operation of generation `gen` (spec 4.4), started
      // at once on every change (no debounce). Fetches collection-count section → updates:
      // count badge, filter option availability (brand/color/size counts), size filter
      // visibility (only categories can show/hide size tab), active filter pills.
      // Does NOT touch the result region, its empty state included: that is the grid
      // sub-operation's (_runGridFetch), whose commit swaps in the server's #filter-empty-state
      // with the rest of the region (Ruling 36). The JS-built empty state this used to add or
      // remove made the region two writers': a count of 0 followed by a failed grid left the
      // old cards under "No products match", and the reverse blanked the region. The two
      // validate and resolve independently; the grid commit never waits for the count.
      // Ownership (R2/R3): only the current generation's result changes anything, the stale
      // dim and _countFetchPending included (the newest call owns them, e47b869/i).
      // Resolves with its outcome: 'commit', 'superseded' or 'error'.
      executeFilterUpdate: async function (gen = this._gen) {
        if (gen !== this._gen) return 'superseded'

        // If a previous fetch is still pending, dim unchecked options to prevent stale clicks
        if (this._countFetchPending) {
          this._setFilterInputsStale(true)
        }
        this._countFetchPending = true

        var update = await this.getFilterUpdates()

        // Superseded: a newer generation started, or a teardown aborted this fetch. Nothing
        // changes, not even the flags: the newer generation's call owns them now.
        if (gen !== this._gen || update.aborted) return 'superseded'

        this._countFetchPending = false
        this._setFilterInputsStale(false)

        // Count error (spec 4.4): the toast shows and the drawer fails OPEN. Every option a
        // previous count hid comes back (a visible zero-count option is harmless; a hidden
        // valid one is a false reject), the brand letter headings follow their brands, and
        // the badge is cleared (its number would be stale). The pills still follow the
        // checked inputs: they are built from the DOM, not from the response. The next
        // interaction retries.
        if (update.error) {
          this.container.querySelectorAll('li.tag.hide').forEach(function (li) { li.classList.remove('hide') })
          this.updateBrandExtras()
          this._setResultsBadge('')
          this.renderSelectedElement()
          this.showFilterError()
          return 'error'
        }

        // Reached only on success: clear any error toast left over from an OLDER attempt now
        // that filters have updated cleanly. Only an older one: a toast of this generation is
        // its grid's (clear-all starts both fetches together, so the grid can fail first), and
        // a count success says nothing about the grid.
        this._dismissFilterError(gen)

        if (update.data?.count !== undefined) {
          this._setResultsBadge(' (' + update.data.count + ')')
          var srRegion = document.getElementById('filter-sr-announcements')
          if (srRegion) {
            srRegion.textContent = theme.strings.filterSrProductsFound.replace('[count]', update.data.count)
          }
        }

        try {
          this.updateFilter(update.html)
        } catch (e) {
          console.warn('[filter] updateFilter error:', e)
        }

        var isCategoryActive = document.querySelectorAll('input[name="filter.p.m.property.product_type"]:checked')
        var hasMainCategory = document.querySelector('[data-has-main-category]')
        var hasSubCategory = document.querySelector('[data-has-sub-category]')

        if (!hasMainCategory && !hasSubCategory) {
          this.toggleSizeFilter(true)
        } else {
          if (isCategoryActive.length > 0) {
            this.toggleSizeFilter(true)
          } else {
            this.toggleSizeFilter(false)
          }
        }

        this.renderSelectedElement()

        // Clear count when no user filters are active
        if (!document.querySelector('.tag-list--active-tags .tag--remove')) {
          this._setResultsBadge('')
        }

        // The grid fetch runs on its own debounce (scheduleBackgroundUpdate, same generation).
        return 'commit'
      },

      // The Show Results badge " (N)", and nothing else (C-8; written here because this task
      // rewrites the count writers): only the drawers' .show__all_button span[data-count] in
      // this section. A bare span[data-count] also matched the pagination's page spans
      // (snippets/pagination.liquid) and overwrote their numbers. textContent, never
      // innerHTML (Ruling 2): the count is text.
      _setResultsBadge: function (text) {
        this.container.querySelectorAll('.show__all_button span[data-count]').forEach(function (span) {
          span.textContent = text
        })
      },

      // B3: Show subtle error toast on fetch failure. Called only for a current generation's
      // error outcome, never for a superseded (aborted) request (spec 4.4, S5).
      // The toast belongs to the generation that raised it (R3): it is stamped with that
      // generation in data-gen. A failure that finds a toast already up takes it over (new
      // stamp, the one removal timer restarted) instead of leaving the older stamp and the
      // older countdown on a message about the newest failure, so the toast reports the newest
      // failure for as long as it is current, whatever succeeds beside it.
      showFilterError: function () {
        var toast = document.getElementById('filter-error-toast')
        if (!toast) {
          toast = document.createElement('div')
          toast.id = 'filter-error-toast'
          // role="status" alongside aria-live="polite" (C-5): a status message that screen
          // readers announce without moving focus or interrupting (WCAG 2.2, 4.1.3).
          toast.setAttribute('role', 'status')
          toast.setAttribute('aria-live', 'polite')
          toast.className = 'filter-error-toast'
          toast.textContent = theme.strings.filterError || 'Could not update filters. Try again.'
          var filterArea = document.querySelector('.collection-filter') || document.querySelector('.collection-grid__wrapper')
          if (filterArea) filterArea.prepend(toast)
        }
        toast.dataset.gen = String(this._gen)
        // One timer for the one toast: the previous one is cleared first, so a re-stamp
        // restarts the 3 s instead of letting the older countdown remove the new message early.
        clearTimeout(this._errorToastTimer)
        this._errorToastTimer = setTimeout(function () { toast.remove() }, 3000)
      },

      // Dismisses a STALE error toast: one raised by an older generation than `gen`, the
      // generation whose count just succeeded. A count success says nothing about the same
      // generation's grid, so a toast stamped `gen` (or newer) stays until its own timer ends
      // it. A toast with no readable stamp counts as older: there should be none, and failing
      // toward removing a stale message is the safe side (a bare `stamp < gen` would keep it,
      // because NaN compares false).
      _dismissFilterError: function (gen) {
        var toast = document.getElementById('filter-error-toast')
        if (!toast) return
        var stamp = Number.parseInt(toast.dataset.gen, 10)
        if (!Number.isNaN(stamp) && stamp >= gen) return
        clearTimeout(this._errorToastTimer)
        toast.remove()
      },

      _onActiveTagClick: function (evt) {
        var link = evt.target.closest('a[data-name]')
        if (!link) return
        evt.preventDefault()
        evt.stopPropagation()
        this.tagClick({ currentTarget: link, preventDefault: function () {} })
      },

      normalizeString: function (str) {
        return str.normalize("NFD").replace(/\p{Diacritic}/gu, "")
      },

      // Swaps the server-rendered category tree (desktop panel and mobile item) into the open page
      // after a filter change. The category panel is found by data-collapsible-id="filter-category",
      // which collection-grid-filters-form-v2 derives from the category ROLE (filter.param_name, via
      // snippets/filter-role.liquid), so it is the same id in every locale. The old 'filter-kategori'
      // fallback is gone on purpose (C-6): a label-derived id gave the same filter different behaviour
      // per language, and an unknown or renamed filter is simply 'other' (no panel found, no swap).
      // C-7: the panel ids it builds selectors from are label-derived (filter.label | handleize), so
      // each is CSS.escape'd before it enters a selector; a handle that is not a plain identifier
      // (a leading digit, an unusual character) can then neither throw nor match the wrong node.
      // C-8, null guards: the live page and the count response can disagree mid-session (the response
      // has no category block). Each swap then does nothing: before, the desktop half threw on
      // categoryDesktopNew.id, which aborted the count, brand and size updates queued after it in
      // updateFilter, and the mobile half ran replaceWith(null), which inserts the text "null" into
      // the drawer. A swap that does not happen also toggles nothing (followTree needs the tree).
      // The old trigger parameter is gone with its 'clear-all' branch: no caller ever passed it (a
      // clear-all runs the same count pipeline as any filter change), so the branch was unreachable.
      updateCategory: function (html) {
        const hasCategory = document.querySelector('#FilterDrawerMobile [data-main-category-count]')
        if (!hasCategory) return;

        // The drawer's category panel and its button, both looked up inside #FilterDrawer. #FilterDrawer is the form
        // the count section's tree belongs to (its trees are rendered with location SidebarDrawer). A sidebar form
        // (filter_style 'sidebar') would come first in the document and reuse the same collapse id pattern, so it
        // is never matched (final gate rounds 11-12). updateCategory serves the drawer form only: both templates
        // pass filter_style 'drawer' today, and a sidebar layout would need its own tree updated too.
        const filterDrawer = document.getElementById('FilterDrawer')
        const collapsibleWrapper = filterDrawer?.querySelector('.accordion-collapse[data-collapsible-id="filter-category"]')
        if (!collapsibleWrapper) return;
        const collapsibleButton = filterDrawer.querySelector(`.accordion-button[data-bs-target="#${CSS.escape(collapsibleWrapper.id)}"]`)
        if (!collapsibleButton) return;

        const collapsibleWrapperMobile = document.querySelector('[data-main-category-count]')
        if (!collapsibleWrapperMobile) return;

        // After a swap the group follows the tree now inside it (fix round 2, lead #51). facets-category and
        // facets-category-mobile print a data-category-empty marker exactly when the tree has no visible option, and
        // the group's wrapper (the desktop accordion item, the mobile drawer entry) carries the hidden class exactly
        // then. The wrapper sits OUTSIDE the swapped content, so without this a group that was hidden at page load
        // (a zero-result page) would stay hidden after the shopper clears the filter, and a group whose tree became
        // empty would show a heading with nothing under it. A missing group or tree changes nothing; a marker that
        // is absent means the group is shown (the markup's own rule: it fails open).
        const followTree = (group, tree) => {
          if (group && tree) group.classList.toggle('hidden', tree.querySelector('[data-category-empty]') !== null)
        }

        // Use string compare instead of JSON.parse to tolerate any non-boolean
        // value an editor session might leave behind.
        const isCategoryOpen = collapsibleButton.getAttribute('aria-expanded') === 'true'
        const isCategoryActive = collapsibleWrapperMobile.classList.contains('is-active')

        // The menu each tree was built from: data-category-map, on the desktop tree's hidden span and on the
        // mobile li[data-category-main] (facets-category / facets-category-mobile, lead ruling #56). On /search
        // that menu follows the shopper's Men/Women scope, and the header toggle can flip the scope without a page
        // load: the next update is then built from the other gender's menu (final gate round 9). Missing on both
        // sides reads as equal, so older markup keeps the old behaviour.
        const menuOf = (el) => (el?.matches('[data-category-map]') ? el : el?.querySelector('[data-category-map]'))?.getAttribute('data-category-map') ?? null

        // A swap of an OPEN tree (below) can remove the element the shopper is on: the scope flipped, then they
        // ticked a box in that tree. The focus then goes to the same facet's input in the new tree (theme.facetInputs,
        // by name and value, or by data-name and data-value for the mobile twins), else to the group's own control,
        // so it never falls to <body> (WCAG 2.2, 2.4.3). A twin that cannot take the focus (its row hidden at count
        // 0, or inside a collapsed sub-accordion) is detected by checking document.activeElement afterwards, and the
        // fallback is used then too. A closed tree cannot hold the focus, so for the usual swap this does nothing.
        // Gives the focus to the first of these controls that really takes it (connected, visible, focusable), so it
        // never ends on <body> or on a node a swap just hid.
        const focusFirstOf = (...candidates) => {
          for (const el of candidates) {
            el?.focus({ preventScroll: true })
            if (el && document.activeElement === el) return
          }
        }
        const swapKeepingFocus = (oldTree, newTree, fallback) => {
          const active = document.activeElement
          const hadFocus = Boolean(active) && oldTree.contains(active)
          oldTree.replaceWith(newTree)
          if (!hadFocus) return
          let twin = null
          if (active.matches('input[name]')) {
            twin = theme.facetInputs(newTree, active.getAttribute('name'), active.getAttribute('value'))[0]
          } else if (active.matches('input[data-name]')) {
            twin = theme.facetInputs(newTree, active.getAttribute('data-name'), active.getAttribute('data-value'), { data: true })[0]
          }
          focusFirstOf(twin, fallback)
        }

        // An open panel (desktop) or an active one (mobile) is not swapped, because the shopper is working in that
        // tree. The one exception is a response built from ANOTHER menu: the tree on screen then lists the other
        // gender's categories under these results, so it is swapped even while open.
        // The live desktop tree is found by its ROLE: the first .accordion-content inside the category panel
        // (data-collapsible-id="filter-category"), never by the id it carries (final gate round 10). That id
        // embeds the category filter's position among the filters, and search.filters lists only the filters
        // relevant to the current results, so the position moves whenever an earlier filter comes or goes
        // (a scope flip, a facet change). The tree then silently stopped updating. The response's tree is the
        // count section's one [data-category] container.
        const categoryDesktopNew = html.querySelector('[data-category] .accordion-content')
        const categoryDesktopCurrent = categoryDesktopNew ? collapsibleWrapper.querySelector('.accordion-content') : null
        if (categoryDesktopCurrent && (!isCategoryOpen || menuOf(categoryDesktopCurrent) !== menuOf(categoryDesktopNew))) {
          swapKeepingFocus(categoryDesktopCurrent, categoryDesktopNew, collapsibleButton)
          const desktopGroup = categoryDesktopNew.closest('.accordion-item[data-role="category"]')
          followTree(desktopGroup, categoryDesktopNew)
          // An emptied group is hidden by followTree. A focus inside it (on its button, the hand-off's fallback,
          // or on a node that stayed) would then sit on a hidden node (final gate round 11), so it moves on to the
          // drawer's next visible group button, else the drawer's close button. A focus elsewhere is left alone.
          // Only TOP-LEVEL group headers qualify (a group item carries data-role; nested accordions inside a tree
          // do not). A nested button of the just-hidden Category group lacks .hidden on its own item but cannot
          // take the focus (final gate round 12).
          if (desktopGroup?.classList.contains('hidden') && desktopGroup.contains(document.activeElement)) {
            focusFirstOf(
              filterDrawer.querySelector('.accordion-item[data-role]:not(.hidden) > .accordion-header > .accordion-button'),
              filterDrawer.querySelector('.js-drawer-close')
            )
          }
        }

        const categoryMobileNew = html.querySelector('li[data-category-main]')
        const categoryMobileCurrent = document.querySelector('li[data-category-main]')
        // Both ends are needed: replaceWith(null) would insert the text "null".
        if (categoryMobileCurrent && categoryMobileNew && (!isCategoryActive || menuOf(categoryMobileCurrent) !== menuOf(categoryMobileNew))) {
          // The mobile fallback is the panel's own back button, which sits outside the swapped item.
          swapKeepingFocus(categoryMobileCurrent, categoryMobileNew, collapsibleWrapperMobile.querySelector('[data-back]'))
          // An ACTIVE panel whose new tree is empty would be hidden by followTree while the drawer still shows
          // it: a blank level with no way back, because its back button is inside it (final gate round 10). So
          // leave the panel first through its own back button (as applyGroup does). Then hand the focus to the
          // drawer's first visible top-level entry, since the panel's own entry is about to be hidden.
          if (isCategoryActive && categoryMobileNew.querySelector('[data-category-empty]')) {
            collapsibleWrapperMobile.querySelector('[data-back]')?.click()
            followTree(collapsibleWrapperMobile, categoryMobileNew)
            // When Category was the only visible entry, there is no other entry to take the focus: the drawer's
            // own close button does then (final gate round 11). Only a focus that sits inside the now-hidden entry
            // moves: a focus the swap did not displace is left alone (final gate round 12).
            if (collapsibleWrapperMobile.contains(document.activeElement)) {
              focusFirstOf(
                collapsibleWrapperMobile.closest('ul.slide-nav')?.querySelector(':scope > li.mobile-nav__item:not(.hidden) > .js-toggle-submenu'),
                document.querySelector('#FilterDrawerMobile .js-drawer-close')
              )
            }
          } else {
            followTree(collapsibleWrapperMobile, categoryMobileNew)
          }
        }
      },

      // Generic, LABEL-AGNOSTIC count application. Replaces the old per-label
      // updateBrand/updateColor/updateSize trio. Those hard-coded a short list of
      // translated label keys (`data['brand'/'märke'/'varumärke']`, `['color'/'färg']`,
      // `['size'/'storlek']`) to find each filter's data in the count payload — but the
      // payload is keyed by the RAW translated filter label, which drifts across
      // languages and Search & Discovery config. Any filter whose label wasn't on the
      // list (e.g. a "TC-Storlek-TC" size, a non-umlaut "Marke") rendered fine but then
      // silently stopped receiving count updates. Matching each option by param_name +
      // value instead is immune to labels entirely, and covers every filter type at once.
      // Category is deliberately excluded — updateCategory() owns the category tree via
      // server-rendered HTML, and hiding a parent category by its own count would fight it.
      // C-7 (Ruling 4): each option's inputs, desktop and mobile, are found by comparison
      // (theme.facetInputs, both modes), never by a selector built from the value, so a value with
      // a quote or bracket (e.g. a `32"` size) can neither throw and abort the whole pass nor match
      // the wrong input. The payload's value is decoded first: Shopify HTML-escapes
      // filter_value.value (it reads `Dolce &amp; Gabbana` there), while the DOM attribute holds
      // the decoded value (G24).
      updateFilterCounts: function (html) {
        const scriptEl = html.querySelector('[data-product-count]')
        if (!scriptEl) return

        let data
        try {
          data = JSON.parse(scriptEl.textContent)
        } catch (e) {
          console.warn('[filter] updateFilterCounts parse error:', e)
          return
        }

        Object.keys(data).forEach(key => {
          const values = data[key]
          if (!Array.isArray(values)) return // skip scalars: count, has_category_filter, price
          values.forEach(item => {
            if (!item || !item.param_name) return
            // Category is owned by updateCategory() (tree, server-rendered) — leave it alone.
            if (item.param_name === 'filter.p.m.property.product_type') return
            const value = theme.utils.decodeString(item.value)
            const inputs = theme.facetInputs(document, item.param_name, value).concat(theme.facetInputs(document, item.param_name, value, { data: true }))
            inputs.forEach(input => {
              const li = input.closest('.tag')
              if (!li) return
              if (item.count <= 0) {
                li.classList.add('hide')
              } else {
                li.classList.remove('hide')
              }
            })
          })
        })
      },

      // Brand-specific post-processing, run AFTER updateFilterCounts has set each brand
      // option's .hide state. Also label-agnostic: brand lists are found by the structural
      // data-brand-value hook and letter groups by data-alpha-group (both emitted by
      // facets-brand.liquid), so no filter-label matching is involved. Reads the DOM's
      // post-count-pass state rather than re-deriving counts from the payload.
      updateBrandExtras: function () {
        const brandLists = new Set()
        document.querySelectorAll('[data-brand-value]').forEach(el => {
          const ul = el.closest('ul')
          if (ul) brandLists.add(ul)
        })
        if (brandLists.size === 0) return

        brandLists.forEach(ul => {
          // Hide an alpha-group header (A, B, C…) when every brand under that letter is hidden.
          // The letter is the first character of a brand value (catalogue data), so it is
          // CSS.escape'd before it enters the selector (C-7). No identity fallback: this module
          // already needs a browser with optional chaining, and every such browser has CSS.escape.
          ul.querySelectorAll('li.brands__alpha-group').forEach(header => {
            const letter = header.getAttribute('data-value')
            if (letter === null) return
            const visible = ul.querySelectorAll(`li.tag[data-alpha-group="${CSS.escape(letter)}"]:not(.hide)`).length
            if (visible === 0) {
              header.classList.add('hide')
            } else {
              header.classList.remove('hide')
            }
          })

          // Show the brand search box only when there are enough visible brands to be
          // worth searching (mirrors the Liquid > 4 threshold in collection-grid-filters-form-v2).
          const visibleBrands = ul.querySelectorAll('li.tag:not(.hide)').length
          const searchWrapper = ul.closest('.accordion-content')?.querySelector('.filter-search--wrapper')
          if (searchWrapper) {
            searchWrapper.style.display = visibleBrands > 4 ? '' : 'none'
          }
        })
      },

      updateFilter: function (html) {
        this.updateCategory(html)
        this.updateFilterCounts(html)
        this.updateBrandExtras()
      },

      // C-2: the checked NAMED inputs of this section as [name, value] pairs, in
      // DOM order: the facets theme.buildFilterQuery takes. Named inputs only,
      // because the mobile drawer's inputs carry data-name/data-value and mirror
      // into the desktop form's named ones, so each facet is read once. An empty
      // name or value is no facet (the old inline loops' `name && value` test).
      _checkedFacets: function () {
        var facets = [];
        this.container.querySelectorAll('input[name]:checked').forEach(function (input) {
          var name = input.getAttribute('name');
          var value = input.getAttribute('value');
          if (name && value) facets.push([name, value]);
        });
        return facets;
      },

      // C-2: the one adapter from this page to theme.buildFilterQuery, so the count
      // fetch and the grid fetch build the SAME query from the same state
      // (before C-2 they were two inline copies that had drifted apart). Pass
      // facets to override the checked inputs: only renderSelectedElement does, for each pill's
      // remove-link (the checked facets minus that pill's own, Ruling 15). Clear-all does not pass []:
      // it unchecks the user facets and builds from what stays checked, so a mode that
      // stays checked (a collection's gender tag) still reaches the builder.
      _buildQuery: function (facets = this._checkedFacets()) {
        return theme.buildFilterQuery({
          search: window.location.search,
          isSearchPage: theme.isSearchPage(),
          facets: facets
        });
      },

      // IMPORTANT: This fetches sections/collection-count.liquid via Section Rendering API.
      // That section is NOT in any template JSON — it exists solely for this AJAX call.
      //
      // F4: plain `async` function rather than `new Promise(async …)`. The old wrapper
      // could leave the promise pending forever if anything threw before its inner
      // try/catch; an async function rejects on any throw, so callers can't hang.
      // F1: returns a DISCRIMINATED result so executeFilterUpdate can tell the three
      // outcomes apart instead of collapsing them all to null:
      //   - { data, html }  → success
      //   - { aborted: true } → superseded by a newer fetch (not a failure, no toast)
      //   - { error: true }   → genuine failure. The caller shows the toast, and only for
      //                          its current generation (R3): a superseded failure is silent.
      // C-5 validation: response.ok, then script[data-product-count] with JSON that parses.
      getFilterUpdates: async function () {
        // One count fetch in flight: a newer one aborts the older (bandwidth only, R6; the
        // caller's generation check is what drops a late answer).
        if (this.filterAbortController) this.filterAbortController.abort()
        const controller = this.filterAbortController = new AbortController()
        var fetchSignal = controller.signal

        // Whole body inside try/catch so this function is TOTAL — it always resolves to
        // a discriminated object and never rejects. Both callers `await` it WITHOUT a
        // try/catch and depend on the code that runs AFTER the await (clearing
        // _countFetchPending and the stale-input dimming); a reject would skip that and
        // leave the filter checkboxes stuck dimmed. Completes F4: no path can hang OR throw.
        try {
          // C-2: the count query comes from the one builder, so it is the same
          // query the grid fetch builds from the same checked state. That
          // replaces three things: the whole-URL copy on search (it kept unchecked
          // facets and page, F11); the availability append (the builder adds it
          // exactly once); and the forced sort_by=price-descending (e47b869/k):
          // the URL's own sort_by is kept, and the count section's only
          // order-dependent value, range_max, renders only under a price filter
          // that no JS reads. The builder's last step stamps the gender scope
          // (theme.enforceSearchScope), so the count can never carry BOTH genders
          // nor lose the scope.
          const url = window.location.origin + window.location.pathname + '?' + this._buildQuery().toString() + '&section_id=collection-count'

          const response = await fetch(url, { signal: fetchSignal });
          // An error status (a 500 or 429 page) is a failed count, never data (C-5).
          if (!response.ok) throw new Error('count request HTTP ' + response.status)
          const html = await response.text()

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const scriptTag = doc.querySelector('script[data-product-count]');

          // Response arrived but the count payload was missing — surface it as a
          // failure so the user gets feedback rather than a silently stale badge.
          if (!scriptTag) throw new Error('the count response has no script[data-product-count]')

          // Parse the JSON data (throws on malformed payload → caught below as an error)
          const data = JSON.parse(scriptTag.textContent);
          return { data, html: doc }
        }
        catch (error) {
          // Aborted = a newer fetch or a teardown superseded this one. Not a failure: no toast.
          if (error.name === 'AbortError') {
            return { aborted: true }
          }
          console.warn('[filter] getFilterUpdates fetch error:', error)
          return { error: true }
        }
        finally {
          // Only its own controller: a late answer must not clear a newer fetch's.
          if (this.filterAbortController === controller) this.filterAbortController = null
        }
      },

      // A pill's removal (delegated from _onActiveTagClick): unchecks the facet it stands for, then
      // starts a facet change. C-7: every input is found by comparison (theme.facetInputs), never by
      // a selector built from the pill's data-name / data-value, which are catalogue data (a quote or
      // bracket in a value threw a SyntaxError here).
      // C-8 (Ruling 26): the facet goes through theme.setFacetChecked, so EVERY copy of it is
      // cleared (both desktop forms of the sidebar layout, a value under two menu leaves, every
      // mobile twin) and the "All" box of each copy's group is cleared on both sides.
      // theme.buildFilterQuery reads every checked named input, so a copy left checked would keep the
      // removed filter in the next query. Before, the mobile twin was the first match only, and an
      // "All X" pill cleared the desktop drawer's box and rows alone.
      tagClick: function (evt) {
        var el = evt.currentTarget;
        evt.preventDefault()

        const name = el.dataset.name
        const value = el.dataset.value
        const isAll = el.dataset.isAll === 'true'

        if (isAll) {
          // "All X" pill: it stands for a CHECKED "All X" box, found by its data-name alone
          // (theme.facetInputs' name-only mode, Ruling 4: the box has no value of its own) in the
          // desktop drawer, whose rows the pills are built from. Several groups can share a title,
          // and so a data-name: the checked box is the one the pill stands for (the first box only
          // when none is checked, a stale pill).
          const desktopDrawer = document.getElementById('FilterDrawer')
          const boxes = desktopDrawer ? theme.facetInputs(desktopDrawer, name, undefined, { data: true }) : []
          const allCheckbox = boxes.find(box => box.checked) || boxes[0]
          const list = allCheckbox?.closest('.filter__list')
          if (list) {
            // The steps of onFormInput's "All" branch: every row of the group goes onto all copies of
            // its facet (the other desktop form and the mobile twins), then the boxes of those lists,
            // this one and its counterparts, are derived from their rows (all unchecked now).
            const copies = []
            list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(input => {
              copies.push(...theme.setFacetChecked(this.container, input.getAttribute('name'), input.getAttribute('value'), false))
            })
            theme.syncAllBoxes(copies.concat(allCheckbox))
          }
        } else {
          // Every copy of the pill's facet. The server prints the checked attribute for an active
          // value, and a pill removal has always dropped it along with the state, so each copy's
          // default follows its property (nothing reads the attribute today; only a form reset, which
          // restores the default, would see the difference).
          theme.setFacetChecked(this.container, name, value, false).forEach(input => input.removeAttribute('checked'))
        }

        el.remove()

        var srRegion = document.getElementById('filter-sr-announcements')
        if (srRegion) srRegion.textContent = theme.strings.filterSrFilterRemoved

        // A pill removal is a facet change (R1).
        this._onFacetChange()
      },

      // renderSelectedElement — the active-filter pills of both drawers, rebuilt from the desktop
      // form's checked inputs (C-7, spec 5; Ruling 15). Callers: executeFilterUpdate (every count
      // outcome) and renderCollectionPage (every full render).
      //  - Inert data: each pill is built with DOM APIs (createElement, textContent, setAttribute).
      //    A facet label or value is catalogue data and may hold quotes, ampersands or angle
      //    brackets; in the old HTML template one broke an attribute or became markup. The only
      //    markup string left is the constant close icon.
      //  - The pill's href is its no-JS fallback (a middle-click, a copied link): the state shown
      //    minus this pill, from the ONE query builder over the checked facets (_checkedFacets and
      //    _buildQuery, C-2). It used to copy window.location.search, which since C-4 moves only
      //    when the grid commits, so after a second add the first pill's link dropped the other
      //    facet (S9). It is pathname + query: no bare "?" and no trailing-slash path.
      //  - Rules kept: a wrapper without .tag__text, or an input without a name, gets no pill
      //    (7fc8d71: one threw and blanked every list, the other printed data-name="null");
      //    filter.p.tag never gets one (the gender scope is a mode; this mirrors
      //    active-filter-pills.liquid, so a non-gender tag value has no pill either); a checked
      //    "All X" box gets one pill and the items of its group none. The old "in stock" text guard
      //    is gone: availability is a hidden input with no wrapper, so it never reached this loop.
      //  - Each list's children are replaced in one call, by clones, so a list without pills is
      //    truly empty (the .tag-list--active-tags:empty rule hides the strip).
      renderSelectedElement: function () {
        // One key per [name, value] pair. NUL never occurs in an attribute, so the join is
        // unambiguous (the old '=' join merged a=b|c with a|b=c), as in theme.buildFilterQuery.
        const pairKey = (name, value) => name + '\u0000' + value
        // The keys of the items an "All X" box stands for: the named inputs of its .filter__list.
        const groupKeys = allInput => {
          const keys = new Set()
          allInput.closest('.filter__list')?.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(input => {
            const n = input.getAttribute('name')
            const v = input.getAttribute('value')
            if (n && v) keys.add(pairKey(n, v))
          })
          return keys
        }

        // Items of a group whose "All X" box is checked get no pill of their own (only that group's:
        // items of other subcategories still show).
        const coveredByAll = new Set()
        document.querySelectorAll('#FilterDrawer .tag__input--all:checked').forEach(allInput => {
          groupKeys(allInput).forEach(key => coveredByAll.add(key))
        })

        const facets = this._checkedFacets()
        // t output arrives HTML-escaped (G19) and setAttribute writes plain text, so it is decoded once.
        const srLabel = theme.utils.decodeString(theme.strings.filterSrRemoveFilter)
        const pills = []
        document.querySelectorAll('#FilterDrawer .tag__checkbox-wrapper').forEach(label => {
          const inputEl = label.querySelector('input:checked')
          if (!inputEl) return
          const isAll = inputEl.classList.contains('tag__input--all')
          const ownKey = pairKey(inputEl.getAttribute('name'), inputEl.getAttribute('value'))
          // An item whose group has its "All X" box checked: that box's pill stands for it.
          if (!isAll && coveredByAll.has(ownKey)) return
          const textEl = label.querySelector('.tag__text')
          const name = inputEl.getAttribute('name') || inputEl.getAttribute('data-name')
          // 7fc8d71: no text or no name, no pill.
          if (!textEl || !name) return
          // The gender scope is a mode, not a removable filter.
          if (name === 'filter.p.tag') return

          // The remove-link's state: the checked facets minus this pill's own pair (an "All X" pill:
          // minus every item of its group), through the one builder.
          const removed = isAll ? groupKeys(inputEl) : new Set([ownKey])
          const query = this._buildQuery(facets.filter(([n, v]) => !removed.has(pairKey(n, v)))).toString()
          const text = textEl.textContent

          const link = document.createElement('a')
          link.className = 'btn btn--small'
          link.setAttribute('href', window.location.pathname + (query ? '?' + query : ''))
          link.setAttribute('data-name', name)
          link.setAttribute('data-value', inputEl.value)
          if (isAll) link.setAttribute('data-is-all', 'true')
          // A replacer function, so a `$&` or `$1` in a label is inserted as written (a replacement
          // string would expand it).
          link.setAttribute('aria-label', srLabel.replace('[filter]', () => text))
          // The label in a span, a space, then the icon: the server pill's shape
          // (active-filter-pills.liquid), so both render alike.
          const textSpan = document.createElement('span')
          textSpan.textContent = text
          link.append(textSpan, ' ')
          // The constant close icon: the only markup string left, with no data in it.
          link.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>')
          const pill = document.createElement('li')
          pill.className = 'tag tag--remove'
          pill.append(link)
          pills.push(pill)
        })

        document.querySelectorAll('.tag-list.tag-list--active-tags').forEach(list => {
          list.replaceChildren(...pills.map(pill => pill.cloneNode(true)))
        })
      },

      // After a full render (Back/Forward) every group's "All" box is derived again from its rows, by
      // the one rule in theme.syncAllBoxes. That rule counts EVERY row, hidden ones included, because
      // it is the server's: facets-category(-mobile) print the box checked when every printed row is
      // active, and a row printed hidden is an active value at count 0 (Ruling 24). The old code here
      // counted only rows without the hide class, so a group whose rows were all active and hidden
      // was printed checked and then unchecked by this pass (C-8, Task 6's carried concern).
      syncAllCheckboxes: function () {
        theme.syncAllBoxes(document.querySelectorAll('#CollectionSidebar .tag__input--all'))
      },

      // Handles every desktop filter form input change. Runs synchronously for UI sync (C-8: after
      // it, the desktop and mobile checked sets are equal): the change goes onto EVERY copy of the
      // facet, mobile twins and the other desktop form included, "All" checkbox toggling and its
      // mirror, tag-active class, category mutual exclusion. Then starts a new generation
      // (_onFacetChange, R1) and its two async paths:
      //   1. executeFilterUpdate(gen) — immediate count + filter option refresh
      //   2. scheduleBackgroundUpdate(gen) — debounced grid fetch and commit
      // Search inputs return early (immediate client-side filtering, no fetch, no generation:
      // typing in the brand box changes no filter state).
      onFormInput: function (evt) {
        var el = evt.target;
        var isAll = el.classList.contains('tag__input--all')

        // "All" checkbox: check/uncheck every row of its group. Each row goes onto all copies of its
        // facet (theme.setFacetChecked), so the mobile twins follow too; before, only the rows of this
        // list changed and the mobile drawer kept its old state. Then the "All" box of every group
        // those copies sit in, this box and its mobile counterpart included, is derived from its rows
        // (theme.syncAllBoxes), so both sides show the same box.
        if (isAll) {
          // The state the shopper chose, read ONCE: setFacetChecked derives this very box from the rows as it
          // sets them, so el.checked is not the choice any more after the first row.
          var on = el.checked
          var copies = []
          var list = el.closest('.filter__list')
          if (list) {
            list.querySelectorAll('.tag__input:not(.tag__input--all)').forEach(row => {
              copies.push(...theme.setFacetChecked(this.container, row.getAttribute('name'), row.getAttribute('value'), on))
            })
          }
          // The closing pass: setFacetChecked has derived the boxes after each row, so this changes nothing when
          // the rows followed; it also covers THIS box, so it never stays ticked over rows that could not follow
          // (a row without a facet identity has no copy to set).
          theme.syncAllBoxes(copies.concat(el))
        }

        // Search filtering — immediate, no fetch pipeline
        if (el.hasAttribute('data-filter-search-input')) {
          var params = el.value
          var ref = el.dataset.parentId
          var filterInfo = this.searchEnabledFilters.find(function (_) { return _.parentId == ref })

          if (filterInfo) {
            var alphaList = filterInfo.parent.querySelectorAll('.brands__alpha-group')
            alphaList.forEach(function (item) { item.classList.add('hidden') })
            var normalizedParams = this.normalizeString(params.toLowerCase())
            var filteredList = filterInfo.values.filter(function (_) { return this.normalizeString(_).includes(normalizedParams) }.bind(this))
            filterInfo.items.forEach(function (item) {
              var value = item.dataset.filterValue.toLowerCase()
              if (!filteredList.includes(value)) {
                if (!item.classList.contains('hidden')) item.classList.add('hidden')
              } else {
                if (item.classList.contains('hidden')) item.classList.remove('hidden')
                if (alphaList.length > 0) {
                  // The brand's letter heading. The letter is the first character of a brand value
                  // (catalogue data), so it is CSS.escape'd before it enters the selector (C-7); a
                  // brand without a heading is skipped instead of throwing on null.
                  const heading = filterInfo.parent.querySelector('.brands__alpha-group[data-value="' + CSS.escape(item.dataset.alphaGroup) + '"]')
                  if (heading) heading.classList.remove('hidden')
                }
              }
            })
            filterInfo.parent.style.height = 'unset'
          }
          return
        }

        // A row: its state goes onto every copy of the facet (this input, the other desktop form's input
        // of the sidebar layout, every mobile twin), their tag-active marks follow, and the "All" box of its
        // group is derived from its rows on both sides (theme.setFacetChecked): an unchecked row clears it,
        // the last unchecked row ticks it. The copies are found
        // by comparison (theme.facetInputs, C-7), never by a selector built from the value: the value is
        // catalogue data, and a quote or bracket in it threw a SyntaxError here, which also skipped the
        // facet change below. The old code reached only the first mobile twin, left the other desktop
        // form alone, cleared only this side's "All" box, and never ticked it.
        if (!isAll) {
          theme.setFacetChecked(this.container, el.getAttribute('name'), el.getAttribute('value'), el.checked)
        }

        // Category mutual exclusion
        var parent = el.closest('[data-category-main]')
        if (parent) {
          this.clearOtherMainCategory(parent)
        }

        // A1 + A2: count now, grid fetch debounced at 300ms, both owned by one new generation
        this._onFacetChange()
      },

      // Shows (isActive) or hides the size filter once a category is chosen: sizes differ per category.
      // Both hooks are locale-stable: the desktop accordion by data-role="size" (the size ROLE, from
      // filter.param_name), the mobile drawer item by [data-size]. The old [data-label="size"] matched
      // the translated label, so the size panel never toggled on a store whose label is not literally
      // 'size' (e.g. Swedish 'storlek'). Nothing else is selected: other roles and unknown filters stay.
      toggleSizeFilter: function (isActive) {
        const sizeFilterWrapper = document.querySelectorAll(`.slide-nav__item.mobile-nav__item[data-size], .accordion-item[data-role="size"]`)
        if (sizeFilterWrapper.length !== 0) {
          sizeFilterWrapper.forEach(item => {
            if (isActive) {
              item.classList.remove('hidden')
            } else {
              item.classList.add('hidden')
            }
          })
        }
      },

      clearOtherMainCategory: function (currentCategory) {
        theme.utils.clearOtherMainCategory(currentCategory, this.container)
      },

      // The brand search box's Enter guard (C-8, e47b869/c). Enter in a text field submits the form it
      // sits in, and #facets-form is one: onFormSubmit then ran Show Results in the middle of typing
      // (closed the drawers and started a grid fetch). The list is filtered live by onFormInput as the
      // shopper types, so Enter has nothing left to do; cancelling the keydown's default is what stops the
      // implicit submission. Delegated on the form like input and submit, and it acts on the search box
      // alone: Enter on a checkbox or a button keeps its meaning.
      _onFormKeydown: function (evt) {
        if (evt.key === 'Enter' && evt.target.hasAttribute('data-filter-search-input')) evt.preventDefault()
      },

      // Show Results: the form's submit. evt.target is always the FORM here (a submit event is
      // dispatched on the form), so the old `isSearch` branch, keyed on a data-filter-search-input
      // attribute the form never has, could not run (C-8, e47b869/b); the brand search filters in
      // onFormInput and its Enter is cancelled by _onFormKeydown.
      onFormSubmit: function (evt) {
        var el = evt.target;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if (theme.FilterDrawerMobile) {
          theme.FilterDrawerMobile.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();

        // Show Results (spec 4.4 R4): exactly one branch runs; the drawer is already
        // closed. There is no second render path any more: the old fallback
        // (renderFromFormData) rendered and pushed a second time whenever the debounce had
        // not fired yet (N2). No lock either: each branch is safe to re-enter (a second
        // press while waiting lands in (b) and changes nothing), and the busy signal is
        // the button's loading state, which the outcome releases (R3).
        const query = this._buildQuery().toString()
        const shown = this._addressQuery()

        // (0) Nothing changed: the built query is the committed one and the address bar
        // shows it. No fetch, no history entry.
        if (query === this._committed && shown === this._committed) {
          this._settleUnchanged(this._gen)
          return
        }

        // (a) Ready: this generation's grid has already committed.
        if (this._readyGen === this._gen) return

        // (b), (c) and (d) wait for an outcome. Dim the region and mark the button busy
        // first, so an outcome that lands at once still finds them to release (R3).
        this.startLoading()
        this.setShowResultsState('loading')

        // (b) This generation's debounce is pending: fire it now. A grid fetch already in
        // flight is simply waited on: its outcome releases the dim.
        if (this._bgUpdateTimer) {
          clearTimeout(this._bgUpdateTimer)
          this._bgUpdateTimer = null
          this._runGridFetch(this._gen)
          return
        }
        if (this._gridController) return

        // (d) The grid shows the committed state but the address bar does not: a
        // Back/Forward render failed and left them apart. Retry the address bar's state
        // the way popstate does. Checked before (c), which would push the grid's state
        // over the address bar's instead.
        if (query === this._committed) {
          this._onPopState()
          return
        }

        // (c) Nothing pending, or the last grid fetch failed: start it now.
        this._runGridFetch(this._gen)
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },

      // AjaxRenderer's swap hook for a full render: re-opens, in the new DOM, every sidebar panel that
      // was open, then swaps the node. The panel keys are 'filter-<role>' or, for role 'other',
      // 'filter-<label handle>' (Task 6), so they are label-derived and CSS.escape'd before they
      // enter the selector (C-7); the value is also quoted now, which an empty key needs.
      // For the main section it also refreshes the /search heading from the same response
      // (_refreshSearchHeading, Ruling 40): the heading sits outside #CollectionAjaxContent, so a
      // Back/Forward render left it naming the state the shopper had left. renderPage calls this
      // hook only after every section validated, the heading included (renderCollectionPage's
      // validate, Ruling 46), so the order stays prepare-then-swap.
      onReplaceAjaxContent: function (newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach(id => {
          newDom
            .querySelectorAll(`[data-collapsible-id="${CSS.escape(id)}"]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
        if (section.sectionId === this.sectionId) this._refreshSearchHeading(newDom)
      },

      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }

        el.classList.add(classes.isOpen);
      },

      // renderCollectionPage — the full render of one COMPLETE URL state (spec 4.4 R5), run as
      // the current generation's grid sub-operation: Back/Forward and Show Results' retry
      // (R4 d) call it through _onPopState, after a _bump. The whole #CollectionAjaxContent
      // (sticky bar, drawers, region) and the header are rebuilt from the server, so the
      // checked inputs match the state shown again. AjaxRenderer.renderPage prepares every
      // section and swaps only while this generation is current (a cache hit too), so the
      // outcome is one of the table's:
      //  - commit: _committed becomes the scope-enforced query. When the scope authority
      //    changed the popped params (the gender toggle flipped since), replaceState makes
      //    the address bar name what is shown. Everything the render replaced is re-initialised.
      //  - superseded: a newer generation (or a teardown's abort) owns the page: nothing.
      //  - error: _gridFailed. _committed keeps the state on screen, so the next Show Results
      //    retries the address bar's state (R4 d).
      // Nothing is pushed unless updateURLHash (no caller passes it since the submit
      // fallback went). Resolves with the outcome; never rejects before the commit.
      renderCollectionPage: async function (searchParams, updateURLHash = true) {
        const gen = this._gen
        if (this._gridController) this._gridController.abort()
        const controller = this._gridController = new AbortController()

        let query
        try {
          query = await this.ajaxRenderer.renderPage(window.location.pathname, searchParams, updateURLHash, {
            signal: controller.signal,
            isCurrent: () => gen === this._gen,
            // The /search heading, both or neither, before anything is swapped (Ruling 46).
            validate: prepared => {
              const main = prepared.find(({ section }) => section.sectionId === this.sectionId)
              if (main) this._checkSearchHeading(main.dom)
            },
          })
        } catch (err) {
          if (gen !== this._gen || err.name === 'AbortError') return 'superseded'
          controller.abort() // stop the sections still loading
          if (this._gridController === controller) this._gridController = null
          this._gridFailed(err)
          return 'error'
        }
        if (!query) return 'superseded'
        if (this._gridController === controller) this._gridController = null

        const shownQuery = query.toString()
        if (!updateURLHash && shownQuery !== this._addressQuery()) {
          history.replaceState(history.state, '', window.location.pathname + (shownQuery ? '?' + shownQuery : '') + window.location.hash)
        }
        this._gridCommitted(gen, shownQuery)

        theme.sections.reinit('collection-grid');
        theme.reinitProductGridItem();

        document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { searchParams: query } }));

        this.sidebar.reInit(this.container)
        this.syncAllCheckboxes()
        this.renderSelectedElement()

        var triggerBtn = document.querySelector('.js-drawer-open-collection-filters')
        if (triggerBtn) triggerBtn.focus({ preventScroll: true })
        return 'commit'
      },

      bindBackButton: function () {
        // Ajax page on back button (R5: _onPopState)
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, this._onPopState.bind(this));
      },

      // R5: Back/Forward, and Show Results' retry of the address bar's state (R4 d). A new
      // generation: the state the shopper left loses every fetch and its debounce (_bump), and
      // the count flags are cleared here because no count fetch of this generation will clear
      // them. Then the address bar's state is rendered in full. Nothing is pushed.
      _onPopState: function () {
        this._bump()
        this._countFetchPending = false
        this._setFilterInputsStale(false)
        this.renderCollectionPage(new URL(window.location.href).searchParams, false)
      },

      setFilterStickyPosition: function () {

        if (window.innerWidth < 769) {
          // Header doesn't exist on cart/checkout-error states — early-return
          // instead of throwing. filtersWrapper similarly may be absent.
          var siteHeader = document.querySelector('.site-header');
          if (!siteHeader) return;
          var headerHeight = siteHeader.offsetHeight;

          var filtersWrapper = document.querySelector(selectors.filtersWrapper);
          if (filtersWrapper) filtersWrapper.style.top = headerHeight + -1 + 'px';

          // Also update top position of sticky sidebar
          var stickySidebar = document.querySelector('.grid__item--sidebar');
          if (stickySidebar) {
            stickySidebar.style.top = headerHeight + 10 + 'px';
          }
        }
      },

      forceReload: function () {
        this.init();
      },

      // _runGridFetch — the GRID sub-operation of generation `gen` (C-1, C-4, C-5; spec 4.4).
      // It replaces the old background prefetch, which swapped and pushed on whatever
      // arrived: an older answer over a newer one, a 500 page, a URL with nothing swapped (F12).
      // It fetches every registered section (the result region's, and the header's when the
      // page has one) for the one built query, and ends in exactly one outcome:
      //  - 'superseded' (R2): a newer generation started (or a teardown aborted the fetch)
      //    before it could commit. Nothing at all changes: no DOM, URL, flag or toast.
      //  - 'error' (C-5): a network failure, a non-ok status, or a response or live node
      //    without its swap target. Nothing is swapped or pushed; _gridFailed releases the UI
      //    and shows the toast, and the next Show Results retries (R4 c).
      //  - 'commit': prepare, then swap (plan gate). Every response is parsed and every swap
      //    pair resolved first, and only then is it all swapped together (the region's
      //    contents, the header, and the sticky bar and the /search heading from the same main
      //    response), the URL pushed after the swap (R5), the state recorded and the UI
      //    released (R3).
      // When the built query is the committed one and the address bar shows it, the grid on
      // screen already IS this state: no fetch and no history entry (as R4 0).
      // It always resolves (never rejects), so the debounce, Show Results and clear-all can
      // start it without awaiting it.
      _runGridFetch: async function (gen) {
        if (gen !== this._gen) return 'superseded'

        // C-2: the section URLs and the URL pushed after the swap come from the one builder,
        // the same query the count fetch uses (never a merge with the lagging address bar,
        // F11). The builder adds availability once and stamps the gender scope last.
        const query = this._buildQuery()
        const queryString = query.toString()
        if (queryString === this._committed && this._addressQuery() === this._committed) {
          this._settleUnchanged(gen)
          return 'commit'
        }

        // One grid fetch at a time: Show Results (R4 b) waits on it instead of starting a
        // second, and _bump/destroy abort it.
        if (this._gridController) this._gridController.abort()
        const controller = this._gridController = new AbortController()

        let pairs
        let mainDom
        try {
          const responses = await Promise.all(this.ajaxRenderer.sections.map(section => {
            const url = `${window.location.pathname}?section_id=${section.sectionId}&${queryString}`
            return this.ajaxRenderer.renderSectionFromFetch(url, controller.signal)
              .then(html => ({ section, dom: new DOMParser().parseFromString(html, 'text/html') }))
          }))
          if (gen !== this._gen) return 'superseded'

          // Prepare: resolve every swap pair before anything changes. C-1: a section with a
          // marker swaps only that node, the one result region [data-ajax-grid] that both
          // templates render in every state; the node itself survives the swap, so the
          // shell, the open drawer and the dim on it stay. The header swaps whole. A node
          // missing on either side is an error, never a silent no-op (507ab81, N4).
          pairs = responses.map(({ section, dom }) => {
            const from = section.marker ? dom.querySelector(section.marker) : dom.getElementById(section.nodeId)
            const to = section.marker ? this.container.querySelector(section.marker) : document.getElementById(section.nodeId)
            if (!from || !to) throw new Error('[filter] no swap target for section ' + section.sectionId)
            if (section.sectionId === this.sectionId) mainDom = dom
            return { from, to }
          })
          // A STRUCTURAL change (Ruling 48, final gate rounds 4-5): the main response is an empty
          // base collection's page while this page still has its shell. main-collection.liquid
          // renders no shell when all_products_count == 0, e.g. when the collection's last
          // product left mid-session. That is a valid page, but a region swap cannot express it,
          // and rejecting it (Ruling 47) failed every retry. So the browser loads that URL itself
          // and the server renders the true state. The page it lands on has no filter UI, so this
          // cannot repeat. Only the current generation gets here (checked after the fetch), and
          // the navigation is its commit. Only THAT exact shape navigates (_isEmptyBaseResponse,
          // round 5). A response that merely lost companions (the sticky snippet gone while its
          // grid and drawers remain), anything on /search, or a page already without its shell
          // takes the checks below and is an error, never a navigation.
          if (this._isEmptyBaseResponse(mainDom) && this._stickyPairs(mainDom).every(({ to }) => to)) {
            if (this._gridController === controller) this._gridController = null
            // Settle every shared UI state before leaving, so a page the browser restores from
            // its Back/Forward cache comes back usable:
            // - The navigation ends this generation like a new intent (_bump: a newer number,
            //   then the abort). A count answer that had already arrived, and waits behind this
            //   code in the microtask queue, then finds a newer generation and changes nothing:
            //   no badge, pills or toast after location.assign (R6: correctness never rests on
            //   the abort; final gate round 7, where _cancelPending alone left that window).
            // - The count's flags are cleared here because no count will clear them, as in
            //   _onPopState: the stale-option dim and the pending flag (round 6).
            // - The dim and busy button a Show Results press set are released.
            // _committed and readiness stay, because the grid on screen is still the committed
            // state until the new page replaces it. A restored page's next Show Results finds no
            // ready generation and fetches again, which is right: its checked inputs ask for the
            // state the browser was sent to.
            this._bump()
            this._countFetchPending = false
            this._setFilterInputsStale(false)
            this._releaseGridUi('idle')
            window.location.assign(window.location.pathname + (queryString ? '?' + queryString : ''))
            return 'commit'
          }
          // The companions outside the region describe the same state, so they are swap
          // targets too (Rulings 46-47): the sticky bar's nodes and the /search heading.
          this._checkSticky(mainDom)
          this._checkSearchHeading(mainDom)
        } catch (err) {
          // A newer generation, or a teardown's abort: superseded, so no toast (S5).
          if (gen !== this._gen || err.name === 'AbortError') return 'superseded'
          controller.abort() // stop the sections still loading
          if (this._gridController === controller) this._gridController = null
          this._gridFailed(err)
          return 'error'
        }
        if (this._gridController === controller) this._gridController = null

        // Commit: every section at once, then the URL, then the bookkeeping and the release.
        pairs.forEach(({ from, to }) => { to.innerHTML = from.innerHTML })
        this._refreshSticky(mainDom)
        this._refreshSearchHeading(mainDom)
        this.ajaxRenderer.updateURLHash(query)
        this._gridCommitted(gen, queryString)

        // Re-init the swapped cards (the sidebar was not replaced, so it needs no reInit).
        // After the outcome on purpose: a card script's error must neither turn a commit
        // into an error nor reject.
        try {
          theme.reinitProductGridItem()
          document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { searchParams: query } }))
        } catch (err) {
          console.warn('[filter] re-init after the grid commit failed:', err)
        }
        return 'commit'
      },

      // Commit row (spec 4.4): the sticky bar sits in #CollectionAjaxContent but outside
      // [data-ajax-grid], so the region swap leaves it stale. Its "N products" text and the
      // "Filters (N)" chips, with the chips' active style, are copied from the SAME main
      // response the region came from, so the server's one counting rule
      // (collection-filter-sticky.liquid, which leaves the modes out) stays the only one
      // (this replaces e47b869/f's JS recount). These nodes hold plain text (a t string with
      // a count), so textContent copies all of it and no HTML is built. The count node never
      // carries btn--tertiary-active, so the toggle leaves it be.
      // Required on both sides (Ruling 47, final gate round 3; they used to be skipped when
      // missing): collection-filter-sticky.liquid renders all three nodes whenever the shell
      // renders (its setting turns off the count's TEXT, never the node), and a grid fetch
      // only runs from a page that has the shell. So a node missing from the live page means
      // the template lost it, and a response missing any node is broken: _checkSticky rejects
      // either in the PREPARE stage, an error outcome with nothing swapped (507ab81, N4),
      // instead of committing a grid under a stale count and stale filter chips. The one
      // exception is the empty base collection's page, which has no shell at all by design
      // (its last product left mid-session). _runGridFetch hands that exact shape to the
      // browser before this check (_isEmptyBaseResponse, Ruling 48). By commit time every
      // pair is whole.
      _stickyPairs: function (dom) {
        return ['.collection-filter__item--count', '.js-drawer-open-collection-filters', '.js-drawer-open-collection-filters-mobile']
          .map(selector => ({ selector, from: dom.querySelector(selector), to: this.container.querySelector(selector) }))
      },

      // True only for the exact page main-collection.liquid renders for an empty base collection
      // (all_products_count == 0): #CollectionAjaxContent holding nothing but an empty
      // [data-ajax-grid] (no shell, no cards). Never on /search: main-search renders its shell
      // whenever a search ran, and the builder always keeps q. Ruling 48, narrowed in final gate
      // round 5, where a response that had only lost its sticky snippet (grid and drawers intact)
      // still read as "structural" and navigated instead of failing. Round 6: no text either.
      // .children counts elements only, so stray text beside or inside the region ("ERROR") also
      // passed. textContent leaves out comments and is empty for whitespace once trimmed, so the
      // real page (its Liquid comment renders nothing) still matches.
      _isEmptyBaseResponse: function (dom) {
        if (theme.isSearchPage()) return false
        const content = dom.getElementById('CollectionAjaxContent')
        const region = content?.querySelector(selectors.collectionGrid)
        return Boolean(region) && content.children.length === 1 && content.firstElementChild === region &&
          region.children.length === 0 && content.textContent.trim() === ''
      },

      // Prepare-stage check (Ruling 47): throws when any sticky node is missing on either side.
      _checkSticky: function (dom) {
        this._stickyPairs(dom).forEach(({ selector, from, to }) => {
          if (!from || !to) throw new Error('[filter] the sticky bar node ' + selector + ' is missing, nothing swapped')
        })
      },

      _refreshSticky: function (dom) {
        this._stickyPairs(dom).forEach(({ from, to }) => {
          to.textContent = from.textContent
          to.classList.toggle('btn--tertiary-active', from.classList.contains('btn--tertiary-active'))
        })
      },

      // Commit row (Ruling 40): the /search heading, main-search.liquid's [data-search-heading]
      // block (the h1 and the "results for" / "no results" line), reads the FILTERED search:
      // search.results_count, and is_collection from the active product-type value. It sits
      // outside the result region and outside this.container, so no swap reached it, and after
      // a filter change it kept the previous state's title and count line. Callers: the grid
      // commit (_runGridFetch) and the Back/Forward swap hook (onReplaceAjaxContent), each with
      // the SAME main response its region came from. Unlike _refreshSticky's text nodes, the
      // block holds markup (a heading, a link), so its innerHTML is copied: server-rendered and
      // already escaped by Liquid, the same trust as the region swap beside it. The live node is
      // looked up in this section's own Shopify wrapper, #shopify-section-<section id>, which
      // holds both the heading block and this.container, so another section's heading (two
      // instances in the theme editor) is never touched.
      // Required on /search (Rulings 46-47, final gate rounds 2-3; it used to be skipped
      // silently). main-search.liquid always renders the block, so on /search a response or a
      // page WITHOUT it is invalid, on one side or on both: missing on both means the template
      // lost it, and the heading would go stale again. Elsewhere (a collection: its title lives
      // in collection-header.liquid) neither side has one, and one side alone is still invalid.
      // _checkSearchHeading rejects an invalid pair in each path's PREPARE stage, like a missing
      // swap target (507ab81, N4): a grid is never committed under a heading that contradicts
      // it. By commit time both sides exist, or (off /search) neither does.
      _searchHeadingPair: function (dom) {
        return {
          from: dom.querySelector('[data-search-heading]'),
          to: document.getElementById('shopify-section-' + this.sectionId)?.querySelector('[data-search-heading]')
        }
      },

      // Prepare-stage check (Rulings 46-47): throws on an invalid heading pair (above), so the
      // caller's error outcome runs and nothing is swapped. Callers: _runGridFetch's prepare and
      // renderCollectionPage's validate hook (AjaxRenderer.renderPage calls it before any swap).
      _checkSearchHeading: function (dom) {
        const { from, to } = this._searchHeadingPair(dom)
        const valid = theme.isSearchPage() ? Boolean(from && to) : Boolean(from) === Boolean(to)
        if (!valid) throw new Error('[filter] the search heading is missing, nothing swapped')
      },

      _refreshSearchHeading: function (dom) {
        const { from, to } = this._searchHeadingPair(dom)
        if (from && to) to.innerHTML = from.innerHTML
      },

      // R4 (0), and _runGridFetch's no-fetch case: the grid on screen already IS generation
      // gen's state (its query is the committed one and the address bar shows it). Whatever
      // grid work the generation still has pending is dropped (it would only re-render the
      // same state and add a history entry), and the generation commits as it stands, which
      // releases a dim an earlier press left for a generation this one superseded (R3).
      _settleUnchanged: function (gen) {
        clearTimeout(this._bgUpdateTimer)
        this._bgUpdateTimer = null
        if (this._gridController) {
          this._gridController.abort()
          this._gridController = null
        }
        this._gridCommitted(gen, this._committed)
      },

      // The commit outcome's bookkeeping (R2/R3): the grid on screen now shows `query` for
      // generation gen, so it is ready (R4 a) and the dim and the busy state are released.
      _gridCommitted: function (gen, query) {
        this._committed = query
        this._readyGen = gen
        this._releaseGridUi('ready')
      },

      // The error outcome (spec 4.4): unlock and undim, Show Results idle so that pressing it
      // retries (R4 c/d), the existing toast. Selections, _committed, readiness and the URL
      // stay as they were. Called only for the current generation, never for an abort.
      _gridFailed: function (err) {
        console.warn('[filter] grid update failed:', err)
        this._releaseGridUi('idle')
        this.showFilterError()
      },

      // The UI state a grid outcome releases (R3): the dim on the result region and the Show
      // Results busy state.
      _releaseGridUi: function (state) {
        var region = this.container.querySelector(selectors.collectionGrid)
        if (region) region.classList.remove('unload')
        this.setShowResultsState(state)
      },

      // The address bar's query, serialised by URLSearchParams#toString() like the built
      // query and _committed, so the three compare as plain strings (R4, R5).
      _addressQuery: function () {
        return new URLSearchParams(window.location.search).toString()
      },

      // The Show Results busy state, in this section's drawers. 'loading' (spinner, aria-busy;
      // the CSS makes the button unclickable) is set only while a press waits on the grid
      // fetch (R4 b/c/d) and is released by the current generation's outcome (R3). A
      // background fetch does not set it: R4 (b) needs the button pressable while one is out.
      // Any other state ('ready', 'idle') clears it.
      setShowResultsState: function (state) {
        this.container.querySelectorAll('.show__all_button').forEach(btn => {
          if (state === 'loading') {
            btn.classList.add('is-loading')
            btn.setAttribute('aria-busy', 'true')
            if (!btn.querySelector('.btn-spinner')) {
              const spinner = document.createElement('span')
              spinner.className = 'btn-spinner'
              spinner.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="31.4 31.4" stroke-linecap="round"/></svg>'
              btn.appendChild(spinner)
            }
          } else {
            btn.classList.remove('is-loading')
            btn.removeAttribute('aria-busy')
            const spinner = btn.querySelector('.btn-spinner')
            if (spinner) spinner.remove()
          }
        })
      },

      // Dims the result region while a Show Results press waits on this generation's grid
      // fetch (R4 b/c/d); the current generation's outcome removes it (_releaseGridUi). The
      // dim sits on [data-ajax-grid], which every grid swap keeps, so it never leaves with a
      // swap. Null-guarded: a page without the region has nothing to dim.
      startLoading: function () {
        var region = this.container.querySelector(selectors.collectionGrid);
        if (region) region.classList.add('unload');
      },
    });

    return Collection;
  })();

  theme.FooterSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text, on EVERY newsletter field inside THIS footer (E2, Phase E spec 5.2).
        // The footer holds two copies of the sign-up form (phone and desktop, only one visible at a time). The old
        // document-wide querySelector bound just the first field in the page, the hidden phone copy, so on desktop
        // typing in the visible field never swapped the envelope icon for the Subscribe text. Scoping the query to
        // this.container binds both copies, each listener toggling only its own field.
        // The 'input' event (not 'keyup') also fires for paste, autofill and drag-drop, and the class follows whether
        // the field holds text, so clearing the field brings the envelope icon back.
        // The handlers are kept in this.newsletterListeners so onUnload can remove them: a theme-editor re-render of
        // the footer must not stack listeners.
        this.newsletterListeners = [];
        this.container.querySelectorAll('.footer__newsletter-input').forEach((input) => {
          const handler = function () {
            input.classList.toggle('footer__newsletter-input--active', input.value !== '');
          };

          input.addEventListener('input', handler);
          this.newsletterListeners.push({ input, handler });
          // Run the handler once now, so the class matches the value the field already holds (final gate, spec 5.2:
          // the class follows whether the field has a value). For a signed-in customer both copies are rendered with
          // their email as the value, and no 'input' event fires for a value present at load, so the envelope icon
          // showed beside a filled field until the visitor typed.
          handler();
        });

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }

        // Remove the 'input' listeners init bound on the newsletter fields (spec 5.2: a theme-editor re-render must
        // not stack listeners). The editor unloads this instance before it loads a new one for the re-rendered
        // footer; removing the handlers here leaves none behind, even on a field that outlives the unload.
        this.newsletterListeners.forEach(({ input, handler }) => input.removeEventListener('input', handler));
        this.newsletterListeners = [];
      }
    });

    return FooterSection;
  })();

  class HeaderOpacityChanger {
    constructor(headerSelector, topBarSelector, logoSelector, descriptionContainerSelector, maxDistance) {
      this.siteHeader = document.querySelector(headerSelector);
      this.headerTopbar = document.querySelector(topBarSelector);
      this.siteHeaderLogoLink = document.querySelector(logoSelector);
      this.productDescriptionContainer = document.querySelector(descriptionContainerSelector);
      this.maxDistance = maxDistance;

      if (this.siteHeader && this.productDescriptionContainer) {
        this.init();
      }
    }

    init() {
      // RAF-throttle scroll/resize to avoid forced reflows on every raw event.
      // Without this, two getBoundingClientRect() calls fire per scroll event
      // (240/sec on 120Hz displays), causing layout thrashing and scroll jank.
      this._rafId = null;
      this._boundUpdate = () => {
        if (!this._rafId) {
          this._rafId = requestAnimationFrame(() => {
            this.updateBackgroundColorBasedOnScroll();
            this._rafId = null;
          });
        }
      };
      this._boundUpdate();
      window.addEventListener('scroll', this._boundUpdate);
      window.addEventListener('resize', this._boundUpdate);
    }

    calculateOpacity(distance) {
      return Math.max(0, Math.min(1, (this.maxDistance - distance) / this.maxDistance));
    }

    updateBackgroundColorBasedOnScroll() {
      const productRect = this.productDescriptionContainer.getBoundingClientRect();
      const headerRect = this.siteHeader.getBoundingClientRect();
      const distance = productRect.top - headerRect.bottom;
      const opacity = this.calculateOpacity(distance);

      if (window.innerWidth >= 769) {
        // Set CSS variable instead of inline backgroundColor
        this.siteHeader.style.setProperty('--scroll-opacity', opacity);
        if (this.headerTopbar) {
          this.headerTopbar.style.setProperty('--scroll-opacity', opacity);
        }
      } else if (this.siteHeaderLogoLink) {
        // Mobile: still use direct opacity for logo
        this.siteHeader.style.setProperty('--scroll-opacity', opacity);
        this.siteHeaderLogoLink.style.opacity = opacity;
        // Enable pointer events if opacity is full, otherwise disable them
        this.siteHeaderLogoLink.style.pointerEvents = opacity === 1 ? 'auto' : 'none';
      }

      if (distance > this.maxDistance) {
        if (window.innerWidth >= 769) {
          this.siteHeader.style.setProperty('--scroll-opacity', 0);
          if (this.headerTopbar) {
            this.headerTopbar.style.setProperty('--scroll-opacity', 0);
          }
        } else if (this.siteHeaderLogoLink) {
          this.siteHeaderLogoLink.style.opacity = '0';
          this.siteHeaderLogoLink.style.pointerEvents = 'none';
        }
      }

      if (distance <= 0) {
        document.body.classList.add('header-touching');
      } else {
        document.body.classList.remove('header-touching');
      }
    }

    destroy() {
      // Removes the scroll/resize window listeners and cancels any pending RAF.
      // Caller (e.g. Product.init re-running on quick-view re-open) should call
      // destroy() on the previous instance before creating a new one to avoid
      // multiple HeaderOpacityChanger instances reading getBoundingClientRect()
      // on every scroll for the same scroll position.
      if (this._boundUpdate) {
        window.removeEventListener('scroll', this._boundUpdate);
        window.removeEventListener('resize', this._boundUpdate);
        this._boundUpdate = null;
      }
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }
  }

  // Section controller for sections/header.liquid: the nav drawer, the mobile nav, theme.headerNav (sticky and overlay
  // behaviour), the currency search, the locale and currency disclosures and, in drawer mode only, the cart drawer.
  // It must run ONCE per page. The announcement bar is a separate section with its own controller
  // (theme.AnnouncementBarSection), so this one never touches the bar; before D1.1 both sections declared the header
  // type and everything below ran twice on every page view.
  theme.HeaderSection = (function () {

    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        this.initCurrencySearch();
        // Measures the announcement bar, which theme.AnnouncementBarSection has already started: it is registered
        // before this section (see the registrations at the bottom of this file).
        theme.headerNav.init();

        new theme.MobileNav({
          id: 'NavDrawer'
        });
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      // Builds the nav drawer and, when its markup exists, the cart drawer.
      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

        // The cart drawer exists only where #CartDrawer is rendered: snippets/cart-drawer.liquid prints it for
        // settings.cart_type 'drawer' alone. In hybrid mode (the store's mode) there is no drawer, so building
        // theme.CartDrawer here would only fetch /cart?view=ajax for markup that is not on the page: two full renders of
        // templates/cart.ajax.liquid per page view (D1.2). The header bubble after an add is refreshed by the add itself
        // (theme.AjaxProduct, through theme.cart.updateCount). The cart page keeps its own theme.CartForm, so the drawer
        // is not built there either.
        if (document.getElementById('CartDrawer') && !document.body.classList.contains('template-cart')) {
          new theme.CartDrawer();
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      initCurrencySearch: function () {
        const searchParent = document.querySelector('.lang--drawer [data-search-parent]');
        const searchInput = searchParent.querySelector('#currencySearchDrawer');
        const listItems = searchParent.querySelectorAll('.slide-nav li.slide-nav__item');

        searchInput.addEventListener('input', e => {
          const target = e.currentTarget;
          const query = target.value.trim().toLowerCase();

          listItems.forEach(item => {
            const country = item.getAttribute('data-country').toLowerCase();
            const currencyIso = item.getAttribute('data-currency-iso').toLowerCase();
            const currencySymbol = item.getAttribute('data-currency-symbol').toLowerCase();

            if (country.includes(query) || currencyIso.includes(query) || currencySymbol.includes(query)) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          });

          if (query === '') {
            listItems.forEach(item => item.classList.remove('hidden'));
          }
        })
      },

      // The editor is about to re-render or remove the header: close the nav drawer and release the disclosures. The
      // announcement bar is not torn down here, it is a separate section (theme.AnnouncementBarSection.onUnload).
      onUnload: function () {
        theme.NavDrawer.close();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };

    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
      var templateVersion = this.templateVersion = container.getAttribute('data-template-version')

      this.inModal = (container.dataset.modal === 'true');
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',

        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        // The desktop gallery overlay's price, compare-at, savings % and sale row (snippets/product-template.liquid):
        // the only price visible from 769 px up, so updatePrice writes it too (Phase B3).
        overlayPrice: '[data-overlay-price]',
        overlayCompare: '[data-overlay-compare]',
        overlaySave: '[data-overlay-save]',
        overlaySaleRow: '[data-overlay-sale-row]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',

        addToCart: '[data-add-to-cart]',
        addToCartSecondary: '[data-add-to-cart-secondary]',
        addToCartText: '[data-add-to-cart-text]',
        addToCartSecondaryText: '[data-add-to-cart-secondary-text]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',

        availabilityContainer: '[data-store-availability-holder]',

        optionTrigger: '.option-selector--trigger',
      };

      this.cacheElements();

      if (this.templateVersion != 'v2') {
        this.firstProductImage = this.cache.mainSlider.querySelector('img');

        if (!this.firstProductImage) {
          this.settings.hasImages = false;
        }

        var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
        if (dataSetEl) {
          this.settings.imageSetName = dataSetEl.dataset.setName;
        }
      }
      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          // Store bound refs so onUnload can remove them. .bind(this) creates a new
          // function each call, so the originals at registration are otherwise
          // unreachable for removeEventListener — every section reload leaked them.
          this._modalEventNamespace = 'QuickShopModal-' + this.productId;
          this._boundOpenModalProduct = this.openModalProduct.bind(this);
          this._boundCloseModalProduct = this.closeModalProduct.bind(this);
          document.addEventListener('modalOpen.' + this._modalEventNamespace, this._boundOpenModalProduct);
          document.addEventListener('modalClose.' + this._modalEventNamespace, this._boundCloseModalProduct);
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.addIdToRecentlyViewed();
          this.initVariantSelector();
        }
        if (!this.inModal && this.templateVersion !== 'v2') {
          this.initProductSlider();
          this.customMediaListners();
        } else {
          this.initProductSliderV2()
        }

        if (this.templateVersion == 'v2') {
          this.initHeaderOpacityChanger()
        }
      },

      initHeaderOpacityChanger: function () {
        const headerSelector = '.site-header';
        const topBarSelector = '.toolbar';
        const logoSelector = '.site-header__logo a';
        const descriptionContainerSelector = '.product-discription--container';

        const siteHeader = document.querySelector(headerSelector);
        const siteHeaderLogoLink = document.querySelector(logoSelector);
        const productDescriptionContainer = document.querySelector(descriptionContainerSelector);
        if (siteHeader && siteHeaderLogoLink && productDescriptionContainer) {
          // Dispose any previous instance before creating a new one. Without this,
          // Product.init being re-run (quick view re-open, variant change re-init,
          // section reload) leaks a HeaderOpacityChanger that keeps running its
          // scroll/resize handlers against detached DOM, causing scroll jank.
          if (this._headerOpacityChanger && typeof this._headerOpacityChanger.destroy === 'function') {
            this._headerOpacityChanger.destroy();
          }
          this._headerOpacityChanger = new HeaderOpacityChanger(headerSelector, topBarSelector, logoSelector, descriptionContainerSelector, 400);
        }
      },

      doSlidesOverflow: function (wrapperEl) {
        if (window.innerWidth < 769) return true;

        const slideEls = Array.from(wrapperEl.children);
        const totalSlidesWidth = slideEls.reduce((sum, child) => sum + child.offsetWidth, 0);
        const totalGapWidth = (slideEls.length - 1) * 150;
        return (totalSlidesWidth + totalGapWidth) > window.innerWidth;
      },

      initProductSliderV2: function () {
        const initializeSwiper = () => {
          // Guard against Swiper not loaded yet (vendor script race condition under throttled networks)
          if (typeof Swiper === 'undefined') return;
          const sliderEl = document.querySelector(this.selectors.mainSlider);
          const wrapper = sliderEl?.querySelector('.product-slideshow--wrapper');
          if (!sliderEl || !wrapper) return;

          // Determine if slides overflow the viewport
          const shouldActivateSwiper = this.doSlidesOverflow(wrapper);

          if (!shouldActivateSwiper) {
            wrapper.classList.add('is-centered');
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            return;
          }

          // Images overflow — activate Swiper for scrolling
          wrapper.classList.remove('is-centered');

          // Destroy previous instance before re-creating (resize path)
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }

          // Smart preload-ahead: promote the next 2 slides from lazy to eager
          // whenever the active slide changes. The first 5 slides ship eager
          // from the server (snippets/media.liquid); this handles slide 6+ on
          // products with deep slideshows. Bandwidth scales with how far the
          // customer actually swipes -- no waste on slides they never view.
          //
          // Setting loading="eager" alone isn't reliable post-parse in every
          // browser; .decode() forces a network fetch + decode and is well
          // supported (Chrome 63+, Safari 12+, Firefox 63+). Catch swallows
          // failed decodes so a single broken image doesn't break the chain.
          const preloadAdjacent = (swiper) => {
            if (!swiper || !swiper.slides) return;
            const idx = swiper.activeIndex;
            [idx + 1, idx + 2].forEach((i) => {
              const slide = swiper.slides[i];
              if (!slide) return;
              const img = slide.querySelector('img[loading="lazy"]');
              if (!img) return;
              img.loading = 'eager';
              if (typeof img.decode === 'function') {
                img.decode().catch(() => {});
              }
            });
          };

          const mainSliderConfig = {
            slidesPerView: 'auto',
            direction: 'horizontal',
            touchEventsTarget: 'container',

            observer: false,
            observeParents: false,
            observeSlideChildren: false,
            resizeObserver: false,
            updateOnWindowResize: false,
            speed: 750,

            threshold: 5,

            cssMode: false,
            centeredSlides: false,
            centeredSlidesBounds: false,

            touchStartPreventDefault: false,
            preventInteractionOnTransition: false,

            longSwipesRatio: 0.2,
            touchRatio: 0.85,

            resistance: true,
            resistanceRatio: 0.87,
            watchOverflow: true,
            spaceBetween: 8,

            breakpoints: {
              769: {
                speed: 600,
                spaceBetween: 150,
                slidesOffsetAfter: 0,
                slidesPerGroup: 1,
              }
            },

            navigation: {
              nextEl: '.product-slideshow__nav--next',
              prevEl: '.product-slideshow__nav--prev',
            },

            on: {
              init: function () {
                this.el.addEventListener('dragstart', function (e) {
                  e.preventDefault();
                });

                var indicator = document.querySelector('.product-slide-indicator__bar');
                if (indicator) {
                  indicator.style.transform = 'translateX(0%)';
                }

                preloadAdjacent(this);
              },
              slideChange: function () {
                // Run preload before indicator update so a missing indicator
                // (some templates omit it) doesn't short-circuit the preload.
                preloadAdjacent(this);

                var indicator = document.querySelector('.product-slide-indicator__bar');
                if (!indicator) return;
                var index = this.activeIndex;
                indicator.style.transform = 'translateX(' + (index * 100) + '%)';
              }
            }
          };

          this.swiper = new Swiper(this.selectors.mainSlider, mainSliderConfig);
        };

        // First init
        initializeSwiper();

        // Recalculate on resize (debounced, width-only)
        let resizeTimeout;
        let lastWidth = window.innerWidth;
        this._productResizeHandler = () => {
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            initializeSwiper();
          }, 250);
        };
        window.addEventListener('resize', this._productResizeHandler);

      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
          optionsTrigger: this.container.querySelectorAll(this.selectors.optionTrigger),

          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
          // The desktop overlay's price elements (Phase B3); updatePrice guards each one (B9)
          overlayPrice: this.container.querySelector(this.selectors.overlayPrice),
          overlayCompare: this.container.querySelector(this.selectors.overlayCompare),
          overlaySave: this.container.querySelector(this.selectors.overlaySave),
          overlaySaleRow: this.container.querySelector(this.selectors.overlaySaleRow)
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      initOptionDrawer: function () {
        window.addEventListener('DOMContentLoaded', () => {
          this.optionDrawer = new theme.Drawers('OptionDrawer', 'option')
          //'SingleOptionSelector-{{ section_id }}-{{ product.id }}-option-{{ forloop.index0 }}'

          const options = this.container.querySelectorAll('#OptionDrawer .option-input-wrap')
          options.forEach(option => {
            const index = option.dataset.index == 'option2' ? 1 : option.dataset.index == 'option3' ? 2 : 0
            const section_id = option.dataset.sectionId
            const product_id = option.dataset.productId
            // This product section's drawer trigger, not the document's first (final gate): with a second product
            // section on the page, a tap here renamed the other product's trigger and left this one stale. A section
            // without one (product-template renders none for one size or nothing sellable) gets null: the write is guarded.
            const triggerButton = this.container.querySelector(`button[aria-controls="OptionDrawer"]`)
            const text = triggerButton?.dataset.displayText
            // This section's hidden size select, not the document's first (final gate round 2), like the trigger
            // above. Its id is keyed by section and product, so it repeats when the same product is on the page
            // twice (every id in the section does), and a tap here then chose the size in the other section.
            const selectEl = this.container.querySelector(`select#SingleOptionSelector-${section_id}-${product_id}-option-${index}`)

            const option_list = option.querySelectorAll('button.btn--option')
            option_list.forEach(item => {
              item.addEventListener('click', (e) => {

                const selected = option.querySelector('button.btn--option[data-selected="true"]')
                if (selected) {
                  selected.setAttribute('data-selected', false)
                  selected.setAttribute('aria-pressed', 'false')
                }

                const target = e.currentTarget
                const value = target.dataset.value
                const displayValue = target.dataset.displayValue

                // textContent (not innerHTML) — text + displayValue come from
                // merchant-controlled dataset attributes and aren't sanitized.
                if (triggerButton) triggerButton.textContent = `${text}: ${displayValue}`
                target.setAttribute('data-selected', true)
                // aria-pressed mirrors data-selected for screen readers (snippets/variant-drawer.liquid renders both).
                target.setAttribute('aria-pressed', 'true')

                selectEl.value = value
                selectEl.dispatchEvent(new Event('change'))

                const option_list_global = this.container.querySelector('.option--list')
                option_list_global.setAttribute('data-selected', true)
                // Both size lists follow this tap (Task 7 fix round 1: showSelectedSize, below initVariantSelector).
                this.showSelectedSize(option.dataset.index, value)
              })
            })
          })

          document.addEventListener('ajaxProduct:added:close-drawer', () => {
            this.optionDrawer.close()
          })
        })
      },

      initVariantSelector: function () {
        const selectorWrappers = []

        const options = this.container.querySelectorAll('.variant-wrapper--dropdown[data-type="dropdown"]')
        options.forEach(option => {
          const wrapper = option.querySelector('.option-selector--wrapper');
          const trigger = option.querySelector('.option-selector--trigger');
          const list = option.querySelector('.option--list');

          if (!list) return;
          const items = list.querySelectorAll('.option--item')
          const selectEl = option.querySelector('select');
          const width = window.innerWidth;
          selectorWrappers.push(wrapper)

          trigger.addEventListener('click', e => {
            wrapper.classList.toggle('open')
            const event = new Event('selector:open')
            document.dispatchEvent(event)
          })

          items.forEach(option => {
            option.addEventListener('click', e => {
              e.stopPropagation()
              e.preventDefault()
              const target = e.currentTarget
              const value = target.dataset.value
              const displayValue = target.dataset.displayValue
              selectEl.value = value

              const event = new Event('change');
              selectEl.dispatchEvent(event)

              list.setAttribute('data-selected', true)
              const text = trigger.querySelector('.option-selector--text').dataset.displayText
              trigger.querySelector('.option-selector--text').textContent = `${text}: ${displayValue}`

              const preSelectedItems = list.querySelectorAll('[data-selected="true"]')
              preSelectedItems.forEach(_item => {
                if (!_item.isSameNode(target)) _item.setAttribute('data-selected', false)
              })
              target.setAttribute('data-selected', true)
              if (width > 768) {
                if (wrapper.classList.contains('open')) wrapper.classList.remove('open')
                const event = new Event('selector:close')
                document.dispatchEvent(event)
              }
              // Both size lists follow this tap (Task 7 fix round 1: showSelectedSize, below).
              this.showSelectedSize(selectEl.dataset.index, value)
            })
          })
        })
        this._selectorClickHandler = e => {
          const target = e.target
          selectorWrappers.forEach(_ => {
            const listEl = _.querySelector('.option-list--wrapper')
            const trigger = _.querySelector('.option-selector--trigger')
            if (!trigger.isSameNode(target) && !trigger.contains(target)) {
              if (!target.isSameNode(listEl) && !listEl.contains(target)) {
                if (_.classList.contains('open')) {
                  _.classList.remove('open')
                  const event = new Event('selector:close')
                  document.dispatchEvent(event)
                }
              }
            }
          })
        };
        document.addEventListener('click', this._selectorClickHandler);

        this.initOptionDrawer()
      },

      // Puts BOTH size pickers of option `index` (e.g. 'option1') in the state a tap on size `value` leaves in each
      // (Phase B Task 7 fix round 1, spec B6b). The size drawer (#OptionDrawer, snippets/variant-drawer.liquid) and
      // the size list (snippets/variant-dropdown.liquid) are two pickers for one size input, and each tap handler
      // (initOptionDrawer, initVariantSelector) updates only its own. Both can start on a deep-linked size, and both
      // triggers show below 769 px (staging P4b), so a tap in one used to leave the other naming the old size. Both
      // handlers call this last; for their own picker it repeats what they just wrote, which is harmless.
      //   - The drawer: the selected button unselected, this size's button selected (data-selected and aria-pressed
      //     together), and its trigger reading "<label>: <size>".
      //   - The list: the selected rows unselected, this size's row selected, the list's data-selected (the size gate
      //     theme.AjaxProduct reads) set, and its trigger reading "<label>: <size>".
      // A picker with no row for `value` is left as it is. textContent, never innerHTML: the size labels are
      // supplier data. Every element is looked up in this product section (this.container), which holds the drawer,
      // its trigger and the list. The trigger used to be the document's first, so with a second product section on
      // the page (a quick-shop load) a tap renamed the other product's trigger (final gate).
      showSelectedSize: function (index, value) {
        const drawer = this.container.querySelector(`#OptionDrawer .option-input-wrap[data-index="${index}"]`)
        const list = this.container.querySelector(`.variant-input-wrap[data-index="${index}"]`)
        const button = drawer && Array.from(drawer.querySelectorAll('button.btn--option')).find(b => b.dataset.value === value)
        const row = list && Array.from(list.querySelectorAll('.option--item')).find(li => li.dataset.value === value)
        if (button) {
          drawer.querySelectorAll('button.btn--option[data-selected="true"]').forEach(b => {
            b.setAttribute('data-selected', false)
            b.setAttribute('aria-pressed', 'false')
          })
          button.setAttribute('data-selected', true)
          button.setAttribute('aria-pressed', 'true')
          const trigger = this.container.querySelector('button[aria-controls="OptionDrawer"]')
          if (trigger && trigger.dataset.displayText) trigger.textContent = `${trigger.dataset.displayText}: ${button.dataset.displayValue}`
        }
        if (row) {
          list.querySelectorAll('.option--item[data-selected="true"]').forEach(li => li.setAttribute('data-selected', false))
          row.setAttribute('data-selected', true)
          const options = list.querySelector('.option--list')
          if (options) options.setAttribute('data-selected', true)
          const text = list.querySelector('.option-selector--text')
          if (text && text.dataset.displayText) text.textContent = `${text.dataset.displayText}: ${row.dataset.displayValue}`
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        if (this.templateVersion !== 'v2') {
          this.setImageSizes();
          this.initImageZoom();
          this.initModelViewerLibraries();
          this.initShopifyXrLaunch();

          if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle');

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = true;

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };


        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function (evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }

        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === 'drawer' || theme.settings.cartType === 'hybrid') {
          new theme.AjaxProduct(this.cache.form);
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;

        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnSecondary = this.container.querySelector(this.selectors.addToCartSecondary);

        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
        var cartBtnSecondaryText = this.container.querySelector(this.selectors.addToCartSecondaryText);

        if (!cartBtn) return;

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text

            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;

            cartBtnSecondary.classList.remove(classes.disabled);
            cartBtnSecondary.disabled = false;

            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;

            var defaultSecondaryText = cartBtnSecondaryText.dataset.defaultText;
            cartBtnSecondaryText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;

            cartBtnSecondary.classList.add(classes.disabled);
            cartBtnSecondary.disabled = true;
            cartBtnSecondaryText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;

          cartBtnSecondary.classList.add(classes.disabled);
          cartBtnSecondary.disabled = true;
          cartBtnSecondaryText.textContent = theme.strings.unavailable;
        }
      },

      // Writes the selected variant's price, compare-at price, sale state and savings into the PDP's meta price
      // block and into its desktop gallery overlay (snippets/product-template.liquid). Fired by theme.Variants'
      // variantPriceChange (bound in initVariants) when the price or compare-at changes. Phase B: every amount
      // comes from the single formatter (B2), the savings % from the one rule (B8), and every optional element is
      // guarded, so a missing one never stops the rest of the update (B9).
      updatePrice: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        // Variant JSON (product.variants | json) and /cart.js are ALREADY in the shopper's presentment
        // currency: Shopify Markets converts them server-side (gotcha G15). The theme must never convert
        // again. Multiplying by the store's currency rate here (added 2026-05-24 in June f2a436f) turned
        // DE EUR 619 into "EUR 56" whenever a size with a different price was picked (Phase A2).
        // Exact presentment amounts (G15), formatted by the single formatter; never edit the formatted string
        // (#63: `.replace(',00','')` turned 8,000 kr into 80 kr).
        var onSale = variant.compare_at_price > variant.price;
        var a11yHidden = onSale ? 'false' : 'true';

        // The B8 percent as shown ('-15%'), or null when no saving shows (under 10 %, or no sale). The meta block
        // shows it in percent mode; the overlay shows it in either mode.
        var pct = theme.Currency.savingsPercent(variant.compare_at_price, variant.price);
        var pctText = pct !== null ? '-' + pct + '%' : null;

        // The savings text, or null to hide the element. Percent mode (live) uses the one rule (B8), so a
        // saving under 10 % shows nothing. Money mode (product_save_type 'dollar', OFF) shows the formatted
        // difference for any sale. Both amounts are already presentment currency, so neither mode converts.
        var saveText = null;
        if (theme.settings.saveType == 'percent') {
          saveText = pctText;
        } else if (onSale) {
          saveText = '-' + theme.Currency.formatMoney(variant.compare_at_price - variant.price, theme.settings.moneyFormat);
        }

        // The regular price always renders (product-template.liquid). The sale markup renders only for a
        // product with a sale variant and the savings only when its setting is on, so those are optional (B9).
        this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
        this.cache.price.classList.toggle(classes.onSale, onSale);
        if (onSale && this.cache.comparePrice) {
          this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
        }
        if (this.cache.priceWrapper) this.cache.priceWrapper.classList.toggle(classes.hidden, !onSale);
        // The "Regular price" / "Sale price" screen-reader labels are read only while the variant is on sale.
        if (this.cache.comparePriceA11y) this.cache.comparePriceA11y.setAttribute('aria-hidden', a11yHidden);
        if (this.cache.priceA11y) this.cache.priceA11y.setAttribute('aria-hidden', a11yHidden);

        var saveAmount = this.cache.savePrice ? this.cache.savePrice.querySelector('.product__saving--amount') : null;
        if (saveAmount && saveText !== null) saveAmount.innerHTML = saveText;
        if (this.cache.savePrice) this.cache.savePrice.classList.toggle(classes.hidden, saveText === null);

        // The desktop overlay, the only price visible from 769 px up (Phase B3), follows the same variant both
        // ways: the price and its on-sale colour; the sale row, shown for any sale and hidden otherwise; the
        // compare-at ('' when not on sale, as its Liquid renders it); and the B8 percent ('' when none shows).
        // Like its Liquid, the overlay shows the percent whatever the savings setting. Each element is guarded (B9).
        if (this.cache.overlayPrice) {
          this.cache.overlayPrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
          this.cache.overlayPrice.classList.toggle(classes.onSale, onSale);
        }
        if (this.cache.overlaySaleRow) this.cache.overlaySaleRow.classList.toggle(classes.hidden, !onSale);
        if (this.cache.overlayCompare) {
          this.cache.overlayCompare.innerHTML = onSale ? theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat) : '';
        }
        if (this.cache.overlaySave) this.cache.overlaySave.innerHTML = pctText !== null ? pctText : '';
      },

      // The selected variant's unit price: it already goes through the single formatter, as is, so B2 needs no change here.
      // Each unit-price element is looked up and guarded (B9), so markup without one never throws on a tap.
      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;
        var hasUnitPrice = Boolean(variant && variant.unit_price);
        var unitPrice = this.container.querySelector(this.selectors.unitPrice);
        var baseUnit = this.container.querySelector(this.selectors.unitPriceBaseUnit);
        var wrapper = this.container.querySelector(this.selectors.unitWrapper);

        if (hasUnitPrice && unitPrice) unitPrice.innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
        if (hasUnitPrice && baseUnit) baseUnit.innerHTML = theme.Currency.getBaseUnit(variant);
        if (wrapper) wrapper.classList.toggle(classes.hidden, !hasUnitPrice);
      },

      imageSetArguments: function (variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },

      getImageSetName: function (string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold || variantInventoryObject.policy === 'continue') {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, variantInventoryObject);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, variantInventoryObject) {
        const { quantity, policy } = variantInventoryObject || {};
        if (!this.settings.inventory) {
          return;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');

        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && policy !== 'continue') {
          el.parentNode.classList.add('inventory--low');
          if (quantity > 1) {
            el.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
          } else {
            el.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
          }
        } else {
          el.parentNode.classList.remove('inventory--low');
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);

        if (!el) {
          return;
        }

        var salesPoint = el.closest('.product-block');
        var textEl = el.querySelector('.js-incoming-text');

        if (show) {
          var string = available ?
            theme.strings.willNotShipUntil.replace('[date]', date) :
            theme.strings.willBeInStockAfter.replace('[date]', date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },

      initVimeoVideo: function (div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute();
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute('data-video-type');
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Playing as expected
          })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute('controls', '');
              player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function (evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        // Guards (June 3f5bb35, adapted; Phase A6). This handler targets Impulse's Flickity thumbnails, but
        // this PDP uses Swiper and renders no .product__thumb, so newImage was always null and
        // getThumbIndex(null) threw a TypeError on every switch to a variant with a different featured
        // image. Moving the gallery to the variant's image isn't built (owner question O8); until it is,
        // stay quiet. (The unused sized-URL lookup, which also dereferenced the media, is dropped.)
        if (!variant || !variant.featured_media) {
          return;
        }

        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        if (!newImage) {
          return;
        }
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        if (theme.config.bpSmall) {
          this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
        }
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]');

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
          this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + index + '"]');

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute('data-index');
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;

          fetch(url).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);

            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');

              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }

              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });

            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }

            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');

            this.cacheElements();

            this.formSetup();
            this.updateModalProductInventory();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function (evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        if (window.AOS) { AOS.refreshHard(); }

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function () {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });

        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function (evt) {
              this.mediaLoaded(evt);
            }.bind(this));

            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function (evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        if (this._productResizeHandler) {
          window.removeEventListener('resize', this._productResizeHandler);
        }

        if (this._selectorClickHandler) {
          document.removeEventListener('click', this._selectorClickHandler);
        }

        // Modal-open/close listeners registered in init() when inModal is true.
        if (this._boundOpenModalProduct && this._modalEventNamespace) {
          document.removeEventListener('modalOpen.' + this._modalEventNamespace, this._boundOpenModalProduct);
        }
        if (this._boundCloseModalProduct && this._modalEventNamespace) {
          document.removeEventListener('modalClose.' + this._modalEventNamespace, this._boundCloseModalProduct);
        }

        // HeaderOpacityChanger instance from initHeaderOpacityChanger().
        if (this._headerOpacityChanger && typeof this._headerOpacityChanger.destroy === 'function') {
          this._headerOpacityChanger.destroy();
          this._headerOpacityChanger = null;
        }
      }
    });

    return Product;
  })();

  // RecentlyViewed — stores visited product handles in localStorage, then fetches
  // each product's card HTML via the Section Rendering API (?section_id=product-template-json).
  // Cards are cached in a static Map to avoid re-fetching on subsequent page loads.
  // The section file (sections/product-template-json.liquid) is an AJAX-only endpoint —
  // it is NOT in any template JSON. DO NOT DELETE that file.
  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSize = this.container.getAttribute('data-image-size')
      this.hasOverlay = this.container.getAttribute('data-use-image-overlay')

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== undefined) {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));

        Promise.all(promises).then(function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve({ handle: handle, html: theme.recentlyViewed.productInfo[handle] });
          } else {
            const root = window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root
              : '/';
            const url = `${root}products/${handle}?section_id=product-template-json`;

            fetch(url).then(function (response) {
              return response.text();
            }).then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var slide = doc.querySelector('.slide');
              resolve({ handle: handle, html: slide ? slide.outerHTML : null });
            }).catch(function () {
              resolve({ handle: handle, html: null });
            });
          }
        });
      },

      setupOutput: function (products) {
        var allSlides = [];
        var limit = this.container.getAttribute('data-recent-count');

        products.forEach(function (item) {
          if (!item || !item.html) {
            // Product was deleted — remove from localStorage
            if (item && item.handle) {
              delete theme.recentlyViewed.recent[item.handle];
            }
            return;
          }
          if (item.handle === this.handle) return;

          // Skip products with no title or no image (deleted/archived/draft)
          var tmp = new DOMParser().parseFromString(item.html, 'text/html');
          var title = tmp.querySelector('.grid-product__title');
          if (!title || !title.textContent.trim()) {
            delete theme.recentlyViewed.recent[item.handle];
            return;
          }

          allSlides.unshift(item.html);
        }.bind(this));

        // Persist cleaned-up list
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }

        if (allSlides.length === 0) {
          this.container.classList.add('hide');
          return;
        }

        var slideCount = Math.min(allSlides.length, limit);
        var productMarkup = allSlides.slice(0, limit).join('');
        var sliderMarkup = this.prepareSliderElement(productMarkup, slideCount);
        this.outputContainer.innerHTML = sliderMarkup;

        if (window.AOS) {
          AOS.refreshHard();
        }
      },

      prepareSliderElement: function (slides, slideCount) {
        var _classString = ""
        if (slideCount <= 4) _classString = "class='slider--not-trigger'"
        var markup = `
          <slider-component ${_classString}>
            <div class="position-relative">
              <div class="swiper slider">
                <div class="swiper-wrapper slider--wrapper">
                  ${slides}
                </div>
              </div>
              <div class="pagination-wrapper">
                <div class="swiper-pagination"></div>
              </div>
              <button type="button" class="btn--next--prev btn--prev" aria-label="Previous slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="15 6 9 12 15 18"/></svg>
              </button>
              <button type="button" class="btn--next--prev btn--next" aria-label="Next slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 6 15 12 9 18"/></svg>
              </button>
            </div>
          </slider-component>
        `;
        return markup
      },

      captureProductDetails: function (products) {
        products.forEach(function (item) {
          if (item && item.handle && item.html) {
            theme.recentlyViewed.productInfo[item.handle] = item.html;
          }
        });

        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem(theme.recentlyViewed.cacheKey, JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      onUnload: function () {
        init = false;
      }
    });

    return RecentlyViewed;
  })();

  // Drives the CONTENT of the mobile nav drawer: sub-nav level switching
  // (slide-nav tiers) and the language/currency panel. It does NOT open or
  // close the drawer itself — that is theme.Drawers('NavDrawer', 'nav').
  // The old open()/close() half was removed in the 2026-07-11 cleanup: its
  // trigger (.mobile-nav-trigger) existed in no template and its body called
  // two functions (theme.sizeDrawer, theme.headerNav.removeOverlayClass)
  // that are not defined anywhere — a landmine had the trigger ever returned.
  theme.MobileNav = (function () {
    var selectors = {
      wrapper: '.slide-nav__wrapper',
      nav: '.slide-nav',
      childList: '.slide-nav__dropdown',
      subNavToggleBtn: '.js-toggle-submenu',
      mainfixedheader: '.drawer__contents > .drawer__fixed-header',

      langNcurWrapper: '.lang-currency--switcher__wrapper',
      langNcurNav: '.lang-cur--nav'
    };

    var classes = {
      isActive: 'is-active',
      heightRemoved: 'is-removed-height'
    };

    var defaults = {
      menuLevel: 1
    };

    function MobileNav(args) {
      this.config = Object.assign({}, defaults, args);

      this.container = document.getElementById(this.config.id);
      if (!this.container) {
        return;
      }

      // BOTH gender menus render their own .slide-nav__wrapper (women's
      // always, men's once its menu has links — snippets/drawer-menu.liquid).
      // Everything below is per-wrapper: keying off only the FIRST wrapper
      // left the men's submenu buttons without click handlers.
      this.wrappers = this.container.querySelectorAll(selectors.wrapper);
      if (!this.wrappers.length) {
        return;
      }
      this.langNcurWrapper = this.container.querySelector(selectors.langNcurWrapper)
      this.mainfixedheader = this.container.querySelector(selectors.mainfixedheader);
      this.langNcurNav = this.langNcurWrapper.querySelector(selectors.langNcurNav);

      this.init();
    }

    MobileNav.prototype = Object.assign({}, MobileNav.prototype, {
      init: function () {
        // Toggle between menu levels — bind in EVERY gender wrapper, not
        // just the first (the men's menu is a second .slide-nav__wrapper)
        this.container.querySelectorAll(selectors.subNavToggleBtn).forEach(btn => {
          btn.addEventListener('click', this.toggleSubNav.bind(this));
        });

        this.langNcurNav.querySelectorAll('.lang-switcher--btn').forEach(btn => {
          btn.addEventListener('click', (event) => {
            this.toggleLangCurSwitcher(event);
            if (!this.mainfixedheader.classList.contains(classes.heightRemoved)) {
              this.mainfixedheader.classList.add(classes.heightRemoved);
            }
          });
        });

      },

      toggleLangCurSwitcher: function (evt) {
        if (evt) {
          evt.preventDefault();
        }

        const btn = evt.currentTarget;
        this.goToLangCur(btn.dataset.target);
      },

      goToLangCur: function (target) {
        var targetMenu = this.container.querySelector(`div[data-parent='${target}']`)
        if (targetMenu) {
          targetMenu.classList.add(classes.isActive);
        }
      },

      /*============================================================================
        Handle switching between nav levels
      ==============================================================================*/
      toggleSubNav: function (evt) {
        var btn = evt.currentTarget;
        var title = btn.dataset.title
        var titleEl = document.querySelector('.title__placeholder')
        var searchTriggerEl = document.querySelector('.slide-nav__search-field')
        if (title) {
          if (title.toLowerCase() == 'sale') {
            titleEl.classList.add('link--danger')
          } else {
            titleEl.classList.remove('link--danger')
          }
          titleEl.innerHTML = title
          searchTriggerEl.classList.add('disappear')
        } else {
          titleEl.innerHTML = ""
          titleEl.classList.remove('link--danger')
          searchTriggerEl.classList.remove('disappear')
        }
        // Scope the level switch to the gender menu the click came from
        this.goToSubnav(btn.dataset.target, btn.closest(selectors.wrapper));
      },

      // If a level is sent we are going up, so target list doesn't matter.
      // wrapperEl is the .slide-nav__wrapper the triggering button lives in;
      // falls back to the first wrapper so a stray call can't throw.
      goToSubnav: function (target, wrapperEl) {
        var wrapper = wrapperEl || this.wrappers[0];
        var nav = wrapper.querySelector(selectors.nav);

        // Activate new list if a target is passed
        var targetMenu = nav.querySelector(selectors.childList + '[data-parent="' + target + '"]')
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;

          // Hide all level 3 menus if going to level 2
          if (this.config.menuLevel == 2) {
            nav.querySelectorAll(selectors.childList + '[data-level="3"]').forEach(list => {
              list.classList.remove(classes.isActive);
              list.parentElement.classList.remove(classes.isActive);
            });
          }


          setTimeout(() => {
            targetMenu.classList.add(classes.isActive);
            targetMenu.parentElement.classList.add(classes.isActive);
            this.setWrapperHeight(wrapper, targetMenu.offsetHeight + 30);
          }, 150)

        } else {
          // Going to top level, reset
          this.config.menuLevel = 1;
          wrapper.removeAttribute('style');
          nav.querySelectorAll(selectors.childList).forEach(list => {
            list.classList.remove(classes.isActive);
            list.parentElement.classList.remove(classes.isActive);
          });
        }

        wrapper.dataset.level = this.config.menuLevel;
      },

      setWrapperHeight: function (wrapper, h) {
        wrapper.style.height = h + 'px';
      }
    });

    return MobileNav;
  })();


  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (window.AOS) { AOS.refreshHard() }

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  if (window.AOS) AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      // Guard against a corrupted entry left by extensions or older theme versions.
      // Without this, a single bad JSON breaks every subsequent line of theme.js.
      try {
        theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
      } catch (e) {
        theme.recentlyViewed.recent = {};
        window.localStorage.removeItem('theme-recent');
      }
    }
  }

  // Cached card HTML carries prices, and markets that share a currency have different prices (DE vs NL in
  // EUR) and later languages (H). The key is the country, currency and locale (Phase B3, design gate).
  theme.recentlyViewed.cacheKey = 'recent-products-' + [
    window.Shopify && window.Shopify.country,
    window.Shopify && window.Shopify.currency && window.Shopify.currency.active,
    window.Shopify && window.Shopify.locale
  ].join('-');
  theme.recentlyViewed.productInfo = {};
  if (theme.config.hasSessionStorage && sessionStorage[theme.recentlyViewed.cacheKey]) {
    try {
      theme.recentlyViewed.productInfo = JSON.parse(sessionStorage[theme.recentlyViewed.cacheKey]);
    } catch (e) {
      window.sessionStorage.removeItem(theme.recentlyViewed.cacheKey);
    }
  }

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    // The announcement bar's own controller (D1.1), placed immediately before 'header': theme.Sections builds the
    // instances of a type when it is registered, so the bar's slider is up before theme.headerNav.init() measures the bar.
    theme.sections.register('announcement-bar', theme.AnnouncementBarSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      // The cart page's controller (Phase D, spec D2.1) is built on main-cart's [data-cart-root], which exists on an
      // empty cart too (#CartPageForm does not), so a back-forward-cache restore or cart:build is answered either way.
      // No root (a page served with older Liquid): CartForm returns at once and the Remove links keep their href.
      new theme.CartForm(document.querySelector('[data-cart-root]'));
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();

class CollapsibleDescription extends HTMLElement {
  connectedCallback() {
    const showMoreToggle = this.querySelector('.show_more_toggle')
    const showLessToggle = this.querySelector('.show_less_toggle')
    // Scope to THIS component's own wrapper rather than the first one on the page.
    const wrapper = this.closest('.collection__description--wrapper')
    if (!wrapper) return;

    // AbortController tears down every listener in disconnectedCallback so a reconnect
    // (theme-editor section reload, DOM move) can't accumulate duplicate handlers.
    this._ac = new AbortController();
    const { signal } = this._ac;

    const updateToggleVisibility = () => {
      // Measure the WRAPPER — it owns the clipping (`max-height` + `overflow:hidden`).
      // The inner `.rte.collection__description` is not height-constrained, so it never
      // reports overflow; measuring the wrapper is what makes the toggle appear and stay
      // correct on resize. Set "Less" visibility BEFORE measuring — it renders in-flow and
      // only belongs to the expanded state, so measuring it while visible would inflate the
      // collapsed height and false-positive overflow at boundary lengths.
      const isOpen = wrapper.classList.contains('open');
      const active = document.activeElement;

      if (showLessToggle) showLessToggle.classList.toggle('hidden', !isOpen);
      const isOverflowing = wrapper.scrollHeight > wrapper.clientHeight;
      if (showMoreToggle) showMoreToggle.classList.toggle('hidden', !(isOverflowing && !isOpen));

      // Never strand keyboard focus on a toggle we just hid (the ResizeObserver firing
      // mid-collapse, or a resize that makes the text fit): hand focus to the still-visible
      // counterpart, else to the wrapper. preventScroll: the wrapper is overflow-hidden.
      if ((active === showLessToggle || active === showMoreToggle) && active.classList.contains('hidden')) {
        const other = active === showLessToggle ? showMoreToggle : showLessToggle;
        if (other && !other.classList.contains('hidden')) {
          other.focus({ preventScroll: true });
        } else {
          wrapper.setAttribute('tabindex', '-1');
          wrapper.focus({ preventScroll: true });
        }
      }
    }

    // Run cb after the wrapper's max-height transition. prefers-reduced-motion zeroes the
    // duration (transitionend may never fire), so run immediately then. Otherwise listen for
    // the max-height transitionend (target/propertyName-guarded so a descendant transition
    // can't consume it) with a timeout fallback; whichever wins clears the other.
    const afterMaxHeightTransition = (cb) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { cb(); return; }
      let done = false;
      let timer;
      const run = () => { if (done) return; done = true; clearTimeout(timer); wrapper.removeEventListener('transitionend', onEnd); cb(); };
      const onEnd = (e) => { if (e.target === wrapper && e.propertyName === 'max-height') run(); };
      wrapper.addEventListener('transitionend', onEnd, { signal });
      timer = setTimeout(run, 400);
    };

    updateToggleVisibility()

    if (showMoreToggle) {
      showMoreToggle.addEventListener('click', () => {
        // Reveal "Less" and move focus to it first (so focus never sits on the button we're
        // about to hide), then animate max-height from the clamped value to the full height.
        if (showLessToggle) { showLessToggle.classList.remove('hidden'); showLessToggle.focus({ preventScroll: true }); }
        showMoreToggle.classList.add('hidden');
        const fullHeight = wrapper.scrollHeight;

        requestAnimationFrame(() => {
          wrapper.style.maxHeight = fullHeight + 'px';
          wrapper.classList.add('open')
          afterMaxHeightTransition(() => {
            if (wrapper.classList.contains('open')) wrapper.style.maxHeight = 'none';
          })
        })
      }, { signal })
    }
    if (showLessToggle) {
      showLessToggle.addEventListener('click', () => {
        // Pin to the current height, then collapse on the next frame. updateToggleVisibility
        // (via the ResizeObserver during the collapse, and again once it settles) re-shows
        // "More" and hands focus off the now-hidden "Less".
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        wrapper.offsetHeight; // force reflow so the collapse transition runs
        wrapper.classList.remove('open')
        wrapper.style.maxHeight = '';
        afterMaxHeightTransition(updateToggleVisibility)
      }, { signal })
    }

    // Observe the wrapper (not document.body): fires on the reflows that matter and avoids
    // reruns from unrelated body-size changes.
    this._resizeObserver = new ResizeObserver(() => { updateToggleVisibility() })
    this._resizeObserver.observe(wrapper)
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    if (this._ac) this._ac.abort();
  }
}

customElements.define('collapsible-description', CollapsibleDescription)

document.addEventListener('DOMContentLoaded', function (e) {
  const availabilityEl = document.querySelector('input[name="filter.v.availability"][value="1"]')
  const unavailableityEl = document.querySelector('input[name="filter.v.availability"][value="0"]')
  const allItemsEl = document.querySelector('input[name="all_items"][value="1"]')
  const formEl = document.querySelector('.filter-form')

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  if (urlParams.has('all_items') && allItemsEl) {
    allItemsEl.setAttribute('checked', 'checked')
  }
})

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.stickyElement = null;
    this.mainTriggerEl = null;
    this.altTriggerEl = null;
    this.blockerEl = null;

    this.footerVisible = false;
    this._selectorOpen = false;

    this.triggerOffset = 0;
    this.currentScrollY = 0;
    this.ticking = false;
    this.stickyLoadedTimeout = null;

    this.handleBlockerIntersection = this.handleBlockerIntersection.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onSelectorOpen = this.onSelectorOpen.bind(this);
    this.onSelectorClose = this.onSelectorClose.bind(this);
  }

  connectedCallback() {
    this.stickyElement = this.querySelector('[data-sticky-element]');
    if (!this.stickyElement) {
      console.warn('Sticky element not found inside <sticky-add-to-cart>');
      return;
    }

    const mainTriggerSelector = this.dataset.mainTriggerSelector;
    const altTriggerSelector = this.dataset.altTriggerSelector;
    const blockerSelector = this.dataset.blockerSelector;

    if (!mainTriggerSelector || !blockerSelector) {
      console.warn('Missing data-main-trigger-selector or data-blocker-selector');
      return;
    }

    this.mainTriggerEl = document.querySelector(mainTriggerSelector);
    if (!this.mainTriggerEl) {
      console.warn('Main trigger element not found:', mainTriggerSelector);
      return;
    }

    if (altTriggerSelector) {
      this.altTriggerEl = document.querySelector(altTriggerSelector);
    }

    this.blockerEl = document.querySelector(blockerSelector);
    if (!this.blockerEl) {
      console.warn('Blocker element not found:', blockerSelector);
      return;
    }

    this.blockerObserver = new IntersectionObserver(
      this.handleBlockerIntersection,
      { threshold: 0 }
    );
    this.blockerObserver.observe(this.blockerEl);

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    document.addEventListener('selector:open', this.onSelectorOpen);
    document.addEventListener('selector:close', this.onSelectorClose);

    this.updateTriggerOffset();
    this.updateStickyState();
  }

  disconnectedCallback() {
    if (this.blockerObserver) this.blockerObserver.disconnect();

    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);

    document.removeEventListener('selector:open', this.onSelectorOpen);
    document.removeEventListener('selector:close', this.onSelectorClose);

    if (this.stickyLoadedTimeout) {
      clearTimeout(this.stickyLoadedTimeout);
      this.stickyLoadedTimeout = null;
    }
  }

  handleBlockerIntersection(entries) {
    entries.forEach(entry => {
      this.footerVisible = entry.isIntersecting;
      this.updateStickyState();
    });
  }

  updateTriggerOffset() {
    const mainDisabled = this.mainTriggerEl.disabled || this.mainTriggerEl.hasAttribute('disabled');

    if (mainDisabled && this.altTriggerEl) {
      this.triggerOffset = this.altTriggerEl.getBoundingClientRect().top + window.scrollY;
    } else {
      this.triggerOffset = this.mainTriggerEl.getBoundingClientRect().top + window.scrollY;
    }
  }

  updateStickyState() {
    if (this._selectorOpen) {
      this.removeStickyClasses();
      return;
    }

    if (this.currentScrollY > this.triggerOffset && !this.footerVisible) {
      if (!this.stickyElement.classList.contains('position--sticky')) {
        this.stickyElement.classList.add('position--sticky');
        // Add sticky--loaded after 500ms
        this.stickyLoadedTimeout = setTimeout(() => {
          this.stickyElement.classList.add('sticky--loaded');
        }, 0);
      }
    } else {
      this.removeStickyClasses();
    }
  }

  removeStickyClasses() {
    if (this.stickyLoadedTimeout) {
      clearTimeout(this.stickyLoadedTimeout);
      this.stickyLoadedTimeout = null;
    }
    this.stickyElement.classList.remove('position--sticky', 'sticky--loaded');
  }

  onScroll() {
    this.currentScrollY = window.scrollY;
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateStickyState();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  onResize() {
    this.updateTriggerOffset();
    this.updateStickyState();
  }

  onSelectorOpen() {
    this._selectorOpen = true;
    document.body.classList.add('lock-scroll');
    this.removeStickyClasses();
  }

  onSelectorClose() {
    this._selectorOpen = false;
    document.body.classList.remove('lock-scroll');
    this.updateStickyState();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);


class FeaturedCollectionTab extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab__btn')

    this._boundToggle = this.toggleTab.bind(this);
    this.tabs.forEach((item) => {
      item.addEventListener('click', this._boundToggle)
    })

    // ARIA tabs keyboard pattern — Arrow/Home/End/Enter/Space.
    this._boundKeydown = this._onKeydown.bind(this);
    this.addEventListener('keydown', this._boundKeydown)

    this.activeTab = this.querySelector('.tab-content[data-active="true"]')
  }

  disconnectedCallback() {
    if (this._boundToggle && this.tabs) {
      this.tabs.forEach((item) => item.removeEventListener('click', this._boundToggle))
    }
    if (this._boundKeydown) {
      this.removeEventListener('keydown', this._boundKeydown)
    }
  }

  toggleTab(e) {
    const target = e.currentTarget
    const id = target.dataset.tabId

    if (this.activeTab) this.activeTab.setAttribute('data-active', false)

    this.tabs.forEach(item => {
      const isActive = item.isSameNode(target)
      item.setAttribute('data-active-tab', isActive ? 'true' : 'false')
      // Keep ARIA + roving tabindex in sync with data-active-tab.
      item.setAttribute('aria-selected', isActive ? 'true' : 'false')
      item.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    const tabContent = this.querySelector(`[data-tab-for="${id}"]`)
    this.activeTab = tabContent
    if (tabContent) tabContent.setAttribute('data-active', true)
  }

  _onKeydown(e) {
    const currentTab = e.target.closest('.tab__btn')
    if (!currentTab) return
    const tabsArr = Array.from(this.tabs)
    const currentIndex = tabsArr.indexOf(currentTab)
    if (currentIndex < 0) return

    let nextIndex = -1
    switch (e.key) {
      case 'ArrowRight':
        e.preventDefault()
        nextIndex = (currentIndex + 1) % tabsArr.length
        break
      case 'ArrowLeft':
        e.preventDefault()
        nextIndex = (currentIndex - 1 + tabsArr.length) % tabsArr.length
        break
      case 'Home':
        e.preventDefault()
        nextIndex = 0
        break
      case 'End':
        e.preventDefault()
        nextIndex = tabsArr.length - 1
        break
      case 'Enter':
      case ' ':
        e.preventDefault()
        currentTab.click()
        return
      default:
        return
    }

    if (nextIndex >= 0) {
      tabsArr[nextIndex].focus()
      tabsArr[nextIndex].click()
    }
  }
}

customElements.define('featured-collection-tab', FeaturedCollectionTab)

class HeightObserver extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.container')

    if (this.dataset.container) {
      this.container = this.querySelector(this.dataset.container)
    }


  }



  connectedCallback() {
    this.addEventListener('slider:inited', (e) => {
      if (e.detail.isTab) this.adjustHeight(e.detail.height)
    })
  }

  adjustHeight(sliderHeight) {
    const button = this.querySelector('.shop-all__btn--wrapper')
    let buttonHeight = 0

    if (button) {
      const buttonStyles = window.getComputedStyle(button)
      const buttonMarginTop = parseFloat(buttonStyles.marginTop)
      const buttonMarginBottom = parseFloat(buttonStyles.marginBottom)
      buttonHeight = button.offsetHeight + buttonMarginTop + buttonMarginBottom
    }

    let height = sliderHeight + buttonHeight + 'px';

    this.container.style.setProperty('--content-height', height || 'auto');
  }
}

customElements.define('height-observer', HeightObserver);

class SliderComponent extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    // Browsing-gender gate for recommendation slides (data-gender-fit =
    // men|women|both, stamped by sections/product-recommendations.liquid).
    // This is the single choke point BOTH render paths flow through:
    // server-rendered (_related collections — theme.Recommendations
    // returns early for those) and AJAX-injected markup.
    //
    // FAIL-CLOSED ORDERING: this gate runs BEFORE the Swiper guard below.
    // If the vendor-script race trips `typeof Swiper === 'undefined'` and we
    // bail, the cross-gender slides must ALREADY be stripped — otherwise a
    // failed Swiper load would leave men-only slides visible to a women
    // browser (the exact leak this project forbids). The gate has zero
    // Swiper dependency and its empty-case `return` precedes any Swiper use,
    // so it is safe here.
    //
    // Skipped in the theme editor (Shopify.designMode): merchants must see
    // ALL slides while editing, consistent with gender-context.js.
    //
    // Reads the RESOLVED gender from body[data-gender], NOT the raw cookie. As of
    // 2026-08 the server sets data-gender from the PAGE's own gender (product tag /
    // collection handle; women fallback on neutral pages) directly in the <body>
    // HTML, so it is already correct here even though theme.js runs before
    // gender-context.js — and crucially it is AUTHORITATIVE: a men PDP filters recs
    // to men even if a stale cookie says women (the old cookie read filtered to the
    // WRONG gender and irreversibly removed the right slides). "none" (design mode /
    // no preference) → no filtering. Sliders without data-gender-fit slides (featured
    // collections, recently viewed — shows all genders) are untouched.
    if (!(window.Shopify && Shopify.designMode)) {
      const fitSlides = this.querySelectorAll('[data-gender-fit]');
      if (fitSlides.length) {
        const bg = document.body.dataset.gender;
        const browsingGender = (bg === 'men' || bg === 'women') ? bg : null;
        if (browsingGender) {
          fitSlides.forEach((slide) => {
            const fit = slide.dataset.genderFit;
            if (fit !== 'both' && fit !== browsingGender) slide.remove();
          });
        }
        // Gate emptied the slider → hide the whole recommendations section
        // (heading included) instead of initializing an empty Swiper.
        if (!this.querySelector('.slider--wrapper .slide')) {
          const section = this.closest('[data-section-type="product-recommendations"]') || this.closest('.index-section');
          if (section) section.classList.add('hide');
          return;
        }
      }
    }

    // Guard against Swiper not loaded yet (vendor script race condition under throttled networks)
    if (typeof Swiper === 'undefined') return;

    this.sliderContainer = this.querySelector('.slider')

    this.isTabSlider = false

    if (this.dataset.sliderType == "tab-slider") this.isTabSlider = true

    const slideElements = this.querySelectorAll('.slider--wrapper .slide')

    let slidesPerViewDesktop = 4
    let spaceBetweenDesktop = 5

    this.btnPrev = this.querySelector('.btn--prev')
    this.btnNext = this.querySelector('.btn--next')

    if (slideElements.length < 5) this.classList.add('swiper--button--hidden')

    if (slideElements.length <= 4) {
      slidesPerViewDesktop = 4
      spaceBetweenDesktop = 5
    };

    this.slider = new Swiper(this.sliderContainer, {
      // Slide behavior
      slidesPerView: 1.43,
      spaceBetween: 5,

      // Tuning — config-level only (no runtime overrides)
      speed: 650,
      threshold: 5,
      touchRatio: 0.85,
      resistance: true,
      resistanceRatio: 0.87,
      longSwipesRatio: 0.2,
      touchStartPreventDefault: false,
      preventInteractionOnTransition: false,
      watchOverflow: true,

      centeredSlides: true,
      centeredSlidesBounds: true,
      direction: 'horizontal',
      followFinger: true,
      grabCursor: true,
      cssMode: false,
      touchEventsTarget: 'container',
      touchMoveStopPropagation: true,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: this.btnNext,
        prevEl: this.btnPrev
      },
      breakpoints: {
        769: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop,
          speed: 350,
          slidesPerGroup: 1,
          centeredSlides: false,
          centeredSlidesBounds: false,
        }
      },
      on: {
        init: slider => {
          // Block native image drag-and-drop
          slider.el.addEventListener('dragstart', function (e) {
            e.preventDefault();
          });

          // Size arrow buttons to image area only
          const firstImageMask = slider.el.querySelector('.grid-product__image-mask');
          if (firstImageMask) {
            const imageHeight = firstImageMask.offsetHeight + 'px';
            const prevBtn = slider.el.parentElement.querySelector('.btn--prev');
            const nextBtn = slider.el.parentElement.querySelector('.btn--next');
            if (prevBtn) prevBtn.style.height = imageHeight;
            if (nextBtn) nextBtn.style.height = imageHeight;
          }

          const event = new CustomEvent('slider:inited', {
            bubbles: true,
            detail: {
              height: slider.height,
              isTab: this.isTabSlider
            }
          })
          this.dispatchEvent(event)
        },
        resize: slider => {
          const event = new CustomEvent('slider:inited', {
            bubbles: true,
            detail: {
              height: slider.height,
              isTab: this.isTabSlider
            }
          })
          this.dispatchEvent(event)
        }
      }
    });

    // Store the timer so disconnectedCallback can cancel a pending click
    // before the host element is removed from the DOM.
    this._initTimer = setTimeout(() => {
      if (this.btnPrev) this.btnPrev.click()
    }, 300)
  }

  disconnectedCallback() {
    // Section reload in the editor (and any DOM remove) must tear down the
    // Swiper instance + its delegated touch handlers + its ResizeObserver,
    // and cancel any pending init-click timer. Without this, every reload
    // leaves an orphaned Swiper attached to detached DOM nodes.
    if (this._initTimer) {
      clearTimeout(this._initTimer);
      this._initTimer = null;
    }
    if (this.slider && typeof this.slider.destroy === 'function') {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }
}

customElements.define('slider-component', SliderComponent)

class ScrollToList extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.links = this.querySelectorAll('a[href*="#"]')
    this.links.forEach(linkEl => {
      linkEl.addEventListener('click', this.goToDestination.bind(this))
    })
  }

  goToDestination(evt) {
    evt.preventDefault()
    const target = evt.currentTarget

    const id = target.getAttribute('href').replace('#', '')
    const destinationEl = document.getElementById(id)

    if (destinationEl) {
      // Respect prefers-reduced-motion — smooth scroll triggers vestibular issues
      // for affected users. matchMedia returns false on browsers that don't support
      // the query, defaulting to smooth (no regression).
      var prefersReduced = typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destinationEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start', inline: 'start' });
    }
  }
}

customElements.define('scroll-to-list', ScrollToList)

/*============================================================================
  Size ordering — shared utility
  Replaces the 21 KB CSS order approach (size-order.liquid) with DOM reorder.
  Handles alpha sizes (XS–XXXXXXXL), numbered sizes (EU 38, IT 48, 42),
  and merchant-configured custom sizes from theme settings.
==============================================================================*/

const ALPHA_SIZE_WEIGHTS = {
  OS: 0,
  XXXXXS: 1, XXXXS: 2, XXXS: 3, XXS: 4, XS: 5, S: 6,
  M: 7, L: 8, XL: 9, XXL: 10, XXXL: 11, XXXXL: 12,
  XXXXXL: 13, XXXXXXL: 14, XXXXXXXL: 15
}

let merchantSizeWeights = null

function loadMerchantSizeConfig() {
  if (merchantSizeWeights !== null) return
  merchantSizeWeights = {}
  const configEl = document.getElementById('size-order-config')
  if (!configEl) return
  try {
    const raw = JSON.parse(configEl.textContent)
    let counter = 1
    raw.split(/[,|]/).forEach(s => {
      const trimmed = s.trim()
      if (trimmed) {
        merchantSizeWeights[trimmed] = counter
        merchantSizeWeights[trimmed.toUpperCase()] = counter
        merchantSizeWeights[trimmed.toLowerCase()] = counter
        counter++
      }
    })
  } catch (e) { /* invalid config — fall through to alpha/numeric */ }
}

function getSizeWeight(sizeStr) {
  if (!sizeStr) return Infinity
  loadMerchantSizeConfig()

  // Merchant config takes priority (exact match, case-insensitive)
  const merchantWeight = merchantSizeWeights[sizeStr] ?? merchantSizeWeights[sizeStr.toUpperCase()]
  if (merchantWeight !== undefined) return merchantWeight

  // Alpha size lookup
  const alphaWeight = ALPHA_SIZE_WEIGHTS[sizeStr.toUpperCase()]
  if (alphaWeight !== undefined) return alphaWeight

  // Numeric extraction — "EU 38", "IT 48", "42", "6.5"
  const numMatch = sizeStr.match(/(\d+(?:\.\d+)?)/)
  if (numMatch) return 100 + parseFloat(numMatch[1])

  return Infinity
}

function sortSizeContainer(container, items, valueAttr, fallbackAttr) {
  if (!container || items.length < 2) return
  items.sort((a, b) => {
    const valA = a.getAttribute(valueAttr) || (fallbackAttr && a.getAttribute(fallbackAttr))
    const valB = b.getAttribute(valueAttr) || (fallbackAttr && b.getAttribute(fallbackAttr))
    return getSizeWeight(valA) - getSizeWeight(valB)
  })
  items.forEach(item => container.appendChild(item))
}

function sortProductPageSizes() {
  // Mobile: .option-input-wrap[data-handle="size"] .option-list
  // Prefer data-display-value (metafield override), fall back to data-value (raw supplier)
  document.querySelectorAll('.option-input-wrap[data-handle="size"] .option-list').forEach(list => {
    sortSizeContainer(list, [...list.querySelectorAll('.btn--option[data-value]')], 'data-display-value', 'data-value')
  })

  // Desktop: .variant-input-wrap[data-handle="size"] .option--list
  document.querySelectorAll('.variant-input-wrap[data-handle="size"] .option--list').forEach(list => {
    sortSizeContainer(list, [...list.querySelectorAll('.option--item[data-value]')], 'data-display-value', 'data-value')
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sortProductPageSizes)
} else {
  sortProductPageSizes()
}

// SizeFilter — Web Component wrapping the size filter option list.
// On connectedCallback, sorts size options into a logical order (XS→XL, EU 36→46)
// using the shared sortSizeContainer() utility.
class SizeFilter extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.#sortSizes()
  }

  #sortSizes() {
    const list = this.querySelector('ul')
    if (!list) return
    const items = [...list.querySelectorAll('li.tag[data-filter-value]')]
    sortSizeContainer(list, items, 'data-filter-value')
  }
}

customElements.define('size-filter', SizeFilter)

class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.submitButtons = document.querySelectorAll('[data-localization-submit]')
    this.submitButtons.forEach(btn => btn.addEventListener('click', this.handleSubmit.bind(this)))
    this.toggleButtons = document.querySelectorAll('button.localization-toggle--btn')
    this.toggleButtons.forEach(btn => btn.addEventListener('click', this.toggleLocal.bind(this)))
    this.langSwitcherBtns = document.querySelectorAll('.lang-switcher--btn')
    this.langSwitcherBtns.forEach(btn => btn.addEventListener('click', this.openLangSwitcher.bind(this)))
    this.form = this.querySelector('#localization_form-header')
    document.body.addEventListener('click', this.closeSwitcher.bind(this))
  }
  closeSwitcher(evt) {

    const disclosers = document.querySelectorAll('.localization--list__container')

    disclosers.forEach(el => {
      el.classList.remove('active')
    })
  }
  openLangSwitcher(evt) {
    evt.stopPropagation()
    const target = evt.currentTarget
    const targetId = target.dataset.target
    const disclosers = document.querySelectorAll('.localization--list__container')
    disclosers.forEach(el => {
      const parent = el.dataset.parent
      if (parent == targetId) {
        el.classList.add('active')
      }
      else {
        el.classList.remove('active')
      }
    })
  }
  toggleLocal(evt) {
    const target = evt.currentTarget
    const type = target.dataset.type
    const value = target.dataset.value
    const isSubmit = target.dataset.isSubmit
    const parent = target.parentNode.parentNode.parentNode
    if (type == 'language') {
      const input = this.form.querySelector('input[name="language_code"]')
      input.value = value
    }
    if (type == 'currency') {
      const input = this.form.querySelector('input[name="country_code"]')
      input.value = value
    }
    const btnList = parent.querySelectorAll('.localization-toggle--btn')
    btnList.forEach(btn => {
      if (btn.isSameNode(target)) {
        btn.setAttribute('aria-current', true)
      } else {
        btn.removeAttribute('aria-current')
      }
    })
    if (isSubmit == 'true') {
      this.submitForm(type, value)
    }
  }
  handleSubmit(evt) {
    evt.preventDefault()
    const target = evt.currentTarget
    const type = target.dataset.submit
    let value = ""

    if (type == 'currency') {
      value = this.form.querySelector('input[name="country_code"]').value
    }
    if (type == 'language') {
      value = this.form.querySelector('input[name="language_code"]').value
    }
    this.submitForm(type, value)
  }
  submitForm(type, value) {
    if (type == 'language') {
      Cookies.set('language_choosen', value, { path: '/', expires: 30 })
    }
    if (type == 'currency') {
      Cookies.set('currency_choosen', value, { path: '/', expires: 30 })
    }
    this.form.submit()
  }
}
customElements.define('localization-form', LocalizationForm)

const ua = navigator.userAgent;

// Detect iOS
const isIOS = /iP(ad|hone|od)/.test(ua);
if (isIOS) {
  document.body.classList.add('is-ios');
}

// Detect Safari (macOS or iOS) and exclude all other browsers
const isSafari = isIOS && navigator.vendor.includes('Apple')

if (isSafari) {
  document.body.classList.add('is-safari');
}